import _extends from '@babel/runtime/helpers/extends';
import _createForOfIteratorHelperLoose from '@babel/runtime/helpers/createForOfIteratorHelperLoose';

var rf = Object.create;
var hi = Object.defineProperty;
var nf = Object.getOwnPropertyDescriptor;
var tf = Object.getOwnPropertyNames;
var ff = Object.getPrototypeOf,
    uf = Object.prototype.hasOwnProperty;

var vi = function vi(t0, c0) {
  return function () {
    return c0 || t0((c0 = {
      exports: {}
    }).exports, c0), c0.exports;
  };
};

var kf = function kf(t0, c0, P, U2) {
  if (c0 && typeof c0 == "object" || typeof c0 == "function") {
    var _loop = function _loop() {
      var u0 = _step.value;
      !uf.call(t0, u0) && u0 !== P && hi(t0, u0, {
        get: function get() {
          return c0[u0];
        },
        enumerable: !(U2 = nf(c0, u0)) || U2.enumerable
      });
    };

    for (var _iterator = _createForOfIteratorHelperLoose(tf(c0)), _step; !(_step = _iterator()).done;) {
      _loop();
    }
  }

  return t0;
};

var of = function of(t0, c0, P) {
  return P = t0 != null ? rf(ff(t0)) : {}, kf(c0 || !t0 || !t0.__esModule ? hi(P, "default", {
    value: t0,
    enumerable: !0
  }) : P, t0);
};

var pi = vi(function (vf, wi) {
  wi.exports = {
    ALIGN_AUTO: 0,
    ALIGN_FLEX_START: 1,
    ALIGN_CENTER: 2,
    ALIGN_FLEX_END: 3,
    ALIGN_STRETCH: 4,
    ALIGN_BASELINE: 5,
    ALIGN_SPACE_BETWEEN: 6,
    ALIGN_SPACE_AROUND: 7,
    DIMENSION_WIDTH: 0,
    DIMENSION_HEIGHT: 1,
    DIRECTION_INHERIT: 0,
    DIRECTION_LTR: 1,
    DIRECTION_RTL: 2,
    DISPLAY_FLEX: 0,
    DISPLAY_NONE: 1,
    EDGE_LEFT: 0,
    EDGE_TOP: 1,
    EDGE_RIGHT: 2,
    EDGE_BOTTOM: 3,
    EDGE_START: 4,
    EDGE_END: 5,
    EDGE_HORIZONTAL: 6,
    EDGE_VERTICAL: 7,
    EDGE_ALL: 8,
    EXPERIMENTAL_FEATURE_WEB_FLEX_BASIS: 0,
    EXPERIMENTAL_FEATURE_ABSOLUTE_PERCENTAGE_AGAINST_PADDING_EDGE: 1,
    EXPERIMENTAL_FEATURE_FIX_ABSOLUTE_TRAILING_COLUMN_MARGIN: 2,
    FLEX_DIRECTION_COLUMN: 0,
    FLEX_DIRECTION_COLUMN_REVERSE: 1,
    FLEX_DIRECTION_ROW: 2,
    FLEX_DIRECTION_ROW_REVERSE: 3,
    GUTTER_COLUMN: 0,
    GUTTER_ROW: 1,
    GUTTER_ALL: 2,
    JUSTIFY_FLEX_START: 0,
    JUSTIFY_CENTER: 1,
    JUSTIFY_FLEX_END: 2,
    JUSTIFY_SPACE_BETWEEN: 3,
    JUSTIFY_SPACE_AROUND: 4,
    JUSTIFY_SPACE_EVENLY: 5,
    LOG_LEVEL_ERROR: 0,
    LOG_LEVEL_WARN: 1,
    LOG_LEVEL_INFO: 2,
    LOG_LEVEL_DEBUG: 3,
    LOG_LEVEL_VERBOSE: 4,
    LOG_LEVEL_FATAL: 5,
    MEASURE_MODE_UNDEFINED: 0,
    MEASURE_MODE_EXACTLY: 1,
    MEASURE_MODE_AT_MOST: 2,
    NODE_TYPE_DEFAULT: 0,
    NODE_TYPE_TEXT: 1,
    OVERFLOW_VISIBLE: 0,
    OVERFLOW_HIDDEN: 1,
    OVERFLOW_SCROLL: 2,
    POSITION_TYPE_STATIC: 0,
    POSITION_TYPE_RELATIVE: 1,
    POSITION_TYPE_ABSOLUTE: 2,
    PRINT_OPTIONS_LAYOUT: 1,
    PRINT_OPTIONS_STYLE: 2,
    PRINT_OPTIONS_CHILDREN: 4,
    UNIT_UNDEFINED: 0,
    UNIT_POINT: 1,
    UNIT_PERCENT: 2,
    UNIT_AUTO: 3,
    WRAP_NO_WRAP: 0,
    WRAP_WRAP: 1,
    WRAP_WRAP_REVERSE: 2
  };
});
var mi = vi(function (wf, Ni) {
  var M2 = pi();

  Ni.exports = function (t0) {
    function c0(u0, Z0, S0) {
      var k2 = u0[Z0];

      u0[Z0] = function () {
        for (var _len = arguments.length, O0 = new Array(_len), _key = 0; _key < _len; _key++) {
          O0[_key] = arguments[_key];
        }

        return S0.call.apply(S0, [this, k2].concat(O0));
      };
    }

    var _loop2 = function _loop2() {
      var _Z;

      var u0 = _arr[_i2];
      var Z0 = (_Z = {}, _Z[M2.UNIT_POINT] = t0.Node.prototype[u0], _Z[M2.UNIT_PERCENT] = t0.Node.prototype[u0 + "Percent"], _Z[M2.UNIT_AUTO] = t0.Node.prototype[u0 + "Auto"], _Z);
      c0(t0.Node.prototype, u0, function (S0) {
        var _Z0$o, _Z0$o2;

        for (var _len2 = arguments.length, k2 = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          k2[_key2 - 1] = arguments[_key2];
        }

        var O0 = k2.pop(),
            o2,
            H2;
        if (O0 === "auto") o2 = M2.UNIT_AUTO, H2 = void 0;else if (typeof O0 == "object") o2 = O0.unit, H2 = O0.valueOf();else if (o2 = typeof O0 == "string" && O0.endsWith("%") ? M2.UNIT_PERCENT : M2.UNIT_POINT, H2 = parseFloat(O0), !Number.isNaN(O0) && Number.isNaN(H2)) throw new Error("Invalid value " + O0 + " for " + u0);
        if (!Z0[o2]) throw new Error("Failed to execute \"" + u0 + "\": Unsupported unit '" + O0 + "'");
        return H2 !== void 0 ? (_Z0$o = Z0[o2]).call.apply(_Z0$o, [this].concat(k2, [H2])) : (_Z0$o2 = Z0[o2]).call.apply(_Z0$o2, [this].concat(k2));
      });
    };

    for (var _i2 = 0, _arr = ["setPosition", "setMargin", "setFlexBasis", "setWidth", "setHeight", "setMinWidth", "setMinHeight", "setMaxWidth", "setMaxHeight", "setPadding"]; _i2 < _arr.length; _i2++) {
      _loop2();
    }

    function P(u0) {
      return t0.MeasureCallback.implement({
        measure: function measure() {
          var _u = u0.apply(void 0, arguments),
              S0 = _u.width,
              k2 = _u.height;

          return {
            width: S0 != null ? S0 : NaN,
            height: k2 != null ? k2 : NaN
          };
        }
      });
    }

    c0(t0.Node.prototype, "setMeasureFunc", function (u0, Z0) {
      return Z0 ? u0.call(this, P(Z0)) : this.unsetMeasureFunc();
    });

    function U2(u0) {
      return t0.DirtiedCallback.implement({
        dirtied: u0
      });
    }

    return c0(t0.Node.prototype, "setDirtiedFunc", function (u0, Z0) {
      u0.call(this, U2(Z0));
    }), c0(t0.Config.prototype, "free", function () {
      t0.Config.destroy(this);
    }), c0(t0.Node, "create", function (u0, Z0) {
      return Z0 ? t0.Node.createWithConfig(Z0) : t0.Node.createDefault();
    }), c0(t0.Node.prototype, "free", function () {
      t0.Node.destroy(this);
    }), c0(t0.Node.prototype, "freeRecursive", function () {
      for (var u0 = 0, Z0 = this.getChildCount(); u0 < Z0; ++u0) {
        this.getChild(0).freeRecursive();
      }

      this.free();
    }), c0(t0.Node.prototype, "calculateLayout", function (u0, Z0, S0, k2) {
      if (Z0 === void 0) {
        Z0 = NaN;
      }

      if (S0 === void 0) {
        S0 = NaN;
      }

      if (k2 === void 0) {
        k2 = M2.DIRECTION_LTR;
      }

      return u0.call(this, Z0, S0, k2);
    }), _extends({
      Config: t0.Config,
      Node: t0.Node
    }, M2);
  };
});
var Ei = of(mi(), 1);

var Af = function () {
  var t0 = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
  return function (c0) {
    if (c0 === void 0) {
      c0 = {};
    }

    var P;
    P || (P = typeof c0 < "u" ? c0 : {});
    var U2, u0;
    P.ready = new Promise(function (s, a) {
      U2 = s, u0 = a;
    });
    var Z0 = Object.assign({}, P),
        S0 = "";
    typeof document < "u" && document.currentScript && (S0 = document.currentScript.src), t0 && (S0 = t0), S0.indexOf("blob:") !== 0 ? S0 = S0.substr(0, S0.replace(/[?#].*/, "").lastIndexOf("/") + 1) : S0 = "";
    var k2 = P.print || console.log.bind(console),
        O0 = P.printErr || console.warn.bind(console);
    Object.assign(P, Z0), Z0 = null;
    var o2;
    P.wasmBinary && (o2 = P.wasmBinary);
    P.noExitRuntime || !0;

    function Gi() {
      this.buffer = new ArrayBuffer(Ze / 65536 * 65536);
    }

    function Ri() {}

    function Zi(s) {
      this.exports = function (w) {
        function m(B0) {
          return B0.set = function (K, b0) {
            this[K] = b0;
          }, B0.get = function (K) {
            return this[K];
          }, B0;
        }

        for (var y, d = new Uint8Array(123), X = 25; X >= 0; --X) {
          d[48 + X] = 52 + X, d[65 + X] = X, d[97 + X] = 26 + X;
        }

        d[43] = 62, d[47] = 63;

        function g(B0, K, b0) {
          for (var Y0, V, W0 = 0, i = K, O = b0.length, ee = K + (O * 3 >> 2) - (b0[O - 2] == "=") - (b0[O - 1] == "="); W0 < O; W0 += 4) {
            Y0 = d[b0.charCodeAt(W0 + 1)], V = d[b0.charCodeAt(W0 + 2)], B0[i++] = d[b0.charCodeAt(W0)] << 2 | Y0 >> 4, i < ee && (B0[i++] = Y0 << 4 | V >> 2), i < ee && (B0[i++] = V << 6 | d[b0.charCodeAt(W0 + 3)]);
          }
        }

        function D(B0) {
          g(y, 1024, "T25seSBsZWFmIG5vZGVzIHdpdGggY3VzdG9tIG1lYXN1cmUgZnVuY3Rpb25zc2hvdWxkIG1hbnVhbGx5IG1hcmsgdGhlbXNlbHZlcyBhcyBkaXJ0eQBpc0RpcnR5AG1hcmtEaXJ0eQBkZXN0cm95AHNldERpc3BsYXkAZ2V0RGlzcGxheQBzZXRGbGV4AC0rICAgMFgweAAtMFgrMFggMFgtMHgrMHggMHgAc2V0RmxleEdyb3cAZ2V0RmxleEdyb3cAc2V0T3ZlcmZsb3cAZ2V0T3ZlcmZsb3cAY2FsY3VsYXRlTGF5b3V0AGdldENvbXB1dGVkTGF5b3V0AHVuc2lnbmVkIHNob3J0AGdldENoaWxkQ291bnQAdW5zaWduZWQgaW50AHNldEp1c3RpZnlDb250ZW50AGdldEp1c3RpZnlDb250ZW50AHNldEFsaWduQ29udGVudABnZXRBbGlnbkNvbnRlbnQAZ2V0UGFyZW50AGltcGxlbWVudABzZXRNYXhIZWlnaHRQZXJjZW50AHNldEhlaWdodFBlcmNlbnQAc2V0TWluSGVpZ2h0UGVyY2VudABzZXRGbGV4QmFzaXNQZXJjZW50AHNldFBvc2l0aW9uUGVyY2VudABzZXRNYXJnaW5QZXJjZW50AHNldE1heFdpZHRoUGVyY2VudABzZXRXaWR0aFBlcmNlbnQAc2V0TWluV2lkdGhQZXJjZW50AHNldFBhZGRpbmdQZXJjZW50AGNyZWF0ZURlZmF1bHQAdW5pdAByaWdodABoZWlnaHQAc2V0TWF4SGVpZ2h0AGdldE1heEhlaWdodABzZXRIZWlnaHQAZ2V0SGVpZ2h0AHNldE1pbkhlaWdodABnZXRNaW5IZWlnaHQAZ2V0Q29tcHV0ZWRIZWlnaHQAZ2V0Q29tcHV0ZWRSaWdodABsZWZ0AGdldENvbXB1dGVkTGVmdAByZXNldABfX2Rlc3RydWN0AGZsb2F0AHVpbnQ2NF90AHVzZVdlYkRlZmF1bHRzAHNldFVzZVdlYkRlZmF1bHRzAHNldEFsaWduSXRlbXMAZ2V0QWxpZ25JdGVtcwBzZXRGbGV4QmFzaXMAZ2V0RmxleEJhc2lzAENhbm5vdCBnZXQgbGF5b3V0IHByb3BlcnRpZXMgb2YgbXVsdGktZWRnZSBzaG9ydGhhbmRzAHVzZUxlZ2FjeVN0cmV0Y2hCZWhhdmlvdXIAc2V0VXNlTGVnYWN5U3RyZXRjaEJlaGF2aW91cgBzZXRQb2ludFNjYWxlRmFjdG9yAE1lYXN1cmVDYWxsYmFja1dyYXBwZXIARGlydGllZENhbGxiYWNrV3JhcHBlcgBDYW5ub3QgcmVzZXQgYSBub2RlIHN0aWxsIGF0dGFjaGVkIHRvIGEgb3duZXIAc2V0Qm9yZGVyAGdldEJvcmRlcgBnZXRDb21wdXRlZEJvcmRlcgB1bnNpZ25lZCBjaGFyAHRvcABnZXRDb21wdXRlZFRvcABzZXRGbGV4V3JhcABnZXRGbGV4V3JhcABzZXRHYXAAZ2V0R2FwACVwAHNldEhlaWdodEF1dG8Ac2V0TWFyZ2luQXV0bwBzZXRXaWR0aEF1dG8AU2NhbGUgZmFjdG9yIHNob3VsZCBub3QgYmUgbGVzcyB0aGFuIHplcm8Ac2V0QXNwZWN0UmF0aW8AZ2V0QXNwZWN0UmF0aW8Ac2V0UG9zaXRpb24AZ2V0UG9zaXRpb24Abm90aWZ5T25EZXN0cnVjdGlvbgBzZXRGbGV4RGlyZWN0aW9uAGdldEZsZXhEaXJlY3Rpb24Ac2V0TWFyZ2luAGdldE1hcmdpbgBnZXRDb21wdXRlZE1hcmdpbgBuYW4AYm90dG9tAGdldENvbXB1dGVkQm90dG9tAGJvb2wAZW1zY3JpcHRlbjo6dmFsAHNldEZsZXhTaHJpbmsAZ2V0RmxleFNocmluawBNZWFzdXJlQ2FsbGJhY2sARGlydGllZENhbGxiYWNrAHdpZHRoAHNldE1heFdpZHRoAGdldE1heFdpZHRoAHNldFdpZHRoAGdldFdpZHRoAHNldE1pbldpZHRoAGdldE1pbldpZHRoAGdldENvbXB1dGVkV2lkdGgAdW5zaWduZWQgbG9uZwBzdGQ6OndzdHJpbmcAc3RkOjpzdHJpbmcAc3RkOjp1MTZzdHJpbmcAc3RkOjp1MzJzdHJpbmcAc2V0UGFkZGluZwBnZXRQYWRkaW5nAGdldENvbXB1dGVkUGFkZGluZwBjcmVhdGVXaXRoQ29uZmlnAGluZgBzZXRBbGlnblNlbGYAZ2V0QWxpZ25TZWxmAFNpemUAdmFsdWUAVmFsdWUAY3JlYXRlAG1lYXN1cmUAc2V0UG9zaXRpb25UeXBlAGdldFBvc2l0aW9uVHlwZQBpc1JlZmVyZW5jZUJhc2VsaW5lAHNldElzUmVmZXJlbmNlQmFzZWxpbmUAY29weVN0eWxlAGRvdWJsZQBOb2RlAGV4dGVuZABpbnNlcnRDaGlsZABnZXRDaGlsZAByZW1vdmVDaGlsZAB2b2lkAGF2YWlsYWJsZUhlaWdodCBpcyBpbmRlZmluaXRlIHNvIGhlaWdodE1lYXN1cmVNb2RlIG11c3QgYmUgWUdNZWFzdXJlTW9kZVVuZGVmaW5lZABhdmFpbGFibGVXaWR0aCBpcyBpbmRlZmluaXRlIHNvIHdpZHRoTWVhc3VyZU1vZGUgbXVzdCBiZSBZR01lYXN1cmVNb2RlVW5kZWZpbmVkAHNldEV4cGVyaW1lbnRhbEZlYXR1cmVFbmFibGVkAGlzRXhwZXJpbWVudGFsRmVhdHVyZUVuYWJsZWQAZGlydGllZABDYW5ub3QgcmVzZXQgYSBub2RlIHdoaWNoIHN0aWxsIGhhcyBjaGlsZHJlbiBhdHRhY2hlZAB1bnNldE1lYXN1cmVGdW5jAHVuc2V0RGlydGllZEZ1bmMARXhwZWN0IGN1c3RvbSBiYXNlbGluZSBmdW5jdGlvbiB0byBub3QgcmV0dXJuIE5hTgBOQU4ASU5GAGVtc2NyaXB0ZW46Om1lbW9yeV92aWV3PHNob3J0PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzx1bnNpZ25lZCBzaG9ydD4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8aW50PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzx1bnNpZ25lZCBpbnQ+AGVtc2NyaXB0ZW46Om1lbW9yeV92aWV3PGZsb2F0PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzx1aW50OF90PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzxpbnQ4X3Q+AGVtc2NyaXB0ZW46Om1lbW9yeV92aWV3PHVpbnQxNl90PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzxpbnQxNl90PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzx1aW50MzJfdD4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8aW50MzJfdD4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8Y2hhcj4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8dW5zaWduZWQgY2hhcj4Ac3RkOjpiYXNpY19zdHJpbmc8dW5zaWduZWQgY2hhcj4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8c2lnbmVkIGNoYXI+AGVtc2NyaXB0ZW46Om1lbW9yeV92aWV3PGxvbmc+AGVtc2NyaXB0ZW46Om1lbW9yeV92aWV3PHVuc2lnbmVkIGxvbmc+AGVtc2NyaXB0ZW46Om1lbW9yeV92aWV3PGRvdWJsZT4AQ2hpbGQgYWxyZWFkeSBoYXMgYSBvd25lciwgaXQgbXVzdCBiZSByZW1vdmVkIGZpcnN0LgBDYW5ub3Qgc2V0IG1lYXN1cmUgZnVuY3Rpb246IE5vZGVzIHdpdGggbWVhc3VyZSBmdW5jdGlvbnMgY2Fubm90IGhhdmUgY2hpbGRyZW4uAENhbm5vdCBhZGQgY2hpbGQ6IE5vZGVzIHdpdGggbWVhc3VyZSBmdW5jdGlvbnMgY2Fubm90IGhhdmUgY2hpbGRyZW4uAChudWxsKQAlcwoAAAEAAAADAAAAAAAAAAIAAAADAAAAAQAAAAIAAAAAAAAAAQAAAAE="), g(y, 4210, "wH8AAAAAAADAfwMAAABpaQB2AHZp"), g(y, 4240, "6xoAAOkaAAApGwAAIxsAACkbAAAjGwAAaWlpZmlmaQAcGwAA7BoAAHZpaQDtGgAAMBsAAGlpaQ=="), g(y, 4304, "wgAAAMMAAADE"), g(y, 4324, "wgAAAMUAAADGAAAAHBs="), g(y, 4352, "6xoAACkbAAAjGwAAKRsAACMbAAAwGwAAKxsAADAbAABpaWlpAAAAABwbAAABGwAAHBsAAAMbAAAEGwAAMBs="), g(y, 4424, "xwAAAMgAAADJ"), g(y, 4444, "xwAAAMoAAADGAAAABxsAABwbAAAHGw=="), g(y, 4480, "HBsAAAcbAAAjGwAAHRsAAHZpaWlpAAAAHBsAAAcbAAApGwAAdmlpZgAAAAAcGwAABxsAAB0bAAB2aWlpAAAAAB0bAAAIGwAAIxsAAB0bAAAHGwAAaQBkaWkAdmlpZAAADBsAAAwbAAAHGwAAHBsAAAwbAAAcGwAADBsAAAsbAAAcGwAADBsAACMbAAAAAAAAHBsAAAwbAAAjGwAAKhsAAHZpaWlkAAAAHBsAAAwbAAAqGwAAIxsAAA0bAAAKGwAADRsAACMbAAAKGwAADRsAACobAAANGwAAKhsAAA0bAAAjGwAAZGlpaQAAAAApGwAADBsAACMbAABmaWlpAAAAABwbAAAMGwAADBsAACQbAAAcGwAADBsAAAwbAAAkGwAADRsAAAwbAAAMGwAADBsAAAwbAAAkGwAAHRsAAAwbAAAcGwAADBsAAB0bAAAcGwAADBsAAOkaAAAcGwAADBsAAAEbAAAdGwAADRsAAAAAAAAcGwAADBsAACobAAAqGwAAIxsAAHZpaWRkaQAACRsAAA0b"), g(y, 4896, "GQAKABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZABEKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk="), g(y, 4977, "DgAAAAAAAAAAGQAKDRkZGQANAAACAAkOAAAACQAOAAAO"), g(y, 5035, "DA=="), g(y, 5047, "EwAAAAATAAAAAAkMAAAAAAAMAAAM"), g(y, 5093, "EA=="), g(y, 5105, "DwAAAAQPAAAAAAkQAAAAAAAQAAAQ"), g(y, 5151, "Eg=="), g(y, 5163, "EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa"), g(y, 5218, "GgAAABoaGgAAAAAAAAk="), g(y, 5267, "FA=="), g(y, 5279, "FwAAAAAXAAAAAAkUAAAAAAAUAAAU"), g(y, 5325, "Fg=="), g(y, 5337, "FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVG"), g(y, 5412, "0A=="), g(y, 5452, "//////////8="), g(y, 5520, "YB8BAAAAAAAF"), g(y, 5540, "yw=="), g(y, 5564, "zAAAAM0AAABEGw=="), g(y, 5588, "Ag=="), g(y, 5604, "//////////8="), g(y, 5672, "BQ=="), g(y, 5684, "zg=="), g(y, 5708, "zAAAAM8AAABYGwAAAAQ="), g(y, 5732, "AQ=="), g(y, 5748, "/////wo="), g(y, 5816, "0Q==");
        }

        var S = new ArrayBuffer(16),
            Q = new Int32Array(S),
            J = new Float32Array(S),
            f0 = new Float64Array(S);

        function e0(B0) {
          return Q[B0];
        }

        function U(B0, K) {
          Q[B0] = K;
        }

        function H0() {
          return f0[0];
        }

        function D0(B0) {
          f0[0] = B0;
        }

        function A0() {
          throw new Error("abort");
        }

        function _0(B0) {
          J[2] = B0;
        }

        function j() {
          return J[2];
        }

        function Fe(B0) {
          var K = B0.a,
              b0 = K.a,
              Y0 = b0.buffer;
          b0.grow = ef;
          var V = new Int8Array(Y0),
              W0 = new Int16Array(Y0),
              i = new Int32Array(Y0),
              O = new Uint8Array(Y0),
              ee = new Uint16Array(Y0),
              u1 = new Uint32Array(Y0),
              c = new Float32Array(Y0),
              v0 = new Float64Array(Y0),
              w0 = Math.imul,
              f = Math.fround,
              m0 = Math.abs,
              i2 = Math.clz32,
              $i = Math.min,
              bi = Math.max,
              M = K.b,
              P0 = K.c,
              R2 = K.d,
              Z2 = K.e,
              re = K.f,
              ie = K.g,
              pe = K.h,
              Ce = K.i,
              ar = K.j,
              cr = K.k,
              hr = K.l,
              k1 = K.m,
              o1 = K.n,
              A1 = K.o,
              s1 = K.p,
              l1 = K.q,
              e4 = K.r,
              r4 = K.s,
              i4 = K.t,
              n4 = K.u,
              t4 = K.v,
              f4 = K.w,
              u4 = K.x,
              k4 = K.y,
              o4 = K.z,
              A4 = K.A,
              s4 = K.B,
              l4 = K.C,
              a4 = K.D,
              F = 73568,
              z0 = 0;

          function a1(e, r, n, t, u, k, o, A, l, p, R, I, G, Z) {
            var h = 0,
                v = f(0),
                N = f(0),
                E = 0,
                W = 0,
                T = 0,
                _ = f(0),
                L = f(0),
                C = f(0),
                H = 0,
                z = 0,
                x = 0,
                q = f(0),
                n0 = f(0),
                s0 = f(0),
                h0 = 0,
                p0 = f(0),
                N0 = 0,
                E0 = f(0),
                G0 = f(0),
                R0 = 0,
                g0 = 0,
                I0 = 0,
                F0 = 0,
                C0 = 0,
                M0 = f(0),
                x0 = 0,
                q0 = f(0),
                K0 = 0,
                f2 = 0,
                u2 = 0,
                w2 = 0,
                p2 = f(0),
                N2 = 0,
                m2 = 0,
                W2 = 0,
                g2 = 0,
                V2 = f(0),
                _2 = 0,
                L2 = 0,
                X2 = 0,
                F2 = f(0),
                C2 = f(0),
                oe = 0,
                ye = f(0),
                Ee = f(0),
                Ge = f(0),
                Re = 0,
                ze = 0,
                Qe = f(0),
                Ir = 0,
                Br = f(0),
                dr = f(0),
                Or = f(0),
                _r = f(0),
                Lr = 0,
                ki = 0,
                oi = 0,
                Ai = 0,
                si = 0,
                li = 0,
                ai = 0,
                ci = 0,
                V0 = 0,
                T0 = f(0),
                Ae = f(0);

            h = F - 384 | 0, F = h;

            e: {
              n: {
                i: {
                  if (!(u && r != r)) {
                    if (!(k && n != n)) {
                      if (E = (l ? 0 : 4) + R | 0, i[E >> 2] = i[E >> 2] + 1, E = i[e + 24 >> 2] & 3, Ir = (t | 0) <= 1 ? 1 : t, x0 = E || Ir, V[e + 300 | 0] = O[e + 300 | 0] & 252 | x0 & 3, E = e + 252 | 0, t = ((x0 | 0) != 1) << 3, _2 = (x0 | 0) == 2 ? 3 : 2, L = b(e, _2, o), c[E + t >> 2] = L, W = E, E = ((x0 | 0) == 1) << 3, n0 = k0(e, _2, o), c[W + E >> 2] = n0, q = b(e, 0, o), c[e + 256 >> 2] = q, _ = k0(e, 0, o), c[e + 264 >> 2] = _, T = e + 268 | 0, V0 = T + t | 0, T0 = i0(e, _2), c[V0 >> 2] = T0, V0 = E + T | 0, T0 = o0(e, _2), c[V0 >> 2] = T0, v = i0(e, 0), c[e + 272 >> 2] = v, C = o0(e, 0), c[e + 280 >> 2] = C, W = t, t = e + 284 | 0, V0 = W + t | 0, T0 = l0(e, _2, o), c[V0 >> 2] = T0, V0 = t + E | 0, T0 = a0(e, _2, o), c[V0 >> 2] = T0, N = l0(e, 0, o), c[e + 288 >> 2] = N, p0 = a0(e, 0, o), c[e + 296 >> 2] = p0, L = f(L + n0), n0 = f(q + _), t = i[e + 8 >> 2], t) {
                        q = f(f(f(c[e + 284 >> 2] + c[e + 292 >> 2]) + c[e + 268 >> 2]) + c[e + 276 >> 2]), n = f(k ? n - n0 : NaN), v = f(f(N + p0) + v), N = f(u ? r - L : NaN), r = N;

                        r: {
                          if (r != r) break r;

                          if (r = f(N - q), r != r) {
                            r = f(0);
                            break r;
                          }

                          r = $(r, f(0));
                        }

                        L = f(v + C), v = n;

                        r: {
                          if (n != n) break r;

                          if (v = f(n - L), v != v) {
                            v = f(0);
                            break r;
                          }

                          v = $(v, f(0));
                        }

                        if (!((u | 0) != 1 | (k | 0) != 1)) {
                          r = y0(e, 2, N, o), t = r != r, v = f(f(l0(e, 2, o) + i0(e, 2)) + f(a0(e, 2, o) + o0(e, 2)));

                          r: {
                            if (!(t | v != v)) {
                              r = $(r, v);
                              break r;
                            }

                            r = t ? v : r;
                          }

                          c[e + 516 >> 2] = r, r = y0(e, 0, n, A), t = r != r, n = f(f(l0(e, 0, o) + i0(e, 0)) + f(a0(e, 0, o) + o0(e, 0)));

                          r: {
                            if (!(t | n != n)) {
                              r = $(r, n);
                              break r;
                            }

                            r = t ? n : r;
                          }

                          c[e + 520 >> 2] = r;
                          break e;
                        }

                        r: {
                          if (O[e + 4 | 0] & 16) {
                            Y[t | 0](h + 24 | 0, e, r, u, v, k, 0);
                            break r;
                          }

                          Y[t | 0](h + 24 | 0, e, r, u, v, k);
                        }

                        i[R + 20 >> 2] = i[R + 20 >> 2] + 1, t = (Z << 2) + R | 0, i[t + 24 >> 2] = i[t + 24 >> 2] + 1, r = f(q + c[h + 24 >> 2]), r = y0(e, 2, u ? (u | 0) == 2 ? r : N : r, o), t = r != r, v = f(f(l0(e, 2, o) + i0(e, 2)) + f(a0(e, 2, o) + o0(e, 2)));

                        r: {
                          if (!(t | v != v)) {
                            r = $(r, v);
                            break r;
                          }

                          r = t ? v : r;
                        }

                        c[e + 516 >> 2] = r, r = f(L + c[h + 28 >> 2]), r = y0(e, 0, k ? (k | 0) == 2 ? r : n : r, A), t = r != r, n = f(f(l0(e, 0, o) + i0(e, 0)) + f(a0(e, 0, o) + o0(e, 0)));

                        r: {
                          if (!(t | n != n)) {
                            r = $(r, n);
                            break r;
                          }

                          r = t ? n : r;
                        }

                        c[e + 520 >> 2] = r;
                        break e;
                      }

                      if (t = i[e + 556 >> 2], Z = i[e + 560 >> 2], (t | 0) == (Z | 0)) {
                        n0 = f(n - n0), r = y0(e, 2, u & -3 ? f(r - L) : f(f(f(c[e + 284 >> 2] + c[e + 292 >> 2]) + c[e + 268 >> 2]) + c[e + 276 >> 2]), o), t = r != r, n = f(f(l0(e, 2, o) + i0(e, 2)) + f(a0(e, 2, o) + o0(e, 2)));

                        r: {
                          if (!(t | n != n)) {
                            r = $(r, n);
                            break r;
                          }

                          r = t ? n : r;
                        }

                        c[e + 516 >> 2] = r, r = y0(e, 0, k & -3 ? n0 : f(f(f(N + p0) + v) + C), A), t = r != r, n = f(f(l0(e, 0, o) + i0(e, 0)) + f(a0(e, 0, o) + o0(e, 0)));

                        r: {
                          if (!(t | n != n)) {
                            r = $(r, n);
                            break r;
                          }

                          r = t ? n : r;
                        }

                        c[e + 520 >> 2] = r;
                        break e;
                      }

                      r: {
                        if (l || (N = f(r - L), v = f(n - n0), !((u | 0) == 2 & N <= f(0) | !(!(v <= f(0)) | (k | 0) != 2) & v == v) & ((u | 0) != 1 | (k | 0) != 1))) break r;
                        r = y0(e, 2, N == N ? (u | 0) == 2 && N < f(0) ? f(0) : N : f(0), o), t = r != r, n = f(f(l0(e, 2, o) + i0(e, 2)) + f(a0(e, 2, o) + o0(e, 2)));

                        t: {
                          if (!(t | n != n)) {
                            r = $(r, n);
                            break t;
                          }

                          r = t ? n : r;
                        }

                        c[e + 516 >> 2] = r, r = y0(e, 0, v != v || (k | 0) == 2 && v < f(0) ? f(0) : v, A), t = r != r, n = f(f(l0(e, 0, o) + i0(e, 0)) + f(a0(e, 0, o) + o0(e, 0)));

                        t: {
                          if (!(t | n != n)) {
                            r = $(r, n);
                            break t;
                          }

                          r = t ? n : r;
                        }

                        c[e + 520 >> 2] = r;
                        break e;
                      }

                      for (I0 = Z - t | 0, w2 = I0 >> 2; E = i[t >> 2], i[E + 552 >> 2] != (e | 0) && (T = i[e + 568 >> 2], E = Z1(i[T >> 2], O[T + 8 | 0], E, e, z, 0), i[t >> 2] = E, i[E + 552 >> 2] = e), z = z + 1 | 0, t = t + 4 | 0, (Z | 0) != (t | 0);) {
                      }

                      V[e + 300 | 0] = O[e + 300 | 0] & 251, z = 3, oe = i[e + 24 >> 2], t = oe >>> 2 & 3;

                      r: {
                        t: {
                          f: {
                            if ((x0 | 0) == 2) {
                              Z = 0;

                              u: switch (t - 2 | 0) {
                                case 0:
                                  break r;

                                case 1:
                                  break u;

                                default:
                                  break f;
                              }

                              z = 2;
                              break r;
                            }

                            if (z = 2, Z = 0, t >>> 0 > 1) break t;
                          }

                          Z = z;
                        }

                        z = t;
                      }

                      Br = f(r - L), p2 = f(f(l0(e, z, o) + i0(e, z)) + f(a0(e, z, o) + o0(e, z))), p0 = f(l0(e, Z, o) + i0(e, Z)), q0 = f(p0 + f(a0(e, Z, o) + o0(e, Z))), K0 = z >>> 0 > 1, _ = w1(e, 0, Br, K0 ? p2 : q0, o), dr = f(n - n0), E0 = w1(e, 1, dr, K0 ? q0 : p2, A), G0 = K0 ? E0 : _, n0 = K0 ? _ : E0, N2 = i[e + 560 >> 2], E = i[e + 556 >> 2], N0 = K0 ? u : k;

                      r: {
                        if ((N0 | 0) != 1) break r;
                        if ((E | 0) == (N2 | 0)) break i;

                        for (t = 0, T = E;;) {
                          W = t, t = i[T >> 2];

                          t: {
                            if (!I1(t)) {
                              t = W;
                              break t;
                            }

                            if (H = 0, W || (W = i[t + 552 >> 2], !W)) break r;

                            f: {
                              u: {
                                n = c[t + 32 >> 2];

                                k: {
                                  if (n != n && (v = f(0), n = c[t + 28 >> 2], !(n > f(0)))) break k;
                                  if (v = n, n != n) break u;
                                }

                                if (f(m0(v)) < f(9999999747378752e-20)) break r;
                                if (W) break u;
                                n = f(0);
                                break f;
                              }

                              if (n = c[t + 36 >> 2], n != n) {
                                if (V[t + 4 | 0] < 0) {
                                  n = f(1);
                                  break f;
                                }

                                if (n = f(0), r = c[t + 28 >> 2], !(r < f(0))) break f;
                                n = f(-r);
                              }

                              if (n != n) break t;
                            }

                            if (f(m0(n)) < f(9999999747378752e-20)) break r;
                          }

                          if (H = t, T = T + 4 | 0, (N2 | 0) == (T | 0)) break;
                        }
                      }

                      if ((E | 0) == (N2 | 0)) break i;

                      for (F0 = (x0 | 0) <= 1 ? 1 : x0, W2 = _ != _, m2 = W2 | (u | 0) != 1, g2 = E0 == E0, L2 = _ == _, v = f(0);;) {
                        x = i[E >> 2], v1(x), T = i[x + 24 >> 2];

                        r: {
                          if (T & 4194304) {
                            if (m1(x, 0), t = O[x + 4 | 0], T = t | 1, V[x + 4 | 0] = T, !(t & 4)) break r;
                            V[x + 4 | 0] = T & 251;
                            break r;
                          }

                          if (l && (t = T & 3, W1(x, t || F0, n0, G0, _), T = i[x + 24 >> 2]), (T & 196608) == 131072) break r;

                          t: {
                            if ((H | 0) == (x | 0)) {
                              i[H + 308 >> 2] = 0, i[H + 304 >> 2] = G, n = f(0);
                              break t;
                            }

                            X2 = i[e + 24 >> 2], W = X2 >>> 2 & 3;

                            f: {
                              u: {
                                if ((x0 | 0) != 2) break u;
                                t = 3;

                                k: switch (W - 2 | 0) {
                                  case 0:
                                    break f;

                                  case 1:
                                    break k;

                                  default:
                                    break u;
                                }

                                t = 2;
                                break f;
                              }

                              t = W;
                            }

                            f2 = t >>> 0 > 1, N = f2 ? _ : E0, n = f(0), r = c[x + 40 >> 2];

                            f: {
                              u: {
                                W = i[x + 40 >> 2];

                                k: {
                                  if ((W | 0) == 2139156720) break k;
                                  if ((W | 0) == 2140081935) break u;
                                  h0 = 4216;

                                  o: {
                                    if ((W | 0) != 2141891242) {
                                      if (r == r) break o;
                                      h0 = 4208;
                                    }

                                    n = c[h0 >> 2];

                                    A: {
                                      l: switch (W = i[h0 + 4 >> 2], W | 0) {
                                        case 0:
                                        case 3:
                                          break l;

                                        default:
                                          break A;
                                      }

                                      if (r = f(NaN), !(c[x + 28 >> 2] > f(0))) break f;
                                      h0 = V[x + 4 | 0] < 0, C0 = h0 ? 2143289344 : 0, W = h0 ? 3 : 1, n = (U(2, C0), j());
                                    }

                                    switch (r = f(NaN), W - 1 | 0) {
                                      case 0:
                                        break u;

                                      case 1:
                                        break k;

                                      default:
                                        break f;
                                    }
                                  }

                                  if (n = (U(2, (W & -1073741825) + 536870912 | 0), j()), !(W & 1073741824)) break u;
                                }

                                r = f(f(N * n) * f(.009999999776482582));
                                break f;
                              }

                              r = n;
                            }

                            n = c[x + 572 >> 2], W = 0;

                            f: {
                              u: switch (g0 = i[x + 576 >> 2], g0 | 0) {
                                case 0:
                                case 3:
                                  break f;

                                default:
                                  break u;
                              }

                              if (L = c[x + 572 >> 2], !((g0 | 0) != 1 | L != L)) {
                                if (n < f(0)) break f;
                                W = 1;
                                break f;
                              }

                              if (W = 1, (g0 | 0) != 2 | L != L || (W = 0, n < f(0))) break f;
                              W = L2;
                            }

                            L = c[x + 580 >> 2], h0 = 0;

                            f: {
                              u: switch (R0 = i[x + 584 >> 2], R0 | 0) {
                                case 0:
                                case 3:
                                  break f;

                                default:
                                  break u;
                              }

                              if (C = c[x + 580 >> 2], !((R0 | 0) != 1 | C != C)) {
                                if (L < f(0)) break f;
                                h0 = 1;
                                break f;
                              }

                              if (h0 = 1, (R0 | 0) != 2 | C != C || (h0 = 0, L < f(0))) break f;
                              h0 = g2;
                            }

                            f: {
                              u: {
                                if (!(r != r | N != N)) {
                                  if (n = c[x + 308 >> 2], (!O[i[x + 568 >> 2] + 20 | 0] | i[x + 304 >> 2] == (G | 0)) & n == n) break f;
                                  if (n = f(f(l0(x, t, _) + i0(x, t)) + f(a0(x, t, _) + o0(x, t))), !(n <= r) & r < n) break u;
                                  n = r;
                                  break u;
                                }

                                if (W & f2) {
                                  N = f(f(l0(x, 2, _) + i0(x, 2)) + f(a0(x, 2, _) + o0(x, 2))), r = f(NaN);

                                  k: switch (g0 - 1 | 0) {
                                    case 1:
                                      n = f(f(_ * n) * f(.009999999776482582));

                                    case 0:
                                      if (r = n, N <= r) break u;
                                      break;

                                    default:
                                      break k;
                                  }

                                  if (!(r == r | N == N)) {
                                    n = r;
                                    break u;
                                  }

                                  if (r < N) {
                                    n = N;
                                    break u;
                                  }

                                  n = r != r ? N : r;
                                  break u;
                                }

                                if (!(f2 | h0 ^ 1)) {
                                  r = f(f(l0(x, 0, _) + i0(x, 0)) + f(a0(x, 0, _) + o0(x, 0))), n = f(NaN);

                                  k: switch (R0 - 1 | 0) {
                                    case 1:
                                      L = f(f(E0 * L) * f(.009999999776482582));

                                    case 0:
                                      if (n = L, r <= n) break u;
                                      break;

                                    default:
                                      break k;
                                  }

                                  if (n != n & r != r) break u;

                                  if (r > n) {
                                    n = r;
                                    break u;
                                  }

                                  n = n != n ? r : n;
                                  break u;
                                }

                                if (i[h + 360 >> 2] = 2143289344, i[h + 24 >> 2] = 2143289344, C0 = 0, i[h + 356 >> 2] = 0, i[h + 352 >> 2] = 0, C = f(b(x, 2, _) + k0(x, 2, _)), q = b(x, 0, _), s0 = k0(x, 0, _), N = f(NaN), u2 = 0, r = f(NaN), W) {
                                  k: {
                                    o: switch (g0 - 1 | 0) {
                                      case 0:
                                        r = n;
                                        break k;

                                      case 1:
                                        break o;

                                      default:
                                        break k;
                                    }

                                    r = f(f(_ * n) * f(.009999999776482582));
                                  }

                                  i[h + 356 >> 2] = 1, r = f(C + r), c[h + 24 >> 2] = r, u2 = 1;
                                }

                                if (q = f(q + s0), h0) {
                                  n = f(NaN);

                                  k: {
                                    o: switch (R0 - 1 | 0) {
                                      case 0:
                                        n = L;
                                        break k;

                                      case 1:
                                        break o;

                                      default:
                                        break k;
                                    }

                                    n = f(f(E0 * L) * f(.009999999776482582));
                                  }

                                  i[h + 352 >> 2] = 1, N = f(q + n), c[h + 360 >> 2] = N, C0 = 1;
                                }

                                g0 = t >>> 0 < 2, R0 = X2 & 3145728;

                                k: {
                                  o: {
                                    A: {
                                      if (!(!f2 & (R0 | 0) == 2097152)) {
                                        if (W2 | (R0 | 0) == 2097152) break o;
                                        if (r != r) break A;
                                        break o;
                                      }

                                      if (W2 | r == r) break k;
                                    }

                                    u2 = 2, i[h + 356 >> 2] = 2, c[h + 24 >> 2] = _, r = _;
                                  }

                                  o: {
                                    if (!(!g0 & (R0 | 0) == 2097152)) {
                                      if ((R0 | 0) == 2097152 | E0 != E0) break k;
                                      if (N != N) break o;
                                      break k;
                                    }

                                    if (N == N | E0 != E0) break k;
                                  }

                                  C0 = 2, i[h + 352 >> 2] = 2, c[h + 360 >> 2] = E0, N = E0;
                                }

                                n = c[x + 224 >> 2], R0 = n != n;

                                k: {
                                  if (R0) break k;

                                  o: {
                                    if (!(f2 | (u2 | 0) != 1)) {
                                      i[h + 352 >> 2] = 1, c[h + 360 >> 2] = q + f(f(r - C) / n);
                                      break o;
                                    }

                                    if (g0 | (C0 | 0) != 1) break k;
                                    i[h + 356 >> 2] = 1, c[h + 24 >> 2] = f(f(N - q) * n) + C;
                                  }

                                  C0 = 1, u2 = 1;
                                }

                                T = T >>> 13 & 7, T = T || X2 >>> 10 & 7;

                                k: {
                                  if ((T | 0) == 5 | (u2 | 0) == 1 | (f2 | (W | m2)) | (T | 0) != 4 || (i[h + 356 >> 2] = 1, c[h + 24 >> 2] = _, R0)) break k;
                                  C0 = 1, i[h + 352 >> 2] = 1, c[h + 360 >> 2] = f(_ - C) / n;
                                }

                                k: {
                                  if (g0 | (k | 0) != 1 | E0 != E0 | h0 | (T | 0) != 4 | (C0 | 0) == 1 || (i[h + 352 >> 2] = 1, c[h + 360 >> 2] = E0, R0)) break k;
                                  i[h + 356 >> 2] = 1, c[h + 24 >> 2] = f(E0 - q) * n;
                                }

                                if (ne(x, 2, _, _, h + 356 | 0, h + 24 | 0), ne(x, 0, E0, _, h + 352 | 0, h + 360 | 0), z2(x, c[h + 24 >> 2], c[h + 360 >> 2], x0, i[h + 356 >> 2], i[h + 352 >> 2], _, E0, 0, 5, p, R, I, G), r = c[(x + (i[(t << 2) + 4192 >> 2] << 2) | 0) + 516 >> 2], T = r != r, n = f(f(l0(x, t, _) + i0(x, t)) + f(a0(x, t, _) + o0(x, t))), !(T | n != n)) {
                                  n = $(r, n);
                                  break u;
                                }

                                n = T ? n : r;
                              }

                              c[x + 308 >> 2] = n;
                            }

                            i[x + 304 >> 2] = G;
                          }

                          v = f(v + f(n + f(b(x, z, _) + k0(x, z, _))));
                        }

                        if (E = E + 4 | 0, (N2 | 0) == (E | 0)) break;
                      }

                      break n;
                    }

                    i[h >> 2] = 2963, n2(e, h), r2(), A0();
                  }

                  i[h + 16 >> 2] = 3045, n2(e, h + 16 | 0), r2(), A0();
                }

                v = f(0);
              }

              r = f(v + f(0)), ye = K0 ? A : o, F2 = K0 ? o : A, I0 >>> 0 >= 5 && (r = f(f(Me(e, z, G0) * f(w2 - 1 >>> 0)) + r)), t = r > n0, N2 = oe & 786432, g2 = (N0 | 0) == 2 && N2 && t ? 1 : N0, x = K0 ? k : u, W2 = (x | 0) == 1, ki = W2 & (l ^ 1), K0 = z >>> 0 < 2, oi = x & -3, X2 = e + 208 | 0, k = Z << 2, R0 = k + 4160 | 0, Ai = W2 & !N2, si = (x | 0) != 1 | l, E = z << 2, f2 = E + 4160 | 0, L2 = E + 4192 | 0, u2 = G0 == G0, li = u2 << 1, g0 = k + 4192 | 0, ai = !N0 | !t, oe = h + 52 | 0, Or = Me(e, Z, G0), T = 0, t = 0, C0 = 0;

              n: {
                for (;;) {
                  h0 = t, j0(h + 24 | 0, 0, 44), t = i[e + 560 >> 2], k = i[e + 556 >> 2];

                  i: {
                    if ((t | 0) == (k | 0)) break i;
                    if (t = t - k | 0, (t | 0) < 0) break n;
                    if (E = me(h + 360 | 0, t >> 2, 0, oe), t = i[h + 44 >> 2], k = i[h + 48 >> 2] - t | 0, k = d2(i[h + 364 >> 2] - k | 0, t, k), t = i[h + 44 >> 2], i[h + 364 >> 2] = t, i[h + 44 >> 2] = k, W = i[h + 368 >> 2], H = i[h + 372 >> 2], k = i[h + 48 >> 2], i[h + 368 >> 2] = k, N0 = i[h + 52 >> 2], i[h + 48 >> 2] = W, i[h + 52 >> 2] = H, i[h + 372 >> 2] = N0, i[E >> 2] = t, (t | 0) != (k | 0) && (i[h + 368 >> 2] = k + ((t - k | 0) + 3 & -4)), !t) break i;
                    L0(t);
                  }

                  H = i[e + 24 >> 2], k = H >>> 2 & 3;

                  i: {
                    r: {
                      if (t = H & 3, ((t || Ir) | 0) != 2) break r;
                      t = 3;

                      t: switch (k - 2 | 0) {
                        case 0:
                          break i;

                        case 1:
                          break t;

                        default:
                          break r;
                      }

                      t = 2;
                      break i;
                    }

                    t = k;
                  }

                  v = Me(e, t, _), E = T, W = i[e + 560 >> 2], k = i[e + 556 >> 2];

                  i: {
                    if (E >>> 0 >= W - k >> 2 >>> 0) break i;

                    for (N0 = H & 786432, n = f(0);;) {
                      if (W - k >> 2 >>> 0 <= E >>> 0) break n;

                      if (H = i[(E << 2) + k >> 2], I0 = i[H + 24 >> 2], !(I0 & 4194304 | (I0 & 196608) == 131072)) {
                        if (i[H + 548 >> 2] = h0, r = b(H, t, _), N = k0(H, t, _), k = i[h + 24 >> 2], L = (E | 0) == (T | 0) ? f(0) : v, r = f(r + N), N = c[H + 308 >> 2], C = y0(H, t, N, F2), !(!k || !(f(L + f(r + f(n + C))) > n0) | !N0)) break i;

                        if (i[h + 24 >> 2] = k + 1, L = f(L + f(r + C)), c[h + 28 >> 2] = L + c[h + 28 >> 2], I1(H)) {
                          r: {
                            if (i[H + 552 >> 2]) {
                              if (r = c[H + 32 >> 2], r != r && (r = c[H + 28 >> 2], r = r > f(0) ? r : f(0)), c[h + 32 >> 2] = r + c[h + 32 >> 2], r = c[H + 36 >> 2], r == r) break r;

                              if (V[H + 4 | 0] < 0) {
                                r = f(1);
                                break r;
                              }

                              if (r = f(0), C = c[H + 28 >> 2], !(C < f(0))) break r;
                              r = f(-C);
                              break r;
                            }

                            r = f(0), c[h + 32 >> 2] = c[h + 32 >> 2] + f(0);
                          }

                          c[h + 36 >> 2] = c[h + 36 >> 2] - f(r * N);
                        }

                        k = i[h + 48 >> 2];

                        r: {
                          if ((k | 0) != i[h + 52 >> 2]) {
                            i[k >> 2] = H, i[h + 48 >> 2] = k + 4;
                            break r;
                          }

                          if (k = k - i[h + 44 >> 2] | 0, I0 = k >> 2, W = I0 + 1 | 0, W >>> 0 >= 1073741824) break n;
                          if (F0 = k >>> 1 | 0, I0 = me(h + 360 | 0, k >>> 0 >= 2147483644 ? 1073741823 : W >>> 0 < F0 >>> 0 ? F0 : W, I0, oe), i[i[h + 368 >> 2] >> 2] = H, i[h + 368 >> 2] = i[h + 368 >> 2] + 4, k = i[h + 44 >> 2], W = i[h + 48 >> 2] - k | 0, W = d2(i[h + 364 >> 2] - W | 0, k, W), k = i[h + 44 >> 2], i[h + 364 >> 2] = k, i[h + 44 >> 2] = W, H = i[h + 368 >> 2], F0 = i[h + 372 >> 2], W = i[h + 48 >> 2], i[h + 368 >> 2] = W, m2 = i[h + 52 >> 2], i[h + 48 >> 2] = H, i[h + 52 >> 2] = F0, i[h + 372 >> 2] = m2, i[I0 >> 2] = k, (k | 0) != (W | 0) && (i[h + 368 >> 2] = W + ((k - W | 0) + 3 & -4)), !k) break r;
                          L0(k);
                        }

                        k = i[e + 556 >> 2], W = i[e + 560 >> 2], n = f(n + L);
                      }

                      if (E = E + 1 | 0, !(E >>> 0 < W - k >> 2 >>> 0)) break;
                    }
                  }

                  s0 = c[h + 32 >> 2], !(s0 > f(0)) | !(s0 < f(1)) || (i[h + 32 >> 2] = 1065353216, s0 = f(1)), M0 = c[h + 36 >> 2], !(M0 > f(0)) | !(M0 < f(1)) || (i[h + 36 >> 2] = 1065353216, M0 = f(1)), i[h + 40 >> 2] = E, q = c[h + 28 >> 2], N0 = i[h + 24 >> 2], C0 && L0(C0), L = c[h + 56 >> 2], I0 = i[h + 48 >> 2], C0 = i[h + 44 >> 2];

                  i: {
                    r: {
                      t: {
                        f: {
                          if ((g2 | 0) == 1) break f;
                          n = f(0), r = c[X2 >> 2];

                          u: {
                            k: {
                              t = i[X2 >> 2];

                              o: {
                                if ((t | 0) == 2139156720) break o;
                                if ((t | 0) == 2140081935) break k;
                                k = 4216;

                                A: {
                                  if ((t | 0) != 2141891242) {
                                    if (r == r) break A;
                                    k = 4208;
                                  }

                                  switch (n = c[k >> 2], r = f(NaN), i[k + 4 >> 2] - 1 | 0) {
                                    case 0:
                                      break k;

                                    case 1:
                                      break o;

                                    default:
                                      break u;
                                  }
                                }

                                if (n = (U(2, (t & -1073741825) + 536870912 | 0), j()), !(t & 1073741824)) break k;
                              }

                              r = f(f(n * o) * f(.009999999776482582));
                              break u;
                            }

                            r = n;
                          }

                          n = f(0), v = c[e + 216 >> 2];

                          u: {
                            k: {
                              t = i[e + 216 >> 2];

                              o: {
                                if ((t | 0) == 2139156720) break o;
                                if ((t | 0) == 2140081935) break k;
                                k = 4216;

                                A: {
                                  if ((t | 0) != 2141891242) {
                                    if (v == v) break A;
                                    k = 4208;
                                  }

                                  switch (n = c[k >> 2], v = f(NaN), i[k + 4 >> 2] - 1 | 0) {
                                    case 0:
                                      break k;

                                    case 1:
                                      break o;

                                    default:
                                      break u;
                                  }
                                }

                                if (n = (U(2, (t & -1073741825) + 536870912 | 0), j()), !(t & 1073741824)) break k;
                              }

                              v = f(f(n * o) * f(.009999999776482582));
                              break u;
                            }

                            v = n;
                          }

                          n = f(0), N = c[e + 212 >> 2];

                          u: {
                            k: {
                              t = i[e + 212 >> 2];

                              o: {
                                if ((t | 0) == 2139156720) break o;
                                if ((t | 0) == 2140081935) break k;
                                k = 4216;

                                A: {
                                  if ((t | 0) != 2141891242) {
                                    if (N == N) break A;
                                    k = 4208;
                                  }

                                  switch (n = c[k >> 2], C = f(NaN), i[k + 4 >> 2] - 1 | 0) {
                                    case 0:
                                      break k;

                                    case 1:
                                      break o;

                                    default:
                                      break u;
                                  }
                                }

                                if (n = (U(2, (t & -1073741825) + 536870912 | 0), j()), !(t & 1073741824)) break k;
                              }

                              C = f(f(n * A) * f(.009999999776482582));
                              break u;
                            }

                            C = n;
                          }

                          n = f(0), N = c[e + 220 >> 2];

                          u: {
                            k: {
                              t = i[e + 220 >> 2];

                              o: {
                                if ((t | 0) == 2139156720) break o;
                                if ((t | 0) == 2140081935) break k;
                                k = 4216;

                                A: {
                                  if ((t | 0) != 2141891242) {
                                    if (N == N) break A;
                                    k = 4208;
                                  }

                                  switch (n = c[k >> 2], N = f(NaN), i[k + 4 >> 2] - 1 | 0) {
                                    case 0:
                                      break k;

                                    case 1:
                                      break o;

                                    default:
                                      break u;
                                  }
                                }

                                if (n = (U(2, (t & -1073741825) + 536870912 | 0), j()), !(t & 1073741824)) break k;
                              }

                              N = f(f(n * A) * f(.009999999776482582));
                              break u;
                            }

                            N = n;
                          }

                          if (t = z >>> 0 > 1, n = f((t ? r : C) - p2), n == n & n > q || (n = f((t ? v : N) - p2), n == n & n < q)) break t;
                          if (O[i[e + 568 >> 2] + 11 | 0]) break f;
                          if (n = q, !i[e + 552 >> 2] | s0 == f(0)) break r;
                          r = c[e + 32 >> 2];

                          u: {
                            k: {
                              if (r == r) {
                                n = r;
                                break k;
                              }

                              if (n = c[e + 28 >> 2], !(n > f(0))) break u;
                            }

                            if (n != n) {
                              n = n0;
                              break r;
                            }

                            r = c[e + 32 >> 2];
                          }

                          if (r != r && (n = q, r = c[e + 28 >> 2], !(r > f(0))) || (n = n0, r != f(0))) break r;
                          n = q;
                          break r;
                        }

                        n = n0;
                      }

                      if (n != n) break r;
                      L = f(n - q);
                      break i;
                    }

                    if (!(q < f(0))) break i;
                    L = f(-q);
                  }

                  if (n0 = n, !ki) {
                    i: {
                      if ((C0 | 0) == (I0 | 0)) {
                        C = f(0);
                        break i;
                      }

                      for (N = f(0), k = C0;;) {
                        t = i[k >> 2], q = c[t + 308 >> 2], n = y0(t, z, q, F2);

                        r: {
                          if (L < f(0)) {
                            H = i[t + 552 >> 2];

                            t: {
                              if (!H) {
                                v = f(0);
                                break t;
                              }

                              if (v = c[t + 36 >> 2], v == v) break t;

                              if (V[t + 4 | 0] < 0) {
                                v = f(1);
                                break t;
                              }

                              if (v = f(0), r = c[t + 28 >> 2], !(r < f(0))) break t;
                              v = f(-r);
                            }

                            if (r = f(n * f(-v)), !(r > f(0) | r < f(0))) break r;
                            v = f(f(f(L / M0) * r) + n), r = y0(t, z, v, n0), W = r != r, C = f(f(l0(t, z, _) + i0(t, z)) + f(a0(t, z, _) + o0(t, z)));

                            t: {
                              if (!(W | C != C)) {
                                r = $(r, C);
                                break t;
                              }

                              r = W ? C : r;
                            }

                            if (v != v | r != r | r == v) break r;
                            r = f(r - n);

                            t: {
                              if (!H) {
                                n = f(0);
                                break t;
                              }

                              if (n = c[t + 36 >> 2], n == n) break t;

                              if (V[t + 4 | 0] < 0) {
                                n = f(1);
                                break t;
                              }

                              if (n = f(0), v = c[t + 28 >> 2], !(v < f(0))) break t;
                              n = f(-v);
                            }

                            N = f(N + r), M0 = f(f(n * q) + M0);
                            break r;
                          }

                          if (!(L > f(0)) | !i[t + 552 >> 2] || (v = c[t + 32 >> 2], v != v && (v = c[t + 28 >> 2], !(v > f(0)))) || !(v < f(0) | v > f(0))) break r;
                          C = f(f(f(L / s0) * v) + n), r = y0(t, z, C, n0), W = r != r, q = f(f(l0(t, z, _) + i0(t, z)) + f(a0(t, z, _) + o0(t, z)));

                          t: {
                            if (!(W | q != q)) {
                              r = $(r, q);
                              break t;
                            }

                            r = W ? q : r;
                          }

                          if (C != C | r != r | r == C) break r;
                          s0 = f(s0 - v), N = f(N + f(r - n));
                        }

                        if (k = k + 4 | 0, (I0 | 0) == (k | 0)) break;
                      }

                      for (q = f(L - N), Ee = f(q / M0), Ge = f(q / s0), F0 = W2 & (!(O[e + 26 | 0] & 12) | ai), ze = !F0, m2 = i[g0 >> 2], C = f(0), W = C0;;) {
                        k = i[W >> 2], n = y0(k, z, c[k + 308 >> 2], F2);

                        r: {
                          t: {
                            if (q < f(0)) {
                              f: {
                                if (!i[k + 552 >> 2]) {
                                  r = f(0);
                                  break f;
                                }

                                if (r = c[k + 36 >> 2], r == r) break f;

                                if (V[k + 4 | 0] < 0) {
                                  r = f(1);
                                  break f;
                                }

                                if (r = f(0), v = c[k + 28 >> 2], !(v < f(0))) break f;
                                r = f(-v);
                              }

                              if (v = n, r = f(n * f(-r)), r == f(0)) break r;
                              r = M0 == f(0) ? f(n + r) : f(f(Ee * r) + n);
                              break t;
                            }

                            if (v = n, !(q > f(0)) | !i[k + 552 >> 2] || (r = c[k + 32 >> 2], r != r && (r = c[k + 28 >> 2], !(r > f(0)))) || !(r < f(0) | r > f(0))) break r;
                            r = f(f(Ge * r) + n);
                          }

                          if (r = y0(k, z, r, n0), t = r != r, v = f(f(l0(k, z, _) + i0(k, z)) + f(a0(k, z, _) + o0(k, z))), !(t | v != v)) {
                            v = $(r, v);
                            break r;
                          }

                          v = t ? v : r;
                        }

                        r = b(k, z, _), N = k0(k, z, _), s0 = b(k, Z, _), Qe = k0(k, Z, _), N = f(r + N), _r = f(v + N), c[h + 352 >> 2] = _r, i[h + 344 >> 2] = 1, s0 = f(s0 + Qe), r = c[k + 224 >> 2];

                        r: {
                          if (r == r) {
                            i[h + 348 >> 2] = 1, N = f(_r - N), c[h + 356 >> 2] = s0 + f(K0 ? N * r : N / r), H = k + (m2 << 3) | 0, N = c[H + 572 >> 2], t = i[H + 576 >> 2], r = c[H + 572 >> 2];
                            break r;
                          }

                          H = k + (m2 << 3) | 0, r = c[H + 572 >> 2];

                          t: {
                            f: {
                              u: {
                                k: {
                                  o: {
                                    A: {
                                      l: {
                                        h: {
                                          a: {
                                            if (!u2) {
                                              N = c[H + 572 >> 2], t = i[H + 576 >> 2];
                                              break a;
                                            }

                                            N = c[H + 572 >> 2];

                                            s: {
                                              v: {
                                                w: {
                                                  c: switch (t = i[H + 576 >> 2], t | 0) {
                                                    case 0:
                                                    case 3:
                                                      break w;

                                                    default:
                                                      break c;
                                                  }

                                                  if (!((t | 0) != 1 | r != r)) {
                                                    if (!(F0 & N < f(0))) break s;
                                                    break v;
                                                  }

                                                  if (!(ze | (!(N < f(0)) | ((t | 0) != 2 | r != r)))) break v;
                                                  break s;
                                                }

                                                if (!F0) break s;
                                              }

                                              if (H = i[k + 24 >> 2] >>> 13 & 7, H || (H = i[e + 24 >> 2] >>> 10 & 7), (H | 0) != 4 || (j2(h + 24 | 0, k, Z), i[h + 28 >> 2] == 3)) break s;
                                              if (Q2(h + 360 | 0, k, Z), i[h + 364 >> 2] != 3) break h;
                                            }

                                            r = N;
                                          }

                                          switch (t | 0) {
                                            case 0:
                                            case 3:
                                              break A;

                                            default:
                                              break l;
                                          }
                                        }

                                        i[h + 348 >> 2] = 1;
                                        break f;
                                      }

                                      if (!((t | 0) != 1 | r != r)) {
                                        if (r = N, r < f(0)) break A;
                                        break u;
                                      }

                                      if ((t | 0) != 2 | r != r) break o;
                                      if (G0 != G0) break A;
                                      if (!(N < f(0))) break k;
                                    }

                                    i[h + 348 >> 2] = li;
                                    break f;
                                  }

                                  r = f(NaN);

                                  o: switch (t - 1 | 0) {
                                    case 1:
                                      break k;

                                    case 0:
                                      break o;

                                    default:
                                      break u;
                                  }

                                  r = N;
                                  break u;
                                }

                                r = f(f(G0 * N) * f(.009999999776482582));
                              }

                              r = f(s0 + r), c[h + 356 >> 2] = r, i[h + 348 >> 2] = (W2 | (t | 0) != 2) & r == r;
                              break t;
                            }

                            c[h + 356 >> 2] = G0;
                          }

                          r = N;
                        }

                        ne(k, z, n0, _, h + 344 | 0, h + 352 | 0), ne(k, Z, G0, _, h + 348 | 0, h + 356 | 0);

                        r: {
                          t: {
                            f: {
                              u: switch (t | 0) {
                                case 0:
                                case 3:
                                  break f;

                                default:
                                  break u;
                              }

                              if (!((t | 0) != 1 | r != r)) {
                                if (N < f(0)) break f;
                                break t;
                              }

                              if ((t | 0) != 2 | r != r) break t;
                              if (N < f(0)) break f;
                              if (H = 0, u2) break r;
                            }

                            if (H = 0, t = i[k + 24 >> 2] >>> 13 & 7, t || (t = i[e + 24 >> 2] >>> 10 & 7), (t | 0) != 4 || (j2(h + 24 | 0, k, Z), i[h + 28 >> 2] == 3)) break r;
                            Q2(h + 360 | 0, k, Z), H = i[h + 364 >> 2] != 3;
                            break r;
                          }

                          H = 0;
                        }

                        r = c[h + 352 >> 2], N = c[h + 356 >> 2], t = z >>> 0 > 1, s0 = t ? r : N, r = t ? N : r, Re = i[h + 344 >> 2], Lr = i[h + 348 >> 2], ci = t ? Re : Lr, Re = t ? Lr : Re, t = (H ^ 1) & l, z2(k, s0, r, O[e + 300 | 0] & 3, ci, Re, _, E0, t, t ? 4 : 7, p, R, I, G), C = f(C + f(v - n)), t = O[e + 300 | 0];

                        r: {
                          t: {
                            if (t & 4) {
                              H = t & 251;
                              break t;
                            }

                            if (H = t & 251, t = 0, !(O[k + 300 | 0] & 4)) break r;
                          }

                          t = 4;
                        }

                        if (V[e + 300 | 0] = t | H, W = W + 4 | 0, (I0 | 0) == (W | 0)) break;
                      }
                    }

                    L = f(L - C);
                  }

                  t = O[e + 300 | 0], V[e + 300 | 0] = t & 251 | (L < f(0) ? 4 : t & 4), N = f(l0(e, z, o) + i0(e, z)), Ee = f(a0(e, z, o) + o0(e, z)), q = Me(e, z, o);

                  i: {
                    if (!(!(L > f(0)) | (g2 | 0) != 2)) {
                      C = f(0), n = f(0);

                      r: {
                        t: {
                          t = X2 + (i[L2 >> 2] << 2) | 0, r = c[t >> 2], t = i[t >> 2], k = (t | 0) == 2139156720;

                          f: {
                            if (!k) {
                              if (W = (t | 0) == 2140081935, W) break t;
                              if (H = (t | 0) == 2141891242, H | r != r) break i;
                              if (W) break t;
                              if (H) break i;
                              if (n = (U(2, (t & -1073741825) + 536870912 | 0), j()), !(t & 1073741824)) break f;
                            }

                            n = f(f(F2 * n) * f(.009999999776482582));
                          }

                          if (n != n) break i;
                          n = f(0);

                          f: {
                            if (k) break f;
                            if ((t | 0) == 2140081935) break t;
                            k = 4216;

                            u: {
                              if ((t | 0) != 2141891242) {
                                if (r == r) break u;
                                k = 4208;
                              }

                              switch (n = c[k >> 2], v = f(NaN), i[k + 4 >> 2] - 1 | 0) {
                                case 0:
                                  break t;

                                case 1:
                                  break f;

                                default:
                                  break r;
                              }
                            }

                            if (n = (U(2, (t & -1073741825) + 536870912 | 0), j()), !(t & 1073741824)) break t;
                          }

                          v = f(f(F2 * n) * f(.009999999776482582));
                          break r;
                        }

                        v = n;
                      }

                      if (r = f(f(f(v - N) - Ee) - f(n0 - L)), r != r) break i;
                      C = $(r, f(0));
                      break i;
                    }

                    C = L;
                  }

                  H = E >>> 0 <= T >>> 0;

                  i: {
                    if (!H) {
                      for (I0 = i[e + 556 >> 2], t = i[e + 560 >> 2] - I0 >> 2, F0 = t >>> 0 < T >>> 0 ? T : t, W = 0, t = T;;) {
                        if ((t | 0) == (F0 | 0)) break n;
                        if (k = i[I0 + (t << 2) >> 2], (i[k + 24 >> 2] & 196608) != 131072 && (m2 = h + 24 | 0, j2(m2, k, z), ze = i[h + 28 >> 2], Q2(m2, k, z), W = (((ze | 0) == 3) + W | 0) + (i[h + 28 >> 2] == 3) | 0), t = t + 1 | 0, (E | 0) == (t | 0)) break;
                      }

                      if (s0 = f(0), n = q, W) break i;
                    }

                    s0 = f(0), W = 0, n = q;

                    r: switch ((i[e + 24 >> 2] >>> 4 & 7) - 1 | 0) {
                      case 0:
                        s0 = f(C * f(.5));
                        break i;

                      case 1:
                        s0 = C;
                        break i;

                      case 2:
                        if (N0 >>> 0 < 2) break i;
                        n = f(q + f((T0 = f(0), Ae = $(C, f(0)), V0 = C != C, (V0 ? T0 : Ae) / f(N0 - 1 >>> 0))));
                        break i;

                      case 4:
                        s0 = f(C / f(N0 + 1 >>> 0)), n = f(q + s0);
                        break i;

                      case 3:
                        break r;

                      default:
                        break i;
                    }

                    s0 = f(f(C * f(.5)) / f(N0 >>> 0)), n = f(f(s0 + s0) + q);
                  }

                  if (r = f(N + s0), L = f(0), N0 = d1(e), H) n = f(0);else {
                    for (I0 = E - 1 | 0, Ge = f(C / f(W | 0)), N = f(0), v = f(0), t = T;;) {
                      if (k = i[e + 556 >> 2], i[e + 560 >> 2] - k >> 2 >>> 0 <= t >>> 0) break n;
                      k = i[k + (t << 2) >> 2], W = k + 228 | 0, Q0(h + 24 | 0, W, 320), n = f(n - ((t | 0) == (I0 | 0) ? q : f(0))), F0 = i[k + 24 >> 2];

                      i: {
                        if (F0 & 4194304) break i;

                        r: {
                          if ((F0 & 196608) == 131072) {
                            if (!e2(k, z)) break r;
                            if (!l) break i;
                            C = O2(k, z, n0), M0 = i0(e, z), Qe = b(k, z, _), c[W + (i[f2 >> 2] << 2) >> 2] = Qe + f(C + M0);
                            break i;
                          }

                          if (j2(h + 360 | 0, k, z), r = f(r + (i[h + 364 >> 2] == 3 ? Ge : f(-0))), l && (F0 = W, W = i[f2 >> 2] << 2, c[F0 + W >> 2] = r + c[W + (h + 24 | 0) >> 2]), Q2(h + 360 | 0, k, z), r = f(r + (i[h + 364 >> 2] == 3 ? Ge : f(-0))), !si) {
                            r = f(r + f(f(n + f(b(k, z, _) + k0(k, z, _))) + c[h + 104 >> 2])), L = G0;
                            break i;
                          }

                          if (W = k + 516 | 0, r = f(r + f(n + f(c[W + (i[L2 >> 2] << 2) >> 2] + f(b(k, z, _) + k0(k, z, _))))), N0) {
                            C = Ue(k), M0 = b(k, 0, _), C = f(C + M0), M0 = f(f(c[k + 520 >> 2] + f(b(k, 0, _) + k0(k, 0, _))) - C), k = N != N;

                            t: {
                              if (!(k | C != C)) {
                                N = $(N, C);
                                break t;
                              }

                              N = k ? C : N;
                            }

                            if (k = v != v, !(k | M0 != M0)) {
                              v = $(v, M0);
                              break i;
                            }

                            v = k ? M0 : v;
                            break i;
                          }

                          if (C = f(c[W + (i[g0 >> 2] << 2) >> 2] + f(b(k, Z, _) + k0(k, Z, _))), k = L != L, !(C != C | k)) {
                            L = $(L, C);
                            break i;
                          }

                          L = k ? C : L;
                          break i;
                        }

                        if (!l) break i;
                        k = i[f2 >> 2] << 2, C = c[k + (h + 24 | 0) >> 2], V0 = k + W | 0, T0 = f(s0 + f(C + i0(e, z))), c[V0 >> 2] = T0;
                      }

                      if (t = t + 1 | 0, (E | 0) == (t | 0)) break;
                    }

                    n = f(v + N);
                  }

                  if (N = N0 ? n : L, C = G0, !oi) {
                    n = y0(e, Z, f(q0 + N), ye), t = n != n, v = f(f(l0(e, Z, o) + i0(e, Z)) + f(a0(e, Z, o) + o0(e, Z)));

                    i: {
                      if (!(t | v != v)) {
                        n = $(n, v);
                        break i;
                      }

                      n = t ? v : n;
                    }

                    C = f(n - q0);
                  }

                  n = y0(e, Z, f(q0 + (Ai ? G0 : N)), ye), t = n != n, v = f(f(l0(e, Z, o) + i0(e, Z)) + f(a0(e, Z, o) + o0(e, Z)));

                  i: {
                    if (!(t | v != v)) {
                      n = $(n, v);
                      break i;
                    }

                    n = t ? v : n;
                  }

                  if (v = f(n - q0), !(H | !l)) for (;;) {
                    if (t = i[e + 556 >> 2], i[e + 560 >> 2] - t >> 2 >>> 0 <= T >>> 0) break n;
                    t = i[t + (T << 2) >> 2], k = i[t + 24 >> 2];

                    i: {
                      if (k & 4194304) break i;

                      if ((k & 196608) == 131072) {
                        if (k = i[R0 >> 2], e2(t, Z) && (n = f(f(O2(t, Z, G0) + i0(e, Z)) + b(t, Z, _)), c[(t + (k << 2) | 0) + 228 >> 2] = n, n == n)) break i;
                        V0 = t + (k << 2) | 0, T0 = f(i0(e, Z) + b(t, Z, _)), c[V0 + 228 >> 2] = T0;
                        break i;
                      }

                      k = k >>> 13 & 7, k || (k = i[e + 24 >> 2] >>> 10 & 7);

                      r: {
                        t: {
                          f: {
                            if ((k | 0) == 5) {
                              k = i[e + 24 >> 2] & 8 ? 5 : 1;
                              break f;
                            }

                            if ((k | 0) != 4 || (j2(h + 24 | 0, t, Z), k = 4, i[h + 28 >> 2] == 3)) break f;
                            if (Q2(h + 360 | 0, t, Z), W = i[g0 >> 2], i[h + 364 >> 2] == 3) break t;
                            W = t + (W << 3) | 0, N = c[W + 572 >> 2];

                            u: {
                              k: switch (k = i[W + 576 >> 2], k | 0) {
                                case 0:
                                case 3:
                                  break u;

                                default:
                                  break k;
                              }

                              if (L = c[W + 572 >> 2], !((k | 0) != 1 | L != L)) {
                                if (n = p0, N < f(0)) break u;
                                break r;
                              }

                              if (n = p0, u2 & !(N < f(0)) | ((k | 0) != 2 | L != L)) break r;
                            }

                            N = c[(t + (i[L2 >> 2] << 2) | 0) + 516 >> 2], n = c[t + 224 >> 2], n == n ? n = f(f(b(t, Z, _) + k0(t, Z, _)) + f(K0 ? N * n : N / n)) : n = v, c[h + 360 >> 2] = n, V0 = h, T0 = f(N + f(b(t, z, _) + k0(t, z, _))), c[V0 + 24 >> 2] = T0, i[h + 356 >> 2] = 1, i[h + 352 >> 2] = 1, ne(t, z, n0, _, h + 356 | 0, h + 24 | 0), ne(t, Z, G0, _, h + 352 | 0, h + 360 | 0), N = c[h + 360 >> 2], L = c[h + 24 >> 2], k = z >>> 0 > 1, n = k ? N : L, N = k ? L : N, k = (N2 | 0) != 0 & (i[e + 24 >> 2] & 896) != 512, z2(t, N, n, x0, !(k & K0 | N != N), (K0 | !k) & n == n, _, E0, 1, 2, p, R, I, G), n = p0;
                            break r;
                          }

                          W = i[g0 >> 2];
                        }

                        n = c[((W << 2) + t | 0) + 516 >> 2], N = b(t, Z, _), L = k0(t, Z, _), j2(h + 24 | 0, t, Z), N = f(C - f(n + f(N + L)));

                        t: {
                          if (i[h + 28 >> 2] != 3 || (Q2(h + 360 | 0, t, Z), i[h + 364 >> 2] != 3)) break t;
                          n = f(N * f(.5)), n = f(p0 + (T0 = f(0), Ae = $(n, f(0)), V0 = n != n, V0 ? T0 : Ae));
                          break r;
                        }

                        if (Q2(h + 24 | 0, t, Z), n = p0, i[h + 28 >> 2] == 3) break r;

                        if (j2(h + 24 | 0, t, Z), i[h + 28 >> 2] == 3) {
                          n = f(p0 + (T0 = f(0), Ae = $(N, f(0)), V0 = N != N, V0 ? T0 : Ae));
                          break r;
                        }

                        t: switch (k - 1 | 0) {
                          case 1:
                            n = f(p0 + f(N * f(.5)));
                            break r;

                          case 0:
                            break r;

                          default:
                            break t;
                        }

                        n = f(p0 + N);
                      }

                      t = t + (i[R0 >> 2] << 2) | 0, c[t + 228 >> 2] = n + f(V2 + c[t + 228 >> 2]);
                    }

                    if (T = T + 1 | 0, (T | 0) == (E | 0)) break;
                  }
                  n = f((h0 ? Or : f(0)) + v), t = C2 != C2, r = f(Ee + r);

                  i: {
                    if (!(t | r != r)) {
                      C2 = $(C2, r);
                      break i;
                    }

                    C2 = t ? r : C2;
                  }

                  if (V2 = f(V2 + n), t = h0 + 1 | 0, T = E, !(E >>> 0 < w2 >>> 0)) break;
                }

                i: {
                  if (!l || !N2 && !d1(e)) break i;
                  N = f(0);

                  r: {
                    t: {
                      if (G0 != G0) break t;
                      r = f(G0 - V2);

                      f: switch ((i[e + 24 >> 2] >>> 7 & 7) - 2 | 0) {
                        case 0:
                          p0 = f(p0 + f(r * f(.5)));
                          break t;

                        case 2:
                          if (!(G0 > V2)) break t;
                          N = f(r / f(t >>> 0));
                          break t;

                        case 5:
                          if (G0 > V2) {
                            if (p0 = f(p0 + f(r / f(t << 1 >>> 0))), t >>> 0 < 2) break t;
                            N = f(r / f(t >>> 0));
                            break r;
                          }

                          p0 = f(p0 + f(r * f(.5)));
                          break t;

                        case 4:
                          if (!(G0 > V2) | t >>> 0 < 2) break t;
                          N = f(r / f(h0 >>> 0));
                          break r;

                        case 1:
                          break f;

                        default:
                          break t;
                      }

                      p0 = f(p0 + r);
                    }

                    if (!t) break i;
                  }

                  for (W = 0, t = 0, k = 0;;) {
                    if (L = f(0), n = f(0), r = f(0), v = f(0), E = t, t >>> 0 < w2 >>> 0) {
                      r: {
                        for (;;) {
                          if (k = i[e + 556 >> 2], i[e + 560 >> 2] - k >> 2 >>> 0 <= E >>> 0) break n;
                          T = i[k + (E << 2) >> 2], H = i[T + 24 >> 2];

                          t: {
                            if (H & 4194304 | (H & 196608) == 131072) break t;
                            if (k = E, i[T + 548 >> 2] != (W | 0)) break r;
                            r = c[(T + (i[g0 >> 2] << 2) | 0) + 516 >> 2];

                            f: {
                              if (!(r >= f(0))) break f;

                              if (k = n != n, r = f(r + f(b(T, Z, _) + k0(T, Z, _))), !(k | r != r)) {
                                n = $(n, r);
                                break f;
                              }

                              n = k ? r : n;
                            }

                            if (k = H >>> 13 & 7, k || (k = i[e + 24 >> 2] >>> 10 & 7), !(O[e + 24 | 0] & 8) | (k | 0) != 5) break t;
                            r = Ue(T), C = b(T, 0, _), r = f(r + C), C = f(f(c[T + 520 >> 2] + f(b(T, 0, _) + k0(T, 0, _))) - r), k = n != n, T = v != v;

                            f: {
                              if (!(T | r != r)) {
                                v = $(v, r);
                                break f;
                              }

                              v = T ? r : v;
                            }

                            T = L != L;

                            f: {
                              if (!(T | C != C)) {
                                L = $(L, C);
                                break f;
                              }

                              L = T ? C : L;
                            }

                            if (r = f(v + L), !(k | r != r)) {
                              n = $(n, r);
                              break t;
                            }

                            n = k ? r : n;
                          }

                          if (E = E + 1 | 0, (w2 | 0) == (E | 0)) break;
                        }

                        k = w2;
                      }

                      r = n;
                    }

                    if (C = f(p0 + (W ? Or : f(0))), n = f(N + r), p0 = f(C + n), t >>> 0 < k >>> 0) for (q = f(C + v);;) {
                      if (E = i[e + 556 >> 2], i[e + 560 >> 2] - E >> 2 >>> 0 <= t >>> 0) break n;
                      T = i[E + (t << 2) >> 2], E = i[T + 24 >> 2];

                      r: {
                        if (E & 4194304 | (E & 196608) == 131072) break r;
                        E = E >>> 13 & 7, E || (E = i[e + 24 >> 2] >>> 10 & 7);

                        t: {
                          f: switch (E - 1 | 0) {
                            case 4:
                              if (O[e + 24 | 0] & 8) break t;

                            case 0:
                              r = b(T, Z, _), c[(T + (i[R0 >> 2] << 2) | 0) + 228 >> 2] = C + r;
                              break r;

                            case 2:
                              r = k0(T, Z, _), E = T + 228 | 0, c[E + (i[R0 >> 2] << 2) >> 2] = f(p0 - r) - c[(E + (i[g0 >> 2] << 2) | 0) + 288 >> 2];
                              break r;

                            case 1:
                              E = T + 228 | 0, c[E + (i[R0 >> 2] << 2) >> 2] = C + f(f(n - c[(E + (i[g0 >> 2] << 2) | 0) + 288 >> 2]) * f(.5));
                              break r;

                            case 3:
                              break f;

                            default:
                              break r;
                          }

                          r = b(T, Z, _), c[(T + (i[R0 >> 2] << 2) | 0) + 228 >> 2] = C + r, H = T + (i[g0 >> 2] << 3) | 0, E = H, r = c[E + 572 >> 2];

                          f: {
                            u: switch (E = i[E + 576 >> 2], E | 0) {
                              case 0:
                              case 3:
                                break f;

                              default:
                                break u;
                            }

                            if (v = c[H + 572 >> 2], !((E | 0) != 1 | v != v)) {
                              if (r < f(0)) break f;
                              break r;
                            }

                            if (u2 & !(r < f(0)) | ((E | 0) != 2 | v != v)) break r;
                          }

                          f: {
                            if (z >>> 0 >= 2) {
                              L = n, r = c[T + 516 >> 2], v = f(r + f(b(T, z, _) + k0(T, z, _)));
                              break f;
                            }

                            L = f(c[T + 520 >> 2] + f(b(T, Z, _) + k0(T, Z, _))), r = c[T + 516 >> 2], v = n;
                          }

                          f: {
                            u: {
                              if (!(v != v | r != r)) {
                                if (f(m0(f(v - r))) < f(9999999747378752e-20)) break u;
                                break f;
                              }

                              if (v == v | r == r) break f;
                            }

                            if (r = c[T + 520 >> 2], E = r != r, !(E | L != L)) {
                              if (!(f(m0(f(L - r))) < f(9999999747378752e-20))) break f;
                              break r;
                            }

                            if (L == L) break f;
                            if (E) break r;
                          }

                          z2(T, v, L, x0, 1, 1, _, E0, 1, 3, p, R, I, G);
                          break r;
                        }

                        V0 = T, T0 = f(f(q - Ue(T)) + O2(T, 0, G0)), c[V0 + 232 >> 2] = T0;
                      }

                      if (t = t + 1 | 0, (k | 0) == (t | 0)) break;
                    }
                    if (E = (W | 0) != (h0 | 0), W = W + 1 | 0, t = k, !E) break;
                  }
                }

                W = e + 516 | 0, r = y0(e, 2, Br, o), t = r != r, n = f(f(l0(e, 2, o) + i0(e, 2)) + f(a0(e, 2, o) + o0(e, 2)));

                i: {
                  if (!(t | n != n)) {
                    r = $(r, n);
                    break i;
                  }

                  r = t ? n : r;
                }

                c[W >> 2] = r, r = y0(e, 0, dr, A), t = r != r, n = f(f(l0(e, 0, o) + i0(e, 0)) + f(a0(e, 0, o) + o0(e, 0)));

                i: {
                  if (!(t | n != n)) {
                    r = $(r, n);
                    break i;
                  }

                  r = t ? n : r;
                }

                c[e + 520 >> 2] = r;

                i: {
                  r: {
                    t: {
                      if (g2 && (t = i[e + 24 >> 2] >>> 20 & 3, (t | 0) == 2 | (g2 | 0) != 2)) break t;

                      if (r = y0(e, z, C2, F2), t = r != r, n = f(f(l0(e, z, o) + i0(e, z)) + f(a0(e, z, o) + o0(e, z))), !(t | n != n)) {
                        r = $(r, n);
                        break r;
                      }

                      r = t ? n : r;
                      break r;
                    }

                    if ((g2 | 0) != 2 | (t | 0) != 2) break i;
                    n = f(p2 + n0), t = n != n, r = y0(e, z, C2, F2);

                    t: {
                      if (!(t | r != r)) {
                        r = Rr(n, r);
                        break t;
                      }

                      r = t ? r : n;
                    }

                    if (t = r != r, !(t | p2 != p2)) {
                      r = $(r, p2);
                      break r;
                    }

                    r = t ? p2 : r;
                  }

                  c[W + (i[L2 >> 2] << 2) >> 2] = r;
                }

                i: {
                  r: {
                    t: {
                      if (x && (k = (x | 0) != 2, t = i[e + 24 >> 2] >>> 20 & 3, k | (t | 0) == 2)) break t;

                      if (r = y0(e, Z, f(q0 + V2), ye), t = r != r, n = f(f(l0(e, Z, o) + i0(e, Z)) + f(a0(e, Z, o) + o0(e, Z))), !(t | n != n)) {
                        r = $(r, n);
                        break r;
                      }

                      r = t ? n : r;
                      break r;
                    }

                    if (k | (t | 0) != 2) break i;
                    n = f(q0 + G0), t = n != n, r = y0(e, Z, f(q0 + V2), ye);

                    t: {
                      if (!(t | r != r)) {
                        r = Rr(n, r);
                        break t;
                      }

                      r = t ? r : n;
                    }

                    if (t = r != r, !(t | q0 != q0)) {
                      r = $(r, q0);
                      break r;
                    }

                    r = t ? q0 : r;
                  }

                  c[W + (i[g0 >> 2] << 2) >> 2] = r;
                }

                i: {
                  if (!l) break i;

                  if (t = i[e + 560 >> 2], T = i[e + 556 >> 2], (i[e + 24 >> 2] & 786432) == 524288) {
                    for (k = w2 >>> 0 <= 1 ? 1 : w2, l = t - T >> 2, t = 0; E = 0, E = t >>> 0 < l >>> 0 ? i[(t << 2) + T >> 2] : E, (i[E + 24 >> 2] & 196608) != 131072 && (E = E + 228 | 0, H = E + (i[R0 >> 2] << 2) | 0, h0 = i[g0 >> 2] << 2, c[H >> 2] = f(c[h0 + W >> 2] - c[H >> 2]) - c[(E + h0 | 0) + 288 >> 2]), t = t + 1 | 0, (k | 0) != (t | 0);) {
                    }

                    T = i[e + 556 >> 2], t = i[e + 560 >> 2];
                  }

                  if ((t | 0) != (T | 0)) for (h0 = ((z >>> 0 > 1 ? g2 : u) | 0) != 0;;) {
                    l = i[T >> 2];

                    r: {
                      if ((i[l + 24 >> 2] & 4390912) != 131072) break r;
                      n = _, n0 = E0, O[i[e + 568 >> 2] + 21 | 0] && (n0 = c[e + 520 >> 2], n = c[e + 516 >> 2]), u = i[e + 24 >> 2] >>> 2 & 3;

                      t: {
                        f: {
                          if ((x0 | 0) == 2) {
                            k = 0, E = 3;

                            u: switch (u - 2 | 0) {
                              case 0:
                                break t;

                              case 1:
                                break u;

                              default:
                                break f;
                            }

                            E = 2;
                            break t;
                          }

                          if (k = 0, u >>> 0 <= 1) break f;
                          E = u;
                          break t;
                        }

                        E = u, k = _2;
                      }

                      A = f(b(l, 2, n) + k0(l, 2, n)), N = b(l, 0, n), L = k0(l, 0, n), r = c[l + 572 >> 2];

                      t: {
                        f: {
                          u: switch (u = i[l + 576 >> 2], u | 0) {
                            case 0:
                            case 3:
                              break f;

                            default:
                              break u;
                          }

                          o = c[l + 572 >> 2];

                          u: {
                            if (!((u | 0) != 1 | o != o)) {
                              if (v = r, !(r < f(0))) break u;
                              break f;
                            }

                            k: {
                              if (!((u | 0) != 2 | o != o)) {
                                if (n != n | r < f(0)) break f;
                                break k;
                              }

                              v = f(NaN);

                              o: switch (u - 1 | 0) {
                                case 1:
                                  break k;

                                case 0:
                                  break o;

                                default:
                                  break u;
                              }

                              v = r;
                              break u;
                            }

                            v = f(f(n * r) * f(.009999999776482582));
                          }

                          v = f(A + v);
                          break t;
                        }

                        if (v = f(NaN), !e2(l, 2) || !Se(l, 2)) break t;

                        if (r = y0(l, 2, f(f(c[e + 516 >> 2] - f(i0(e, 2) + o0(e, 2))) - f(O2(l, 2, n) + Ne(l, 2, n))), n), u = r != r, o = f(f(l0(l, 2, n) + i0(l, 2)) + f(a0(l, 2, n) + o0(l, 2))), !(u | o != o)) {
                          v = $(r, o);
                          break t;
                        }

                        v = u ? o : r;
                      }

                      L = f(N + L);

                      t: {
                        f: {
                          u: {
                            k: {
                              o: {
                                A: {
                                  l: {
                                    H = v != v, o = c[l + 580 >> 2];

                                    h: {
                                      a: {
                                        s: switch (u = i[l + 584 >> 2], u | 0) {
                                          case 0:
                                          case 3:
                                            break a;

                                          default:
                                            break s;
                                        }

                                        r = c[l + 580 >> 2];

                                        s: {
                                          if (!((u | 0) != 1 | r != r)) {
                                            if (r = o, !(r < f(0))) break s;
                                            break a;
                                          }

                                          v: {
                                            if (!((u | 0) != 2 | r != r)) {
                                              if (n0 != n0 | o < f(0)) break a;
                                              break v;
                                            }

                                            r = f(NaN);

                                            w: switch (u - 1 | 0) {
                                              case 1:
                                                break v;

                                              case 0:
                                                break w;

                                              default:
                                                break s;
                                            }

                                            r = o;
                                            break s;
                                          }

                                          r = f(f(n0 * o) * f(.009999999776482582));
                                        }

                                        r = f(L + r);
                                        break h;
                                      }

                                      a: {
                                        if (e2(l, 0) && Se(l, 0)) break a;
                                        if (r = f(NaN), v == v) break l;
                                        break u;
                                      }

                                      if (r = y0(l, 0, f(f(c[e + 520 >> 2] - f(i0(e, 0) + o0(e, 0))) - f(O2(l, 0, n0) + Ne(l, 0, n0))), n0), u = r != r, o = f(f(l0(l, 0, n) + i0(l, 0)) + f(a0(l, 0, n) + o0(l, 0))), !(u | o != o)) {
                                        r = $(r, o);
                                        break h;
                                      }

                                      r = u ? o : r;
                                    }

                                    if ((H | 0) == (r != r | 0) || (N = c[l + 224 >> 2], N != N)) break o;

                                    if (v != v) {
                                      v = f(f(f(r - L) * N) + A);
                                      break o;
                                    }

                                    if (r == r) break o;
                                    break A;
                                  }

                                  if (N = c[l + 224 >> 2], N != N) break k;
                                }

                                r = f(L + f(f(v - A) / N));
                              }

                              if (v != v) break u;
                              if (r == r) break t;
                            }

                            u = 0;
                            break f;
                          }

                          u = 1;
                        }

                        H = n > f(0), N0 = u & h0 & E >>> 0 < 2, o = N0 && H ? n : v, u = u ^ 1, z2(l, o, r, x0, N0 && H ? 2 : u, r == r, o, r, 0, 6, p, R, I, G), v = f(c[l + 516 >> 2] + K1(l, 2, n)), r = f(c[l + 520 >> 2] + K1(l, 0, n));
                      }

                      z2(l, v, r, x0, 1, 1, v, r, 1, 1, p, R, I, G), u = E >>> 0 < 2, A = u ? n : n0, H = i[e + 568 >> 2], o = O[H + 22 | 0] ? A : n;

                      t: {
                        f: {
                          u: {
                            if (!Se(l, E) || e2(l, E)) break u;
                            N0 = i[(E << 2) + 4192 >> 2] << 2, r = f(f(f(f(c[N0 + W >> 2] - c[(l + N0 | 0) + 516 >> 2]) - o0(e, E)) - k0(l, E, o)) - Ne(l, E, u ? n0 : n));
                            break f;
                          }

                          if (!(e2(l, E) | (i[e + 24 >> 2] & 112) != 16)) {
                            u = i[(E << 2) + 4192 >> 2] << 2, r = f(f(c[u + W >> 2] - c[(u + l | 0) + 516 >> 2]) * f(.5));
                            break f;
                          }

                          if (!(e2(l, E) | (i[e + 24 >> 2] & 112) != 32)) {
                            u = i[(E << 2) + 4192 >> 2] << 2, r = f(c[u + W >> 2] - c[(u + l | 0) + 516 >> 2]);
                            break f;
                          }

                          if (!O[H + 21 | 0] || !e2(l, E)) break t;
                          r = c[W + (i[(E << 2) + 4192 >> 2] << 2) >> 2], r = f(f(O2(l, E, r) + i0(e, E)) + b(l, E, r));
                        }

                        c[(l + (i[(E << 2) + 4160 >> 2] << 2) | 0) + 228 >> 2] = r;
                      }

                      t: {
                        f: {
                          if (!Se(l, k) || e2(l, k)) break f;
                          u = i[(k << 2) + 4192 >> 2] << 2, r = f(f(f(f(c[u + W >> 2] - c[(u + l | 0) + 516 >> 2]) - o0(e, k)) - k0(l, k, o)) - Ne(l, k, A));
                          break t;
                        }

                        f: {
                          if (e2(l, k) || (u = i[l + 24 >> 2] >>> 13 & 7, u || (u = i[e + 24 >> 2] >>> 10 & 7), (u | 0) != 2)) break f;
                          u = i[(k << 2) + 4192 >> 2] << 2, r = f(f(c[u + W >> 2] - c[(u + l | 0) + 516 >> 2]) * f(.5));
                          break t;
                        }

                        f: {
                          if (e2(l, k)) break f;
                          E = i[l + 24 >> 2] >>> 13 & 7, u = i[e + 24 >> 2], E = E || u >>> 10 & 7;

                          u: {
                            if (!((E | 0) != 5 | u & 8)) {
                              if ((u & 786432) == 524288) break u;
                              break f;
                            }

                            if (((u & 786432) == 524288 | 0) == ((E | 0) == 3 | 0)) break f;
                          }

                          u = i[(k << 2) + 4192 >> 2] << 2, r = f(c[u + W >> 2] - c[(u + l | 0) + 516 >> 2]);
                          break t;
                        }

                        if (!O[H + 21 | 0] || !e2(l, k)) break r;
                        r = c[W + (i[(k << 2) + 4192 >> 2] << 2) >> 2], r = f(f(O2(l, k, r) + i0(e, k)) + b(l, k, r));
                      }

                      c[(l + (i[(k << 2) + 4160 >> 2] << 2) | 0) + 228 >> 2] = r;
                    }

                    if (T = T + 4 | 0, (T | 0) == (t | 0)) break;
                  }
                  if (!((Z | z) & 1)) break i;

                  for (k = Z & 1, l = z & 1, p = w2 >>> 0 <= 1 ? 1 : w2, R = (Z << 2) + 4176 | 0, I = (z << 2) + 4176 | 0, G = i[e + 556 >> 2], Z = i[e + 560 >> 2] - G >> 2, t = 0;;) {
                    if ((t | 0) == (Z | 0)) break n;
                    e = i[G + (t << 2) >> 2];

                    r: {
                      if (O[e + 26 | 0] & 64 || (l && (u = e + 228 | 0, E = i[L2 >> 2] << 2, c[u + (i[I >> 2] << 2) >> 2] = f(c[E + W >> 2] - c[(u + E | 0) + 288 >> 2]) - c[u + (i[f2 >> 2] << 2) >> 2]), !k)) break r;
                      e = e + 228 | 0, u = i[g0 >> 2] << 2, c[e + (i[R >> 2] << 2) >> 2] = f(c[u + W >> 2] - c[(e + u | 0) + 288 >> 2]) - c[e + (i[R0 >> 2] << 2) >> 2];
                    }

                    if (t = t + 1 | 0, (p | 0) == (t | 0)) break;
                  }
                }

                if (!C0) break e;
                L0(C0);
                break e;
              }

              ie(), A0();
            }

            F = h + 384 | 0;
          }

          function c1() {
            var e = 0,
                r = 0;
            re(6888, 6889, 6890, 0, 4224, 17, 4227, 0, 4227, 0, 2511, 4229, 18), e = B(8), i[e >> 2] = 8, i[e + 4 >> 2] = 1, M(6888, 2813, 6, 4240, 4264, 19, e | 0, 1), re(6892, 6893, 6894, 6888, 4224, 20, 4224, 21, 4224, 22, 2e3, 4229, 23), e = B(4), i[e >> 2] = 24, M(6892, 2341, 2, 4272, 4280, 25, e | 0, 0), R2(6888, 1397, 2, 4284, 4292, 26, 27), R2(6888, 2918, 3, 4372, 4384, 28, 29), re(6912, 6913, 6914, 0, 4224, 30, 4227, 0, 4227, 0, 2527, 4229, 31), e = B(8), i[e >> 2] = 8, i[e + 4 >> 2] = 1, M(6912, 3184, 2, 4392, 4280, 32, e | 0, 1), re(6915, 6916, 6917, 6912, 4224, 33, 4224, 34, 4224, 35, 2023, 4229, 36), e = B(4), i[e >> 2] = 37, M(6915, 2341, 2, 4400, 4280, 38, e | 0, 0), R2(6912, 1397, 2, 4408, 4292, 39, 40), R2(6912, 2918, 3, 4372, 4384, 28, 41), re(6918, 6919, 6920, 0, 4224, 42, 4227, 0, 4227, 0, 2752, 4229, 43), s1(6918, 1, 4456, 4224, 44, 45), R2(6918, 2806, 1, 4456, 4224, 44, 45), R2(6918, 1128, 2, 4460, 4280, 46, 47), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 48, M(6918, 3125, 4, 4480, 4496, 49, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 50, M(6918, 1980, 3, 4504, 4516, 51, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 52, M(6918, 1951, 3, 4524, 4536, 53, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 54, M(6918, 1799, 3, 4524, 4536, 53, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 55, M(6918, 3155, 3, 4544, 4384, 56, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 57, M(6918, 1925, 2, 4556, 4292, 58, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 59, M(6918, 1784, 2, 4556, 4292, 58, e | 0, 0), hr(6921, 1270, 4564, 60, 4229, 61), ke(1731, 0), ke(1611, 8), ke(2144, 16), ke(2437, 24), ke(2543, 32), ke(1617, 40), cr(6921), hr(6891, 2789, 4564, 62, 4229, 63), Y1(2543, 0), Y1(1617, 8), cr(6891), hr(6922, 2800, 4564, 64, 4229, 65), e = B(4), i[e >> 2] = 8, r = B(4), i[r >> 2] = 8, Ce(6922, 2794, 6954, 4566, 66, e | 0, 6954, 4570, 67, r | 0), e = B(4), i[e >> 2] = 0, r = B(4), i[r >> 2] = 0, Ce(6922, 1606, 6947, 4292, 68, e | 0, 6947, 4536, 69, r | 0), cr(6922), re(6923, 6924, 6925, 0, 4224, 70, 4227, 0, 4227, 0, 2913, 4229, 71), s1(6923, 1, 4576, 4224, 72, 73), R2(6923, 1592, 1, 4576, 4224, 72, 73), R2(6923, 2742, 2, 4580, 4292, 74, 75), R2(6923, 1128, 2, 4588, 4280, 76, 77), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 78, M(6923, 1752, 2, 4588, 4280, 79, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 80, M(6923, 2896, 3, 4596, 4536, 81, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 82, M(6923, 2821, 3, 4608, 4536, 83, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 84, M(6923, 2317, 4, 4624, 4640, 85, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 86, M(6923, 1484, 4, 4624, 4640, 85, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 87, M(6923, 1355, 3, 4608, 4536, 83, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 88, M(6923, 1817, 3, 4608, 4536, 83, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 89, M(6923, 2763, 3, 4608, 4536, 83, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 90, M(6923, 2361, 3, 4608, 4536, 83, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 91, M(6923, 2163, 3, 4608, 4536, 83, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 92, M(6923, 1319, 3, 4608, 4536, 83, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 93, M(6923, 2395, 4, 4624, 4640, 85, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 94, M(6923, 1503, 4, 4624, 4640, 85, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 95, M(6923, 2218, 3, 4608, 4536, 83, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 96, M(6923, 1219, 3, 4608, 4536, 83, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 97, M(6923, 1136, 3, 4608, 4536, 83, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 98, M(6923, 1158, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 100, M(6923, 1845, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 101, M(6923, 1464, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 102, M(6923, 1195, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 103, M(6923, 2483, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 104, M(6923, 2573, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 105, M(6923, 1539, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 106, M(6923, 2232, 2, 4588, 4280, 79, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 107, M(6923, 1650, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 108, M(6923, 1427, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 109, M(6923, 2204, 2, 4588, 4280, 79, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 110, M(6923, 2591, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 111, M(6923, 1555, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 112, M(6923, 1670, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 113, M(6923, 1444, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 114, M(6923, 2549, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 115, M(6923, 1520, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 116, M(6923, 1624, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 117, M(6923, 1407, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 118, M(6923, 2287, 3, 4648, 4570, 99, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 119, M(6923, 2092, 4, 4624, 4640, 85, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 120, M(6923, 2701, 4, 4624, 4640, 85, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 121, M(6923, 1574, 4, 4624, 4640, 85, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 122, M(6923, 2187, 4, 4624, 4640, 85, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 123, M(6923, 2837, 2, 4660, 4292, 124, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 125, M(6923, 2329, 3, 4668, 4384, 126, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 127, M(6923, 1371, 2, 4660, 4292, 124, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 128, M(6923, 1831, 2, 4660, 4292, 124, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 129, M(6923, 2776, 2, 4660, 4292, 124, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 130, M(6923, 2378, 2, 4660, 4292, 124, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 131, M(6923, 2175, 2, 4660, 4292, 124, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 132, M(6923, 1337, 2, 4660, 4292, 124, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 133, M(6923, 2405, 3, 4668, 4384, 126, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 134, M(6923, 1858, 2, 4680, 4292, 135, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 136, M(6923, 1207, 2, 4688, 4566, 137, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 138, M(6923, 2497, 2, 4688, 4566, 137, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 139, M(6923, 2582, 2, 4680, 4292, 135, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 140, M(6923, 1660, 2, 4680, 4292, 135, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 141, M(6923, 2603, 2, 4680, 4292, 135, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 142, M(6923, 1683, 2, 4680, 4292, 135, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 143, M(6923, 2561, 2, 4680, 4292, 135, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 144, M(6923, 1637, 2, 4680, 4292, 135, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 145, M(6923, 2302, 2, 4688, 4566, 137, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 146, M(6923, 2102, 3, 4696, 4708, 147, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 148, M(6923, 1231, 2, 4660, 4292, 124, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 149, M(6923, 1147, 2, 4660, 4292, 124, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 150, M(6923, 2712, 3, 4668, 4384, 126, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 151, M(6923, 2194, 3, 4716, 4728, 152, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 153, M(6923, 2925, 4, 4736, 4496, 154, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 155, M(6923, 2946, 3, 4752, 4536, 156, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 157, M(6923, 1292, 2, 4764, 4292, 158, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 159, M(6923, 1387, 2, 4772, 4292, 160, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 161, M(6923, 2937, 3, 4780, 4384, 162, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 163, M(6923, 2853, 2, 4792, 4292, 164, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 165, M(6923, 2873, 3, 4800, 4536, 166, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 167, M(6923, 3248, 3, 4812, 4536, 168, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 169, M(6923, 3246, 2, 4588, 4280, 79, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 170, M(6923, 3265, 3, 4824, 4536, 171, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 172, M(6923, 3263, 2, 4588, 4280, 79, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 173, M(6923, 1118, 2, 4588, 4280, 79, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 174, M(6923, 1110, 2, 4836, 4292, 175, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 176, M(6923, 1243, 5, 4848, 4868, 177, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 178, M(6923, 1736, 2, 4688, 4566, 137, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 179, M(6923, 1714, 2, 4688, 4566, 137, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 180, M(6923, 2148, 2, 4688, 4566, 137, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 181, M(6923, 2444, 2, 4688, 4566, 137, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 182, M(6923, 2615, 2, 4688, 4566, 137, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 183, M(6923, 1696, 2, 4688, 4566, 137, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 184, M(6923, 1259, 2, 4876, 4292, 185, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 186, M(6923, 2415, 3, 4696, 4708, 147, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 187, M(6923, 2112, 3, 4696, 4708, 147, e | 0, 0), e = B(8), i[e + 4 >> 2] = 0, i[e >> 2] = 188, M(6923, 2723, 3, 4696, 4708, 147, e | 0, 0);
          }

          function c4(e, r, n, t, u, k) {
            e = e | 0, r = +r, n = n | 0, t = t | 0, u = u | 0, k = k | 0;
            var o = 0,
                A = 0,
                l = 0,
                p = 0,
                R = 0,
                I = 0,
                G = 0,
                Z = 0,
                h = 0,
                v = 0,
                N = 0,
                E = 0,
                W = 0,
                T = 0,
                _ = 0,
                L = 0,
                C = 0,
                H = 0,
                z = 0;
            G = F - 560 | 0, F = G, i[G + 44 >> 2] = 0, D0(+r), o = e0(1) | 0, e0(0) | 0;

            e: {
              if ((o | 0) < 0) {
                W = 1, H = 1176, r = -r, D0(+r), o = e0(1) | 0, e0(0) | 0;
                break e;
              }

              if (u & 2048) {
                W = 1, H = 1179;
                break e;
              }

              W = u & 1, H = W ? 1182 : 1177, z = !W;
            }

            e: {
              if ((o & 2146435072) == 2146435072) {
                o = W + 3 | 0, X0(e, 32, n, o, u & -65537), d0(e, H, W), t = k & 32, d0(e, r != r ? t ? 2433 : 3330 : t ? 2759 : 3334, 3), X0(e, 32, n, o, u ^ 8192), Z = (n | 0) < (o | 0) ? o : n;
                break e;
              }

              _ = G + 16 | 0;

              n: {
                i: {
                  r: {
                    if (r = _1(r, G + 44 | 0), r = r + r, r != 0) {
                      if (o = i[G + 44 >> 2], i[G + 44 >> 2] = o - 1, L = k | 32, (L | 0) != 97) break r;
                      break n;
                    }

                    if (L = k | 32, (L | 0) == 97) break n;
                    R = i[G + 44 >> 2], I = (t | 0) < 0 ? 6 : t;
                    break i;
                  }

                  R = o - 29 | 0, i[G + 44 >> 2] = R, r = r * 268435456, I = (t | 0) < 0 ? 6 : t;
                }

                for (N = (G + 48 | 0) + ((R | 0) >= 0 ? 288 : 0) | 0, A = N; r < 4294967296 & r >= 0 ? t = ~~r >>> 0 : t = 0, i[A >> 2] = t, A = A + 4 | 0, r = (r - +(t >>> 0)) * 1e9, r != 0;) {
                }

                i: {
                  if ((R | 0) <= 0) {
                    t = R, o = A, l = N;
                    break i;
                  }

                  for (l = N, t = R;;) {
                    h = (t | 0) >= 29 ? 29 : t, o = A - 4 | 0;

                    r: {
                      if (l >>> 0 > o >>> 0) break r;

                      for (t = 0; p = i[o >> 2], C = t, t = h & 31, (h & 63) >>> 0 >= 32 ? (Z = p << t, t = 0) : (Z = (1 << t) - 1 & p >>> 32 - t, t = p << t), C = C + t | 0, p = Z + v | 0, t = N1(C, t >>> 0 > C >>> 0 ? p + 1 | 0 : p, 1e9), p = Gr(t, z0, -1e9, 0) + C | 0, i[o >> 2] = p, o = o - 4 | 0, l >>> 0 <= o >>> 0;) {
                      }

                      if (!t) break r;
                      l = l - 4 | 0, i[l >> 2] = t;
                    }

                    for (; o = A, l >>> 0 < o >>> 0 && (A = o - 4 | 0, !i[A >> 2]);) {
                    }

                    if (t = i[G + 44 >> 2] - h | 0, i[G + 44 >> 2] = t, A = o, !((t | 0) > 0)) break;
                  }
                }

                if ((t | 0) < 0) for (T = ((I + 25 >>> 0) / 9 | 0) + 1 | 0, v = (L | 0) == 102;;) {
                  t = 0 - t | 0, Z = (t | 0) >= 9 ? 9 : t;

                  i: {
                    if (o >>> 0 <= l >>> 0) {
                      A = i[l >> 2];
                      break i;
                    }

                    for (h = 1e9 >>> Z | 0, p = -1 << Z ^ -1, t = 0, A = l; C = t, t = i[A >> 2], i[A >> 2] = C + (t >>> Z | 0), t = w0(h, t & p), A = A + 4 | 0, A >>> 0 < o >>> 0;) {
                    }

                    if (A = i[l >> 2], !t) break i;
                    i[o >> 2] = t, o = o + 4 | 0;
                  }

                  if (t = Z + i[G + 44 >> 2] | 0, i[G + 44 >> 2] = t, l = (!A << 2) + l | 0, A = v ? N : l, o = o - A >> 2 > (T | 0) ? A + (T << 2) | 0 : o, !((t | 0) < 0)) break;
                }
                t = 0;

                i: {
                  if (o >>> 0 <= l >>> 0 || (t = w0(N - l >> 2, 9), A = 10, p = i[l >> 2], p >>> 0 < 10)) break i;

                  for (; t = t + 1 | 0, A = w0(A, 10), p >>> 0 >= A >>> 0;) {
                  }
                }

                if (A = (I - ((L | 0) != 102 ? t : 0) | 0) - ((L | 0) == 103 & (I | 0) != 0) | 0, (A | 0) < (w0(o - N >> 2, 9) - 9 | 0)) {
                  if (h = A + 9216 | 0, p = (h | 0) / 9 | 0, R = ((((R | 0) < 0 ? 4 : 292) + G | 0) + (p << 2) | 0) - 4048 | 0, A = 10, Z = h + w0(p, -9) | 0, (Z | 0) <= 7) for (; A = w0(A, 10), Z = Z + 1 | 0, (Z | 0) != 8;) {
                  }
                  h = i[R >> 2], T = (h >>> 0) / (A >>> 0) | 0, v = w0(T, A), p = R + 4 | 0;

                  i: {
                    if ((h | 0) == (v | 0) & (p | 0) == (o | 0)) break i;
                    h = h - v | 0;

                    r: {
                      if (!(T & 1) && (r = 9007199254740992, !(V[R - 4 | 0] & 1) | ((A | 0) != 1e9 | l >>> 0 >= R >>> 0))) break r;
                      r = 9007199254740994;
                    }

                    if (E = (o | 0) == (p | 0) ? 1 : 1.5, p = A >>> 1 | 0, E = p >>> 0 > h >>> 0 ? .5 : (p | 0) == (h | 0) ? E : 1.5, O[H | 0] != 45 | z || (E = -E, r = -r), i[R >> 2] = v, r + E == r) break i;
                    if (t = A + v | 0, i[R >> 2] = t, t >>> 0 >= 1e9) for (; i[R >> 2] = 0, R = R - 4 | 0, R >>> 0 < l >>> 0 && (l = l - 4 | 0, i[l >> 2] = 0), t = i[R >> 2] + 1 | 0, i[R >> 2] = t, t >>> 0 > 999999999;) {
                    }
                    if (t = w0(N - l >> 2, 9), A = 10, p = i[l >> 2], p >>> 0 < 10) break i;

                    for (; t = t + 1 | 0, A = w0(A, 10), p >>> 0 >= A >>> 0;) {
                    }
                  }

                  A = R + 4 | 0, o = o >>> 0 > A >>> 0 ? A : o;
                }

                for (; p = o, h = o >>> 0 <= l >>> 0, !h && (o = p - 4 | 0, !i[o >> 2]);) {
                }

                i: {
                  if ((L | 0) != 103) {
                    R = u & 8;
                    break i;
                  }

                  if (A = I || 1, o = (A | 0) > (t | 0) & (t | 0) > -5, I = (o ? t ^ -1 : -1) + A | 0, k = (o ? -1 : -2) + k | 0, R = u & 8, R) break i;
                  o = -9;

                  r: {
                    if (h || (R = i[p - 4 >> 2], !R) || (Z = 10, o = 0, (R >>> 0) % 10 | 0)) break r;

                    for (; A = o, o = o + 1 | 0, Z = w0(Z, 10), !((R >>> 0) % (Z >>> 0) | 0);) {
                    }

                    o = A ^ -1;
                  }

                  if (A = w0(p - N >> 2, 9), (k & -33) == 70) {
                    R = 0, o = (o + A | 0) - 9 | 0, o = (o | 0) > 0 ? o : 0, I = (o | 0) > (I | 0) ? I : o;
                    break i;
                  }

                  R = 0, o = ((t + A | 0) + o | 0) - 9 | 0, o = (o | 0) > 0 ? o : 0, I = (o | 0) > (I | 0) ? I : o;
                }

                if (Z = -1, h = R | I, ((h ? 2147483645 : 2147483646) | 0) < (I | 0)) break e;
                v = (((h | 0) != 0) + I | 0) + 1 | 0, A = k & -33;

                i: {
                  if ((A | 0) == 70) {
                    if ((v ^ 2147483647) < (t | 0)) break e;
                    o = (t | 0) > 0 ? t : 0;
                    break i;
                  }

                  if (o = t >> 31, o = te((o ^ t) - o | 0, 0, _), (_ - o | 0) <= 1) for (; o = o - 1 | 0, V[o | 0] = 48, (_ - o | 0) < 2;) {
                  }
                  if (T = o - 2 | 0, V[T | 0] = k, V[o - 1 | 0] = (t | 0) < 0 ? 45 : 43, o = _ - T | 0, (o | 0) > (v ^ 2147483647)) break e;
                }

                if (t = o + v | 0, (t | 0) > (W ^ 2147483647)) break e;
                v = t + W | 0, X0(e, 32, n, v, u), d0(e, H, W), X0(e, 48, n, v, u ^ 65536);

                i: {
                  r: {
                    t: {
                      if ((A | 0) == 70) {
                        for (k = G + 16 | 0, t = k | 8, R = k | 9, A = l >>> 0 > N >>> 0 ? N : l, l = A;;) {
                          o = te(i[l >> 2], 0, R);

                          f: {
                            if ((A | 0) != (l | 0)) {
                              if (G + 16 >>> 0 >= o >>> 0) break f;

                              for (; o = o - 1 | 0, V[o | 0] = 48, G + 16 >>> 0 < o >>> 0;) {
                              }

                              break f;
                            }

                            if ((o | 0) != (R | 0)) break f;
                            V[G + 24 | 0] = 48, o = t;
                          }

                          if (d0(e, o, R - o | 0), l = l + 4 | 0, !(N >>> 0 >= l >>> 0)) break;
                        }

                        if (h && d0(e, 4146, 1), (I | 0) <= 0 | l >>> 0 >= p >>> 0) break t;

                        for (;;) {
                          if (o = te(i[l >> 2], 0, R), o >>> 0 > G + 16 >>> 0) for (; o = o - 1 | 0, V[o | 0] = 48, G + 16 >>> 0 < o >>> 0;) {
                          }
                          if (d0(e, o, (I | 0) >= 9 ? 9 : I), o = I - 9 | 0, l = l + 4 | 0, p >>> 0 <= l >>> 0) break r;
                          if (t = (I | 0) > 9, I = o, !t) break;
                        }

                        break r;
                      }

                      f: {
                        if ((I | 0) < 0) break f;

                        for (N = l >>> 0 < p >>> 0 ? p : l + 4 | 0, k = G + 16 | 0, t = k | 8, p = k | 9, A = l;;) {
                          o = te(i[A >> 2], 0, p), (p | 0) == (o | 0) && (V[G + 24 | 0] = 48, o = t);

                          u: {
                            if ((A | 0) != (l | 0)) {
                              if (G + 16 >>> 0 >= o >>> 0) break u;

                              for (; o = o - 1 | 0, V[o | 0] = 48, G + 16 >>> 0 < o >>> 0;) {
                              }

                              break u;
                            }

                            if (d0(e, o, 1), o = o + 1 | 0, !(R | I)) break u;
                            d0(e, 4146, 1);
                          }

                          if (k = p - o | 0, d0(e, o, (k | 0) > (I | 0) ? I : k), I = I - k | 0, A = A + 4 | 0, N >>> 0 <= A >>> 0) break f;
                          if (!((I | 0) >= 0)) break;
                        }
                      }

                      X0(e, 48, I + 18 | 0, 18, 0), d0(e, T, _ - T | 0);
                      break i;
                    }

                    o = I;
                  }

                  X0(e, 48, o + 9 | 0, 9, 0);
                }

                X0(e, 32, n, v, u ^ 8192), Z = (n | 0) < (v | 0) ? v : n;
                break e;
              }

              R = (k << 26 >> 31 & 9) + H | 0;

              n: {
                if (t >>> 0 > 11) break n;

                for (o = 12 - t | 0, E = 16; E = E * 16, o = o - 1 | 0, !!o;) {
                }

                if (O[R | 0] == 45) {
                  r = -(E + (-r - E));
                  break n;
                }

                r = r + E - E;
              }

              for (N = W | 2, l = k & 32, A = i[G + 44 >> 2], o = A >> 31, o = te((o ^ A) - o | 0, 0, _), (_ | 0) == (o | 0) && (V[G + 15 | 0] = 48, o = G + 15 | 0), I = o - 2 | 0, V[I | 0] = k + 15, V[o - 1 | 0] = (A | 0) < 0 ? 45 : 43, o = u & 8, A = G + 16 | 0; k = A, m0(r) < 2147483648 ? p = ~~r : p = -2147483648, V[A | 0] = l | O[p + 5360 | 0], r = (r - +(p | 0)) * 16, A = k + 1 | 0, !(o | (t | 0) > 0) & r == 0 | (A - (G + 16 | 0) | 0) != 1 || (V[k + 1 | 0] = 46, A = k + 2 | 0), r != 0;) {
              }

              if (Z = -1, o = _ - I | 0, k = o + N | 0, (2147483645 - k | 0) < (t | 0)) break e;

              n: {
                i: {
                  if (!t || (l = A - (G + 16 | 0) | 0, (l - 2 | 0) >= (t | 0))) break i;
                  t = t + 2 | 0;
                  break n;
                }

                l = A - (G + 16 | 0) | 0, t = l;
              }

              k = t + k | 0, X0(e, 32, n, k, u), d0(e, R, N), X0(e, 48, n, k, u ^ 65536), d0(e, G + 16 | 0, l), X0(e, 48, t - l | 0, 0, 0), d0(e, I, o), X0(e, 32, n, k, u ^ 8192), Z = (n | 0) < (k | 0) ? k : n;
            }

            return F = G + 560 | 0, Z | 0;
          }

          function h1(e, r, n, t, u, k, o) {
            var A = 0,
                l = 0,
                p = 0,
                R = 0,
                I = 0,
                G = 0,
                Z = 0,
                h = 0,
                v = 0,
                N = 0,
                E = 0,
                W = 0,
                T = 0,
                _ = 0,
                L = 0,
                C = 0,
                H = 0,
                z = 0,
                x = 0,
                q = 0;
            p = F - 80 | 0, F = p, i[p + 76 >> 2] = r, z = p + 55 | 0, T = p + 56 | 0;

            e: {
              n: {
                i: {
                  r: {
                    t: for (;;) {
                      if (R = r, (v ^ 2147483647) < (A | 0)) break r;
                      v = A + v | 0;

                      f: {
                        u: {
                          k: {
                            if (A = R, l = O[A | 0], l) for (;;) {
                              o: {
                                r = l & 255;

                                A: {
                                  if (!r) {
                                    r = A;
                                    break A;
                                  }

                                  if ((r | 0) != 37) break o;

                                  for (l = A;;) {
                                    if (O[l + 1 | 0] != 37) {
                                      r = l;
                                      break A;
                                    }

                                    if (A = A + 1 | 0, I = O[l + 2 | 0], r = l + 2 | 0, l = r, (I | 0) != 37) break;
                                  }
                                }

                                if (A = A - R | 0, H = v ^ 2147483647, (A | 0) > (H | 0)) break r;
                                if (e && d0(e, R, A), A) continue t;
                                i[p + 76 >> 2] = r, A = r + 1 | 0, E = -1, l = V[r + 1 | 0], !Ye(l) | O[r + 2 | 0] != 36 || (E = l - 48 | 0, _ = 1, A = r + 3 | 0), i[p + 76 >> 2] = A, h = 0, l = V[A | 0], r = l - 32 | 0;

                                A: {
                                  if (r >>> 0 > 31) {
                                    I = A;
                                    break A;
                                  }

                                  if (I = A, r = 1 << r, !(r & 75913)) break A;

                                  for (;;) {
                                    if (I = A + 1 | 0, i[p + 76 >> 2] = I, h = r | h, l = V[A + 1 | 0], r = l - 32 | 0, r >>> 0 >= 32) break A;
                                    if (A = I, r = 1 << r, !(r & 75913)) break;
                                  }
                                }

                                A: {
                                  if ((l | 0) == 42) {
                                    r = V[I + 1 | 0];

                                    l: {
                                      if (!(!Ye(r) | O[I + 2 | 0] != 36)) {
                                        i[((r << 2) + u | 0) - 192 >> 2] = 10, l = I + 3 | 0, _ = 1, N = i[((V[I + 1 | 0] << 3) + t | 0) - 384 >> 2];
                                        break l;
                                      }

                                      if (_) break k;

                                      if (l = I + 1 | 0, !e) {
                                        i[p + 76 >> 2] = l, _ = 0, N = 0;
                                        break A;
                                      }

                                      r = i[n >> 2], i[n >> 2] = r + 4, _ = 0, N = i[r >> 2];
                                    }

                                    if (i[p + 76 >> 2] = l, (N | 0) >= 0) break A;
                                    N = 0 - N | 0, h = h | 8192;
                                    break A;
                                  }

                                  if (N = M1(p + 76 | 0), (N | 0) < 0) break r;
                                  l = i[p + 76 >> 2];
                                }

                                A = 0, Z = -1;

                                A: {
                                  if (O[l | 0] != 46) {
                                    r = l, W = 0;
                                    break A;
                                  }

                                  if (O[l + 1 | 0] == 42) {
                                    r = V[l + 2 | 0];

                                    l: {
                                      if (!(!Ye(r) | O[l + 3 | 0] != 36)) {
                                        i[((r << 2) + u | 0) - 192 >> 2] = 10, r = l + 4 | 0, Z = i[((V[l + 2 | 0] << 3) + t | 0) - 384 >> 2];
                                        break l;
                                      }

                                      if (_) break k;
                                      if (r = l + 2 | 0, Z = 0, !e) break l;
                                      l = i[n >> 2], i[n >> 2] = l + 4, Z = i[l >> 2];
                                    }

                                    i[p + 76 >> 2] = r, W = (Z ^ -1) >>> 31 | 0;
                                    break A;
                                  }

                                  i[p + 76 >> 2] = l + 1, Z = M1(p + 76 | 0), r = i[p + 76 >> 2], W = 1;
                                }

                                for (;;) {
                                  if (G = A, I = 28, L = r, A = V[r | 0], A - 123 >>> 0 < 4294967238) break i;
                                  if (r = L + 1 | 0, A = O[(A + w0(G, 58) | 0) + 4831 | 0], !(A - 1 >>> 0 < 8)) break;
                                }

                                i[p + 76 >> 2] = r;

                                A: {
                                  l: {
                                    if ((A | 0) != 27) {
                                      if (!A) break i;

                                      if ((E | 0) >= 0) {
                                        i[(E << 2) + u >> 2] = A, A = (E << 3) + t | 0, l = i[A + 4 >> 2], i[p + 64 >> 2] = i[A >> 2], i[p + 68 >> 2] = l;
                                        break l;
                                      }

                                      if (!e) break f;
                                      y1(p - -64 | 0, A, n, o);
                                      break A;
                                    }

                                    if ((E | 0) >= 0) break i;
                                  }

                                  if (A = 0, !e) continue t;
                                }

                                l = h & -65537, h = h & 8192 ? l : h, E = 0, C = 1166, I = T;

                                A: {
                                  l: {
                                    h: {
                                      a: {
                                        s: {
                                          v: {
                                            w: {
                                              c: {
                                                p: {
                                                  m: {
                                                    N: {
                                                      G: {
                                                        R: {
                                                          y: {
                                                            Z: {
                                                              E: switch (A = V[L | 0], A = G && (A & 15) == 3 ? A & -33 : A, A - 88 | 0) {
                                                                case 11:
                                                                  break A;

                                                                case 9:
                                                                case 13:
                                                                case 14:
                                                                case 15:
                                                                  break l;

                                                                case 27:
                                                                  break w;

                                                                case 12:
                                                                case 17:
                                                                  break m;

                                                                case 23:
                                                                  break N;

                                                                case 0:
                                                                case 32:
                                                                  break G;

                                                                case 24:
                                                                  break R;

                                                                case 22:
                                                                  break y;

                                                                case 29:
                                                                  break Z;

                                                                case 1:
                                                                case 2:
                                                                case 3:
                                                                case 4:
                                                                case 5:
                                                                case 6:
                                                                case 7:
                                                                case 8:
                                                                case 10:
                                                                case 16:
                                                                case 18:
                                                                case 19:
                                                                case 20:
                                                                case 21:
                                                                case 25:
                                                                case 26:
                                                                case 28:
                                                                case 30:
                                                                case 31:
                                                                  break u;

                                                                default:
                                                                  break E;
                                                              }

                                                              E: switch (A - 65 | 0) {
                                                                case 0:
                                                                case 4:
                                                                case 5:
                                                                case 6:
                                                                  break l;

                                                                case 2:
                                                                  break s;

                                                                case 1:
                                                                case 3:
                                                                  break u;

                                                                default:
                                                                  break E;
                                                              }

                                                              if ((A | 0) == 83) break v;
                                                              break u;
                                                            }

                                                            l = i[p + 64 >> 2], G = i[p + 68 >> 2], A = 1166;
                                                            break p;
                                                          }

                                                          A = 0;

                                                          y: switch (G & 255) {
                                                            case 0:
                                                              i[i[p + 64 >> 2] >> 2] = v;
                                                              continue t;

                                                            case 1:
                                                              i[i[p + 64 >> 2] >> 2] = v;
                                                              continue t;

                                                            case 2:
                                                              R = i[p + 64 >> 2], i[R >> 2] = v, i[R + 4 >> 2] = v >> 31;
                                                              continue t;

                                                            case 3:
                                                              W0[i[p + 64 >> 2] >> 1] = v;
                                                              continue t;

                                                            case 4:
                                                              V[i[p + 64 >> 2]] = v;
                                                              continue t;

                                                            case 6:
                                                              i[i[p + 64 >> 2] >> 2] = v;
                                                              continue t;

                                                            case 7:
                                                              break y;

                                                            default:
                                                              continue t;
                                                          }

                                                          R = i[p + 64 >> 2], i[R >> 2] = v, i[R + 4 >> 2] = v >> 31;
                                                          continue t;
                                                        }

                                                        Z = Z >>> 0 <= 8 ? 8 : Z, h = h | 8, A = 120;
                                                      }

                                                      if (R = T, l = i[p + 64 >> 2], G = i[p + 68 >> 2], l | G) for (x = A & 32; R = R - 1 | 0, V[R | 0] = x | O[(l & 15) + 5360 | 0], q = !G & l >>> 0 > 15 | (G | 0) != 0, L = G, G = G >>> 4 | 0, l = (L & 15) << 28 | l >>> 4, !!q;) {
                                                      }
                                                      if (!(h & 8) | !(i[p + 64 >> 2] | i[p + 68 >> 2])) break c;
                                                      C = (A >>> 4 | 0) + 1166 | 0, E = 2;
                                                      break c;
                                                    }

                                                    if (A = T, R = i[p + 68 >> 2], G = R, l = i[p + 64 >> 2], R | l) for (; A = A - 1 | 0, V[A | 0] = l & 7 | 48, L = !G & l >>> 0 > 7 | (G | 0) != 0, R = G, G = R >>> 3 | 0, l = (R & 7) << 29 | l >>> 3, !!L;) {
                                                    }
                                                    if (R = A, !(h & 8)) break c;
                                                    A = T - R | 0, Z = (A | 0) < (Z | 0) ? Z : A + 1 | 0;
                                                    break c;
                                                  }

                                                  if (l = i[p + 64 >> 2], A = i[p + 68 >> 2], G = A, (A | 0) < 0) {
                                                    R = 0 - (G + ((l | 0) != 0) | 0) | 0, G = R, l = 0 - l | 0, i[p + 64 >> 2] = l, i[p + 68 >> 2] = R, E = 1, A = 1166;
                                                    break p;
                                                  }

                                                  if (h & 2048) {
                                                    E = 1, A = 1167;
                                                    break p;
                                                  }

                                                  E = h & 1, A = E ? 1168 : 1166;
                                                }

                                                C = A, R = te(l, G, T);
                                              }

                                              if ((Z | 0) < 0 && W) break r;

                                              if (h = W ? h & -65537 : h, A = i[p + 64 >> 2], l = i[p + 68 >> 2], !((A | l) != 0 | Z)) {
                                                R = T, Z = 0;
                                                break u;
                                              }

                                              A = !(A | l) + (T - R | 0) | 0, Z = (A | 0) < (Z | 0) ? Z : A;
                                              break u;
                                            }

                                            h = 0, W = Z >>> 0 >= 2147483647 ? 2147483647 : Z, G = W, I = (G | 0) != 0;

                                            w: {
                                              c: {
                                                A = i[p + 64 >> 2], R = A || 4148, A = R;

                                                p: {
                                                  m: {
                                                    N: {
                                                      if (!(A & 3) | !G) break N;

                                                      for (;;) {
                                                        if (h = O[A | 0], !h) break m;
                                                        if (G = G - 1 | 0, I = (G | 0) != 0, A = A + 1 | 0, !(A & 3)) break N;
                                                        if (!G) break;
                                                      }
                                                    }

                                                    if (!I) break c;

                                                    N: {
                                                      if (!(!O[A | 0] | G >>> 0 < 4)) for (;;) {
                                                        if (I = i[A >> 2], (I ^ -1) & I - 16843009 & -2139062144) break N;
                                                        if (A = A + 4 | 0, G = G - 4 | 0, !(G >>> 0 > 3)) break;
                                                      }
                                                      if (!G) break c;
                                                    }

                                                    I = 0;
                                                    break p;
                                                  }

                                                  I = 1;
                                                }

                                                for (;;) {
                                                  if (!I) {
                                                    h = O[A | 0], I = 1;
                                                    continue;
                                                  }

                                                  if (!h) break w;
                                                  if (A = A + 1 | 0, G = G - 1 | 0, !G) break c;
                                                  I = 0;
                                                }
                                              }

                                              A = 0;
                                            }

                                            if (A = A ? A - R | 0 : W, I = A + R | 0, (Z | 0) >= 0) {
                                              h = l, Z = A;
                                              break u;
                                            }

                                            if (h = l, Z = A, O[I | 0]) break r;
                                            break u;
                                          }

                                          if (Z) {
                                            l = i[p + 64 >> 2];
                                            break a;
                                          }

                                          A = 0, X0(e, 32, N, 0, h);
                                          break h;
                                        }

                                        i[p + 12 >> 2] = 0, i[p + 8 >> 2] = i[p + 64 >> 2], l = p + 8 | 0, i[p + 64 >> 2] = l, Z = -1;
                                      }

                                      A = 0;

                                      a: {
                                        for (;;) {
                                          if (R = i[l >> 2], !R) break a;

                                          if (R = D1(p + 4 | 0, R), I = (R | 0) < 0, !(I | R >>> 0 > Z - A >>> 0)) {
                                            if (l = l + 4 | 0, A = A + R | 0, Z >>> 0 > A >>> 0) continue;
                                            break a;
                                          }

                                          break;
                                        }

                                        if (I) break n;
                                      }

                                      if (I = 61, (A | 0) < 0) break i;

                                      if (X0(e, 32, N, A, h), !A) {
                                        A = 0;
                                        break h;
                                      }

                                      for (I = 0, l = i[p + 64 >> 2];;) {
                                        if (R = i[l >> 2], !R || (R = D1(p + 4 | 0, R), I = R + I | 0, I >>> 0 > A >>> 0)) break h;
                                        if (d0(e, p + 4 | 0, R), l = l + 4 | 0, !(A >>> 0 > I >>> 0)) break;
                                      }
                                    }

                                    X0(e, 32, N, A, h ^ 8192), A = (A | 0) < (N | 0) ? N : A;
                                    continue t;
                                  }

                                  if ((Z | 0) < 0 && W) break r;
                                  if (I = 61, A = Y[k | 0](e, v0[p + 64 >> 3], N, Z, h, A) | 0, (A | 0) >= 0) continue t;
                                  break i;
                                }

                                V[p + 55 | 0] = i[p + 64 >> 2], Z = 1, R = z, h = l;
                                break u;
                              }

                              l = O[A + 1 | 0], A = A + 1 | 0;
                            }
                            if (e) break e;
                            if (!_) break f;

                            for (A = 1;;) {
                              if (e = i[(A << 2) + u >> 2], e) {
                                if (y1((A << 3) + t | 0, e, n, o), v = 1, A = A + 1 | 0, (A | 0) != 10) continue;
                                break e;
                              }

                              break;
                            }

                            if (v = 1, A >>> 0 >= 10) break e;

                            for (;;) {
                              if (i[(A << 2) + u >> 2]) break k;
                              if (A = A + 1 | 0, (A | 0) == 10) break;
                            }

                            break e;
                          }

                          I = 28;
                          break i;
                        }

                        if (G = I - R | 0, Z = (Z | 0) > (G | 0) ? Z : G, (Z | 0) > (E ^ 2147483647)) break r;
                        if (I = 61, l = Z + E | 0, A = (l | 0) < (N | 0) ? N : l, (H | 0) < (A | 0)) break i;
                        X0(e, 32, A, l, h), d0(e, C, E), X0(e, 48, A, l, h ^ 65536), X0(e, 48, Z, G, 0), d0(e, R, G), X0(e, 32, A, l, h ^ 8192);
                        continue;
                      }

                      break;
                    }

                    v = 0;
                    break e;
                  }

                  I = 61;
                }

                i[1745] = I;
              }

              v = -1;
            }

            return F = p + 80 | 0, v;
          }

          function h4(e, r, n, t) {
            e = e | 0, r = +r, n = +n, t = t | 0;
            var u = f(0),
                k = f(0),
                o = 0,
                A = f(0),
                l = 0,
                p = f(0),
                R = 0,
                I = f(0),
                G = 0;
            G = F + -64 | 0, F = G, o = i[e >> 2], j0(G + 8 | 0, 0, 56), i[1719] = i[1719] + 1, v1(o), A = f(r), k = c[o + 572 >> 2];

            e: {
              n: {
                i: switch (e = i[o + 576 >> 2], e | 0) {
                  case 0:
                  case 3:
                    break n;

                  default:
                    break i;
                }

                u = c[o + 572 >> 2];

                i: {
                  if (!((e | 0) != 1 | u != u)) {
                    if (u = k, !(u < f(0))) break i;
                    break n;
                  }

                  r: {
                    if (!((e | 0) != 2 | u != u)) {
                      if (A != A | k < f(0)) break n;
                      break r;
                    }

                    u = f(NaN);

                    t: switch (e - 1 | 0) {
                      case 1:
                        break r;

                      case 0:
                        break t;

                      default:
                        break i;
                    }

                    u = k;
                    break i;
                  }

                  u = f(f(k * A) * f(.009999999776482582));
                }

                I = f(u + f(b(o, 2, A) + k0(o, 2, A))), R = 1;
                break e;
              }

              u = f(0), k = c[o + 216 >> 2];

              n: {
                i: {
                  e = i[o + 216 >> 2];

                  r: {
                    t: {
                      if ((e | 0) == 2139156720) break t;
                      if ((e | 0) == 2140081935) break n;
                      R = 4216;

                      f: {
                        if ((e | 0) != 2141891242) {
                          if (k == k) break f;
                          R = 4208;
                        }

                        switch (u = c[R >> 2], i[R + 4 >> 2] - 1 | 0) {
                          case 0:
                            break r;

                          case 1:
                            break t;

                          default:
                            break i;
                        }
                      }

                      if (u = (U(2, (e & -1073741825) + 536870912 | 0), j()), !(e & 1073741824)) break r;
                    }

                    u = f(f(u * A) * f(.009999999776482582));
                  }

                  if (u != u) break i;
                  u = f(0);

                  r: {
                    if ((e | 0) == 2139156720) break r;
                    if ((e | 0) == 2140081935) break n;
                    l = 4216;

                    t: {
                      if ((e | 0) != 2141891242) {
                        if (k == k) break t;
                        l = 4208;
                      }

                      switch (u = c[l >> 2], I = f(NaN), R = 2, i[l + 4 >> 2] - 1 | 0) {
                        case 1:
                          break r;

                        case 0:
                          break n;

                        default:
                          break e;
                      }
                    }

                    if (u = (U(2, (e & -1073741825) + 536870912 | 0), j()), !(e & 1073741824)) break n;
                  }

                  I = f(f(u * A) * f(.009999999776482582)), R = 2;
                  break e;
                }

                R = A == A, I = A;
                break e;
              }

              R = 2, I = u;
            }

            p = f(n), k = c[o + 580 >> 2];

            e: {
              n: {
                i: switch (e = i[o + 584 >> 2], e | 0) {
                  case 0:
                  case 3:
                    break n;

                  default:
                    break i;
                }

                u = c[o + 580 >> 2];

                i: {
                  if (!((e | 0) != 1 | u != u)) {
                    if (u = k, !(u < f(0))) break i;
                    break n;
                  }

                  r: {
                    if (!((e | 0) != 2 | u != u)) {
                      if (p != p | k < f(0)) break n;
                      break r;
                    }

                    u = f(NaN);

                    t: switch (e - 1 | 0) {
                      case 1:
                        break r;

                      case 0:
                        break t;

                      default:
                        break i;
                    }

                    u = k;
                    break i;
                  }

                  u = f(f(k * p) * f(.009999999776482582));
                }

                k = f(u + f(b(o, 0, A) + k0(o, 0, A))), e = 1;
                break e;
              }

              u = f(0), k = c[o + 220 >> 2];

              n: {
                i: {
                  e = i[o + 220 >> 2];

                  r: {
                    t: {
                      if ((e | 0) == 2139156720) break t;
                      if ((e | 0) == 2140081935) break n;
                      l = 4216;

                      f: {
                        if ((e | 0) != 2141891242) {
                          if (k == k) break f;
                          l = 4208;
                        }

                        switch (u = c[l >> 2], i[l + 4 >> 2] - 1 | 0) {
                          case 0:
                            break r;

                          case 1:
                            break t;

                          default:
                            break i;
                        }
                      }

                      if (u = (U(2, (e & -1073741825) + 536870912 | 0), j()), !(e & 1073741824)) break r;
                    }

                    u = f(f(u * p) * f(.009999999776482582));
                  }

                  if (u != u) break i;
                  u = f(0);

                  r: {
                    if ((e | 0) == 2139156720) break r;
                    if ((e | 0) == 2140081935) break n;
                    l = 4216;

                    t: {
                      if ((e | 0) != 2141891242) {
                        if (k == k) break t;
                        l = 4208;
                      }

                      switch (u = c[l >> 2], k = f(NaN), e = 2, i[l + 4 >> 2] - 1 | 0) {
                        case 0:
                          break n;

                        case 1:
                          break r;

                        default:
                          break e;
                      }
                    }

                    if (u = (U(2, (e & -1073741825) + 536870912 | 0), j()), !(e & 1073741824)) break n;
                  }

                  k = f(f(u * p) * f(.009999999776482582)), e = 2;
                  break e;
                }

                e = p == p, k = p;
                break e;
              }

              e = 2, k = u;
            }

            z2(o, I, k, t, R, e, A, p, 1, 0, i[o + 568 >> 2], G + 8 | 0, 0, i[1719]) && (W1(o, O[o + 300 | 0] & 3, A, p, A), E1(o, +c[i[o + 568 >> 2] + 16 >> 2], 0, 0)), F = G - -64 | 0;
          }

          function v4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0,
                t = f(0),
                u = 0,
                k = 0,
                o = f(0),
                A = 0,
                l = 0,
                p = 0,
                R = f(0);

            e: {
              l = i[r >> 2], r = i[e >> 2];

              n: {
                if ((i[l + 24 >> 2] ^ i[r + 24 >> 2]) & 8388607) break n;
                R = c[l + 40 >> 2], u = i[l + 40 >> 2], t = c[r + 40 >> 2];

                i: {
                  r: {
                    if (n = i[r + 40 >> 2], (n | 0) != 2139156720) {
                      if (o = f(NaN), e = 3, (n | 0) == 2141891242) break i;
                      if ((n | 0) != 2140081935) break r;
                      o = f(0), e = 1;
                      break i;
                    }

                    e = 2;
                    break i;
                  }

                  if (e = 0, t != t) break i;
                  o = (U(2, (n & -1073741825) + 536870912 | 0), j()), e = n & 1073741824 ? 2 : 1;
                }

                i: {
                  r: {
                    if ((u | 0) != 2139156720) {
                      if (t = f(NaN), n = 3, (u | 0) == 2141891242) break i;
                      if ((u | 0) != 2140081935) break r;
                      t = f(0), n = 1;
                      break i;
                    }

                    t = f(0), n = 2;
                    break i;
                  }

                  if (n = 0, R != R) break i;
                  t = (U(2, (u & -1073741825) + 536870912 | 0), j()), n = u & 1073741824 ? 2 : 1;
                }

                if ((n | 0) != (e | 0) | !(!e | o != o & t != t | f(m0(f(o - t))) < f(9999999747378752e-20)) || (n = r + 44 | 0, k = l + 44 | 0, i[n >> 2] != i[k >> 2])) break n;
                e = 0;

                i: {
                  for (;;) {
                    if (u = e, e = e + 1 | 0, (e | 0) == 9) break i;
                    if (A = e << 2, i[A + n >> 2] != i[k + A >> 2]) break;
                  }

                  if (u >>> 0 < 8) break n;
                }

                if (n = r + 80 | 0, k = l + 80 | 0, i[n >> 2] != i[k >> 2]) break n;
                e = 0;

                i: {
                  for (;;) {
                    if (u = e, e = e + 1 | 0, (e | 0) == 9) break i;
                    if (A = e << 2, i[A + n >> 2] != i[k + A >> 2]) break;
                  }

                  if (u >>> 0 < 8) break n;
                }

                if (n = r + 116 | 0, k = l + 116 | 0, i[n >> 2] != i[k >> 2]) break n;
                e = 0;

                i: {
                  for (;;) {
                    if (u = e, e = e + 1 | 0, (e | 0) == 9) break i;
                    if (A = e << 2, i[A + n >> 2] != i[k + A >> 2]) break;
                  }

                  if (u >>> 0 < 8) break n;
                }

                if (n = r + 152 | 0, k = l + 152 | 0, i[n >> 2] != i[k >> 2]) break n;
                e = 0;

                i: {
                  for (;;) {
                    if (u = e, e = e + 1 | 0, (e | 0) == 9) break i;
                    if (A = e << 2, i[A + n >> 2] != i[k + A >> 2]) break;
                  }

                  if (u >>> 0 < 8) break n;
                }

                if (n = r + 188 | 0, k = l + 188 | 0, i[n >> 2] != i[k >> 2]) break n;
                e = 0;

                i: {
                  for (;;) {
                    if (u = e, e = e + 1 | 0, (e | 0) == 3) break i;
                    if (A = e << 2, i[A + n >> 2] != i[k + A >> 2]) break;
                  }

                  if (u >>> 0 < 2) break n;
                }

                for (A = l + 200 | 0, p = r + 200 | 0, e = 0, u = 1;;) {
                  i: {
                    if (e = e << 2, n = i[e + A >> 2], k = i[e + p >> 2], !u) break i;
                    if (u = 0, e = 1, (n | 0) == (k | 0)) continue;
                  }

                  break;
                }

                if ((n | 0) != (k | 0)) break n;

                for (A = l + 208 | 0, p = r + 208 | 0, e = 0, u = 1;;) {
                  i: {
                    if (e = e << 2, n = i[e + A >> 2], k = i[e + p >> 2], !u) break i;
                    if (u = 0, e = 1, (n | 0) == (k | 0)) continue;
                  }

                  break;
                }

                if ((n | 0) != (k | 0)) break n;

                for (A = l + 216 | 0, p = r + 216 | 0, e = 0, u = 1;;) {
                  i: {
                    if (e = e << 2, n = i[e + A >> 2], k = i[e + p >> 2], !u) break i;
                    if (u = 0, e = 1, (n | 0) == (k | 0)) continue;
                  }

                  break;
                }

                if ((n | 0) != (k | 0) || (o = c[l + 28 >> 2], e = o != o, t = c[r + 28 >> 2], (e | 0) == (t == t | 0) | !(e | t != t) & t != o) || (t = c[r + 32 >> 2], o = c[l + 32 >> 2], (t == t | 0) == (o != o | 0) | t == t & t != o) || (o = c[l + 36 >> 2], e = o != o, t = c[r + 36 >> 2], (e | 0) == (t == t | 0) | !e & t != o)) break n;
                if (e = 0, t = c[r + 224 >> 2], t != t && (e = 1, o = c[l + 224 >> 2], o != o) || (o = t, t = c[l + 224 >> 2], o == t | t != t & e)) break e;
              }

              for (Q0(r + 24 | 0, l + 24 | 0, 204);;) {
                if (e = O[r + 4 | 0], e & 4) break e;
                if (V[r + 4 | 0] = e | 4, e = i[r + 20 >> 2], e && Y[e | 0](r), i[r + 308 >> 2] = 2143289344, r = i[r + 552 >> 2], !r) break;
              }
            }
          }

          function w4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0,
                t = 0,
                u = 0,
                k = 0,
                o = 0,
                A = 0,
                l = 0,
                p = 0,
                R = 0,
                I = 0,
                G = 0,
                Z = 0,
                h = 0,
                v = 0,
                N = 0,
                E = 0;
            n = r, r = i[r >> 2] + 7 & -8, i[n >> 2] = r + 16, h = e, l = i[r >> 2], t = i[r + 4 >> 2], e = i[r + 12 >> 2], G = e, o = F - 32 | 0, F = o, e = e & 2147483647, A = e, u = e - 1006698496 | 0, e = e - 1140785152 | 0, n = i[r + 8 >> 2], r = n;

            e: {
              if ((u | 0) == (e | 0) & r >>> 0 < r >>> 0 | e >>> 0 > u >>> 0) {
                if (e = n, n = G << 4 | e >>> 28, r = e << 4 | t >>> 28, e = n, t = t & 268435455, (t | 0) == 134217728 & (l | 0) != 0 | t >>> 0 > 134217728) {
                  e = e + 1073741824 | 0, r = r + 1 | 0, e = r ? e : e + 1 | 0;
                  break e;
                }

                if (e = e + 1073741824 | 0, l | (t | 0) != 134217728) break e;
                t = r & 1, r = t + r | 0, e = r >>> 0 < t >>> 0 ? e + 1 | 0 : e;
                break e;
              }

              if (!(!r & (A | 0) == 2147418112 ? !(t | l) : A >>> 0 < 2147418112)) {
                e = n, n = G << 4 | e >>> 28, r = e << 4 | t >>> 28, e = n & 524287 | 2146959360;
                break e;
              }

              if (r = 0, e = 2146435072, A >>> 0 > 1140785151 || (e = 0, Z = A >>> 16 | 0, Z >>> 0 < 15249)) break e;
              r = l, e = t, u = G & 65535 | 65536, A = u, I = n, k = n, p = Z - 15233 | 0;

              n: {
                if (p & 64) {
                  n = r, u = p + -64 | 0, r = u & 31, (u & 63) >>> 0 >= 32 ? (e = n << r, k = 0) : (e = (1 << r) - 1 & n >>> 32 - r | e << r, k = n << r), u = e, r = 0, e = 0;
                  break n;
                }

                if (!p) break n;
                R = k, k = p & 31, (p & 63) >>> 0 >= 32 ? (n = R << k, k = 0) : (n = (1 << k) - 1 & R >>> 32 - k | u << k, k = R << k), u = n, v = k, R = r, n = 64 - p | 0, k = n & 31, (n & 63) >>> 0 >= 32 ? (n = 0, r = e >>> k | 0) : (n = e >>> k | 0, r = ((1 << k) - 1 & e) << 32 - k | R >>> k), k = v | r, u = n | u, r = p & 31, (p & 63) >>> 0 >= 32 ? (n = R << r, r = 0) : (n = (1 << r) - 1 & R >>> 32 - r | e << r, r = R << r), e = n;
              }

              i[o + 16 >> 2] = r, i[o + 20 >> 2] = e, i[o + 24 >> 2] = k, i[o + 28 >> 2] = u, r = 15361 - Z | 0;

              n: {
                if (r & 64) {
                  t = I, r = r + -64 | 0, e = r & 31, (r & 63) >>> 0 >= 32 ? (n = 0, l = A >>> e | 0) : (n = A >>> e | 0, l = ((1 << e) - 1 & A) << 32 - e | t >>> e), t = n, I = 0, A = 0;
                  break n;
                }

                if (!r) break n;
                u = I, e = 64 - r | 0, n = e & 31, (e & 63) >>> 0 >= 32 ? (e = u << n, k = 0) : (e = (1 << n) - 1 & u >>> 32 - n | A << n, k = u << n), u = l, l = r & 31, (r & 63) >>> 0 >= 32 ? (n = 0, u = t >>> l | 0) : (n = t >>> l | 0, u = ((1 << l) - 1 & t) << 32 - l | u >>> l), l = k | u, t = e | n, u = I, n = r & 31, (r & 63) >>> 0 >= 32 ? (e = 0, I = A >>> n | 0) : (e = A >>> n | 0, I = ((1 << n) - 1 & A) << 32 - n | u >>> n), A = e;
              }

              if (i[o >> 2] = l, i[o + 4 >> 2] = t, i[o + 8 >> 2] = I, i[o + 12 >> 2] = A, r = i[o + 8 >> 2], e = i[o + 12 >> 2] << 4 | r >>> 28, r = r << 4, n = i[o >> 2], A = i[o + 4 >> 2], r = A >>> 28 | r, t = A & 268435455, n = n | (i[o + 16 >> 2] | i[o + 24 >> 2] | (i[o + 20 >> 2] | i[o + 28 >> 2])) != 0, (t | 0) == 134217728 & (n | 0) != 0 | t >>> 0 > 134217728) {
                r = r + 1 | 0, e = r ? e : e + 1 | 0;
                break e;
              }

              if (n | (t | 0) != 134217728) break e;
              n = r, r = r + (r & 1) | 0, e = n >>> 0 > r >>> 0 ? e + 1 | 0 : e;
            }

            F = o + 32 | 0, U(0, r | 0), U(1, G & -2147483648 | e), N = h, E = +H0(), v0[N >> 3] = E;
          }

          function z2(e, r, n, t, u, k, o, A, l, p, R, I, G, Z) {
            var h = f(0),
                v = 0,
                N = 0,
                E = 0,
                W = f(0),
                T = 0,
                _ = 0,
                L = 0,
                C = f(0);

            e: {
              if (!(i[e + 312 >> 2] != (Z | 0) && O[e + 4 | 0] & 4) && (T = 0, i[e + 316 >> 2] == (t | 0))) break e;
              i[e + 540 >> 2] = -1082130432, i[e + 544 >> 2] = -1082130432, i[e + 532 >> 2] = 0, i[e + 536 >> 2] = 0, i[e + 524 >> 2] = -1082130432, i[e + 528 >> 2] = -1082130432, i[e + 320 >> 2] = 0, T = 1;
            }

            _ = G + 1 | 0;

            e: {
              n: {
                i: {
                  r: {
                    if (i[e + 8 >> 2]) {
                      if (W = b(e, 2, o), C = k0(e, 2, o), h = f(b(e, 0, o) + k0(e, 0, o)), G = e + 524 | 0, W = f(W + C), p1(u, r, k, n, i[e + 532 >> 2], c[G >> 2], i[e + 536 >> 2], c[e + 528 >> 2], c[e + 540 >> 2], c[e + 544 >> 2], W, h, R)) break i;
                      if (N = i[e + 320 >> 2], !N) break r;

                      for (v = e + 324 | 0;;) {
                        if (G = v + w0(E, 24) | 0, p1(u, r, k, n, i[G + 8 >> 2], c[G >> 2], i[G + 12 >> 2], c[G + 4 >> 2], c[G + 16 >> 2], c[G + 20 >> 2], W, h, R)) break i;
                        if (E = E + 1 | 0, (N | 0) == (E | 0)) break;
                      }

                      break r;
                    }

                    if (!l) {
                      if (L = i[e + 320 >> 2], !L) break r;

                      for (N = e + 324 | 0;;) {
                        v = w0(E, 24), G = v + N | 0, h = c[G >> 2];

                        t: {
                          f: {
                            if (!(h != h | r != r)) {
                              if (f(m0(f(h - r))) < f(9999999747378752e-20)) break f;
                              break t;
                            }

                            if (h == h | r == r) break t;
                          }

                          v = N + v | 0, h = c[v + 4 >> 2];

                          f: {
                            if (!(h != h | n != n)) {
                              if (f(m0(f(h - n))) < f(9999999747378752e-20)) break f;
                              break t;
                            }

                            if (h == h | n == n) break t;
                          }

                          if (i[v + 8 >> 2] != (u | 0)) break t;
                          if (i[v + 12 >> 2] == (k | 0)) break i;
                        }

                        if (E = E + 1 | 0, (L | 0) == (E | 0)) break;
                      }

                      break r;
                    }

                    G = e + 524 | 0, h = c[G >> 2];

                    t: {
                      if (!(h != h | r != r)) {
                        if (f(m0(f(h - r))) < f(9999999747378752e-20)) break t;
                        break r;
                      }

                      if (h == h | r == r) break r;
                    }

                    v = i[e + 532 >> 2] == (u | 0) && i[e + 536 >> 2] == (k | 0) ? G : 0, h = c[e + 528 >> 2], G = h != h, N = n != n;

                    t: {
                      if (G | N) {
                        G = G & N;
                        break t;
                      }

                      G = f(m0(f(h - n))) < f(9999999747378752e-20);
                    }

                    G = G ? v : 0;
                    break i;
                  }

                  a1(e, r, n, t, u, k, o, A, l, R, I, _, Z, p), i[e + 316 >> 2] = t;
                  break n;
                }

                if (!(!G | T)) {
                  c[e + 516 >> 2] = c[G + 16 >> 2], c[e + 520 >> 2] = c[G + 20 >> 2], t = (l ? 12 : 16) + I | 0, i[t >> 2] = i[t >> 2] + 1, t = 0;
                  break e;
                }

                if (a1(e, r, n, t, u, k, o, A, l, R, I, _, Z, p), i[e + 316 >> 2] = t, t = 1, G) break e;
              }

              G = i[e + 320 >> 2], t = G + 1 | 0, t >>> 0 > u1[I + 8 >> 2] && (i[I + 8 >> 2] = t), (G | 0) == 8 && (i[e + 320 >> 2] = 0, G = 0), l ? t = e + 524 | 0 : (i[e + 320 >> 2] = G + 1, t = (w0(G, 24) + e | 0) + 324 | 0), i[t + 12 >> 2] = k, i[t + 8 >> 2] = u, c[t + 4 >> 2] = n, c[t >> 2] = r, c[t + 16 >> 2] = c[e + 516 >> 2], c[t + 20 >> 2] = c[e + 520 >> 2], t = 1;
            }

            e: {
              if (!l || (u = i[e + 520 >> 2], i[e + 244 >> 2] = i[e + 516 >> 2], i[e + 248 >> 2] = u, u = O[e + 4 | 0], k = u | 1, V[e + 4 | 0] = k, !(u & 4))) break e;
              V[e + 4 | 0] = k & 251;
            }

            return i[e + 312 >> 2] = Z, t;
          }

          function vr(e) {
            e = e | 0;
            var r = 0,
                n = 0,
                t = 0,
                u = 0,
                k = 0,
                o = 0,
                A = 0,
                l = 0,
                p = 0,
                R = 0,
                I = 0;
            A = 8;

            e: {
              if (e >>> 0 > 4294967239) break e;

              n: {
                for (;;) {
                  A = A >>> 0 <= 8 ? 8 : A, r = i[1715], k = r, u = i[1714], e = e >>> 0 <= 8 ? 8 : e + 3 & -4;

                  i: {
                    if (e >>> 0 <= 127) {
                      o = (e >>> 3 | 0) - 1 | 0;
                      break i;
                    }

                    if (t = i2(e), o = ((e >>> 29 - t ^ 4) - (t << 2) | 0) + 110 | 0, e >>> 0 <= 4095) break i;
                    t = ((e >>> 30 - t ^ 2) - (t << 1) | 0) + 71 | 0, o = t >>> 0 >= 63 ? 63 : t;
                  }

                  if (n = o & 31, (o & 63) >>> 0 >= 32 ? (t = 0, r = r >>> n | 0) : (t = r >>> n | 0, r = ((1 << n) - 1 & r) << 32 - n | u >>> n), r | t) {
                    for (;;) {
                      u = t;

                      i: {
                        if (r | t) {
                          n = t - 1 | 0, l = n + 1 | 0, k = n, n = r - 1 | 0, k = (n | 0) != -1 ? l : k, t = i2(t ^ k), t = (t | 0) == 32 ? i2(r ^ n) + 32 | 0 : t, n = 63 - t | 0, z0 = 0 - (t >>> 0 > 63) | 0;
                          break i;
                        }

                        z0 = 0, n = 64;
                      }

                      k = n, n = k & 31, (k & 63) >>> 0 >= 32 ? (t = 0, r = u >>> n | 0) : (t = u >>> n | 0, r = ((1 << n) - 1 & u) << 32 - n | r >>> n), l = r, o = k + o | 0, n = o << 4, r = i[n + 5832 >> 2], k = n + 5824 | 0;

                      i: {
                        if ((r | 0) != (k | 0)) {
                          if (u = mr(r, A, e), u) break e;
                          u = i[r + 4 >> 2], i[u + 8 >> 2] = i[r + 8 >> 2], i[i[r + 8 >> 2] + 4 >> 2] = u, i[r + 8 >> 2] = k, u = n + 5828 | 0, i[r + 4 >> 2] = i[u >> 2], i[u >> 2] = r, i[i[r + 4 >> 2] + 8 >> 2] = r, o = o + 1 | 0, r = (t & 1) << 31 | l >>> 1, t = t >>> 1 | 0;
                          break i;
                        }

                        p = i[1715], k = o & 63, r = k, u = r & 31, r >>> 0 >= 32 ? (r = 0, n = -1 >>> u | 0) : (r = -1 >>> u | 0, n = r | (1 << u) - 1 << 32 - u), n = n & -2, u = k & 31, k >>> 0 >= 32 ? (r = n << u, n = 0) : (r = (1 << u) - 1 & n >>> 32 - u | r << u, n = n << u), R = n, u = r, k = 0 - o & 63, n = k, r = n & 31, n >>> 0 >= 32 ? (r = -1 << r, n = 0) : (n = -1 << r, r = n | (1 << r) - 1 & -1 >>> 32 - r), I = n & -2, n = k & 31, k >>> 0 >= 32 ? (k = 0, r = r >>> n | 0) : (k = r >>> n | 0, r = ((1 << n) - 1 & r) << 32 - n | I >>> n), r = r | R, z0 = u | k, i[1714] = i[1714] & r, i[1715] = z0 & p, r = l ^ 1;
                      }

                      if (!(r | t)) break;
                    }

                    k = i[1715], u = i[1714];
                  }

                  i: {
                    if (u | k) {
                      t = i2(k), n = 63 - ((t | 0) == 32 ? i2(u) + 32 | 0 : t) | 0, r = n << 4, t = i[r + 5832 >> 2];

                      r: {
                        if (!k & u >>> 0 < 1073741824 || (o = 99, r = r + 5824 | 0, (r | 0) == (t | 0))) break r;

                        for (;;) {
                          if (!o) break r;
                          if (u = mr(t, A, e), u) break e;
                          if (o = o - 1 | 0, t = i[t + 8 >> 2], (r | 0) == (t | 0)) break;
                        }

                        t = r;
                      }

                      if (Nr(e + 48 | 0)) break i;
                      if (!t || (r = (n << 4) + 5824 | 0, (r | 0) == (t | 0))) break n;

                      for (;;) {
                        if (u = mr(t, A, e), u) break e;
                        if (t = i[t + 8 >> 2], (r | 0) == (t | 0)) break;
                      }

                      break n;
                    }

                    if (!Nr(e + 48 | 0)) break n;
                  }

                  if (u = 0, A - 1 & A) break e;
                  if (!(e >>> 0 <= 4294967239)) break;
                }

                break e;
              }

              u = 0;
            }

            return u | 0;
          }

          function p4(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0;
            var t = 0,
                u = 0,
                k = 0,
                o = 0,
                A = 0,
                l = 0,
                p = 0,
                R = 0,
                I = 0,
                G = 0;
            A = F - 80 | 0, F = A, e = i[e >> 2];

            e: {
              n: {
                if (l = i[r >> 2], !i[l + 552 >> 2]) {
                  if (i[e + 8 >> 2]) break n;
                  r = i[e + 556 >> 2], o = r + (n << 2) | 0, t = i[e + 560 >> 2], u = e + 564 | 0, k = i[u >> 2];

                  i: {
                    if (t >>> 0 < k >>> 0) {
                      if ((t | 0) == (o | 0)) {
                        i[o >> 2] = l, i[e + 560 >> 2] = o + 4;
                        break i;
                      }

                      if (n = t, r = t - 4 | 0, t >>> 0 > r >>> 0) for (; i[n >> 2] = i[r >> 2], n = n + 4 | 0, r = r + 4 | 0, t >>> 0 > r >>> 0;) {
                      }
                      i[e + 560 >> 2] = n, r = o + 4 | 0, (r | 0) != (t | 0) && (r = t - r | 0, d2(t - (r & -4) | 0, o, r)), i[o >> 2] = l;
                      break i;
                    }

                    if (t = (t - r >> 2) + 1 | 0, t >>> 0 >= 1073741824) break e;
                    r = k - r | 0, k = r >>> 1 | 0, u = me(A + 32 | 0, r >>> 0 >= 2147483644 ? 1073741823 : t >>> 0 < k >>> 0 ? k : t, n, u), n = i[u + 8 >> 2];

                    r: {
                      if ((n | 0) != i[u + 12 >> 2]) break r;

                      if (r = i[u + 4 >> 2], t = i[u >> 2], r >>> 0 > t >>> 0) {
                        t = ((r - t >> 2) + 1 | 0) / -2 << 2, p = t + r | 0, k = r, r = n - r | 0, n = d2(p, k, r) + r | 0, i[u + 8 >> 2] = n, i[u + 4 >> 2] = t + i[u + 4 >> 2];
                        break r;
                      }

                      r = (n | 0) == (t | 0) ? 1 : n - t >> 1, k = me(A + 56 | 0, r, r >>> 2 | 0, i[u + 16 >> 2]), t = i[k + 8 >> 2], r = i[u + 4 >> 2], n = i[u + 8 >> 2];

                      t: {
                        if ((r | 0) == (n | 0)) {
                          n = t, t = r;
                          break t;
                        }

                        for (n = (n - r | 0) + t | 0; i[t >> 2] = i[r >> 2], r = r + 4 | 0, t = t + 4 | 0, (t | 0) != (n | 0);) {
                        }

                        r = i[u + 8 >> 2], t = i[u + 4 >> 2];
                      }

                      if (p = i[u >> 2], i[u >> 2] = i[k >> 2], i[k >> 2] = p, i[u + 4 >> 2] = i[k + 4 >> 2], i[k + 4 >> 2] = t, i[u + 8 >> 2] = n, i[k + 8 >> 2] = r, R = i[u + 12 >> 2], i[u + 12 >> 2] = i[k + 12 >> 2], i[k + 12 >> 2] = R, (r | 0) != (t | 0) && (i[k + 8 >> 2] = ((t - r | 0) + 3 & -4) + r), !p) break r;
                      L0(p), n = i[u + 8 >> 2];
                    }

                    if (i[n >> 2] = l, i[u + 8 >> 2] = i[u + 8 >> 2] + 4, r = i[e + 556 >> 2], n = o - r | 0, I = u, G = d2(i[u + 4 >> 2] - n | 0, r, n), i[I + 4 >> 2] = G, t = i[e + 560 >> 2] - o | 0, o = d2(i[u + 8 >> 2], o, t), r = i[e + 556 >> 2], i[e + 556 >> 2] = i[u + 4 >> 2], i[u + 4 >> 2] = r, n = i[e + 560 >> 2], i[e + 560 >> 2] = t + o, i[u + 8 >> 2] = n, t = i[e + 564 >> 2], i[e + 564 >> 2] = i[u + 12 >> 2], i[u >> 2] = r, i[u + 12 >> 2] = t, (r | 0) != (n | 0) && (i[u + 8 >> 2] = n + ((r - n | 0) + 3 & -4)), !r) break i;
                    L0(r);
                  }

                  for (i[l + 552 >> 2] = e; r = O[e + 4 | 0], !!(!(r & 4) && (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], e));) {
                  }

                  F = A + 80 | 0;
                  return;
                }

                i[A + 16 >> 2] = 3946, n2(e, A + 16 | 0), r2(), A0();
              }

              i[A >> 2] = 4079, n2(e, A), r2(), A0();
            }

            ie(), A0();
          }

          function y0(e, r, n, t) {
            var u = f(0),
                k = f(0),
                o = 0,
                A = f(0);

            e: {
              n: {
                i: {
                  r: {
                    t: {
                      f: {
                        if (r >>> 0 <= 1) {
                          k = c[e + 212 >> 2], r = i[e + 212 >> 2];

                          u: {
                            if ((r | 0) == 2139156720) break u;
                            if ((r | 0) == 2140081935) break f;
                            o = 4216;

                            k: {
                              if ((r | 0) != 2141891242) {
                                if (k == k) break k;
                                o = 4208;
                              }

                              switch (u = c[o >> 2], k = f(NaN), i[o + 4 >> 2] - 1 | 0) {
                                case 0:
                                  break f;

                                case 1:
                                  break u;

                                default:
                                  break t;
                              }
                            }

                            if (u = (U(2, (r & -1073741825) + 536870912 | 0), j()), !(r & 1073741824)) break f;
                          }

                          k = f(f(u * t) * f(.009999999776482582));
                          break t;
                        }

                        k = c[e + 208 >> 2];

                        u: {
                          k: {
                            r = i[e + 208 >> 2];

                            o: {
                              if ((r | 0) == 2139156720) break o;
                              if ((r | 0) == 2140081935) break k;
                              o = 4216;

                              A: {
                                if ((r | 0) != 2141891242) {
                                  if (k == k) break A;
                                  o = 4208;
                                }

                                switch (u = c[o >> 2], k = f(NaN), i[o + 4 >> 2] - 1 | 0) {
                                  case 0:
                                    break k;

                                  case 1:
                                    break o;

                                  default:
                                    break u;
                                }
                              }

                              if (u = (U(2, (r & -1073741825) + 536870912 | 0), j()), !(r & 1073741824)) break k;
                            }

                            k = f(f(u * t) * f(.009999999776482582));
                            break u;
                          }

                          k = u;
                        }

                        u = f(0), A = c[e + 216 >> 2], e = i[e + 216 >> 2];

                        u: {
                          if ((e | 0) == 2139156720) break u;
                          if ((e | 0) == 2140081935) break i;
                          r = 4216;

                          k: {
                            if ((e | 0) != 2141891242) {
                              if (A == A) break k;
                              r = 4208;
                            }

                            switch (u = c[r >> 2], i[r + 4 >> 2] - 1 | 0) {
                              case 1:
                                break u;

                              case 0:
                                break r;

                              default:
                                break n;
                            }
                          }

                          if (u = (U(2, (e & -1073741825) + 536870912 | 0), j()), !(e & 1073741824)) break r;
                        }

                        u = f(f(u * t) * f(.009999999776482582));
                        break r;
                      }

                      k = u;
                    }

                    u = f(0), A = c[e + 220 >> 2], e = i[e + 220 >> 2];

                    t: {
                      if ((e | 0) == 2139156720) break t;
                      if ((e | 0) == 2140081935) break i;
                      r = 4216;

                      f: {
                        if ((e | 0) != 2141891242) {
                          if (A == A) break f;
                          r = 4208;
                        }

                        switch (u = c[r >> 2], i[r + 4 >> 2] - 1 | 0) {
                          case 1:
                            break t;

                          case 0:
                            break r;

                          default:
                            break n;
                        }
                      }

                      if (u = (U(2, (e & -1073741825) + 536870912 | 0), j()), !(e & 1073741824)) break r;
                    }

                    u = f(f(u * t) * f(.009999999776482582));
                  }

                  if (!(u >= f(0))) break n;
                }

                if (n > u) break e;
              }

              if (!(k >= f(0))) return n;
              u = n < k ? k : n;
            }

            return u;
          }

          function wr(e, r) {
            var n = 0,
                t = 0;

            for (i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, W0[e + 4 >> 1] = 1, i[e >> 2] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 36 >> 2] = 2143289344, i[e + 40 >> 2] = 2141891242, i[e + 28 >> 2] = 2143289344, i[e + 32 >> 2] = 2143289344, t = j0(e + 44 | 0, 0, 36); i[t + (n << 2) >> 2] = 2143289344, n = n + 1 | 0, (n | 0) != 9;) {
            }

            for (n = 0, t = j0(e + 80 | 0, 0, 36); i[t + (n << 2) >> 2] = 2143289344, n = n + 1 | 0, (n | 0) != 9;) {
            }

            for (n = 0, t = j0(e + 116 | 0, 0, 36); i[t + (n << 2) >> 2] = 2143289344, n = n + 1 | 0, (n | 0) != 9;) {
            }

            for (n = 0, t = j0(e + 152 | 0, 0, 36); i[t + (n << 2) >> 2] = 2143289344, n = n + 1 | 0, (n | 0) != 9;) {
            }

            for (n = 0, i[e + 196 >> 2] = 0, t = e + 188 | 0, i[t >> 2] = 0, i[t + 4 >> 2] = 0; i[t + (n << 2) >> 2] = 2143289344, n = n + 1 | 0, (n | 0) != 3;) {
            }

            for (i[e + 24 >> 2] = 4224, i[e + 224 >> 2] = 2143289344, i[e + 216 >> 2] = 2143289344, i[e + 220 >> 2] = 2143289344, i[e + 208 >> 2] = 2143289344, i[e + 212 >> 2] = 2143289344, i[e + 200 >> 2] = 2141891242, i[e + 204 >> 2] = 2141891242, j0(e + 228 | 0, 0, 288), i[e + 244 >> 2] = 2143289344, i[e + 248 >> 2] = 2143289344, j0(e + 252 | 0, 0, 49), i[e + 308 >> 2] = 2143289344, t = e + 516 | 0, n = e + 324 | 0; i[n + 16 >> 2] = -1082130432, i[n + 20 >> 2] = -1082130432, i[n + 8 >> 2] = 0, i[n + 12 >> 2] = 0, i[n >> 2] = -1082130432, i[n + 4 >> 2] = -1082130432, n = n + 24 | 0, (t | 0) != (n | 0);) {
            }

            return i[e + 548 >> 2] = 0, i[e + 552 >> 2] = 0, i[e + 516 >> 2] = 2143289344, i[e + 520 >> 2] = 2143289344, i[e + 572 >> 2] = 2143289344, i[e + 576 >> 2] = 0, i[e + 568 >> 2] = r, i[e + 540 >> 2] = -1082130432, i[e + 544 >> 2] = -1082130432, i[e + 532 >> 2] = 0, i[e + 536 >> 2] = 0, i[e + 524 >> 2] = -1082130432, i[e + 528 >> 2] = -1082130432, i[e + 556 >> 2] = 0, i[e + 560 >> 2] = 0, i[e + 564 >> 2] = 0, i[e + 580 >> 2] = 2143289344, i[e + 584 >> 2] = 0, O[r + 10 | 0] && (i[e + 24 >> 2] = 4616, V[e + 4 | 0] = O[e + 4 | 0] | 128), e;
          }

          function v1(e) {
            var r = 0,
                n = 0,
                t = f(0),
                u = f(0),
                k = f(0),
                o = 0,
                A = 0,
                l = 0,
                p = 0,
                R = 0,
                I = 0,
                G = 0,
                Z = 0,
                h = 0;

            for (o = F - 16 | 0, i[o + 8 >> 2] = 0, i[o + 12 >> 2] = 1, R = e + 200 | 0, I = e + 572 | 0, G = e + 208 | 0, Z = e + 216 | 0, e = 0;;) {
              h = e, p = i[(o + 8 | 0) + (e << 2) >> 2], A = p << 2, e = Z + A | 0, t = c[e >> 2];

              e: {
                n: {
                  i: {
                    r: {
                      t: {
                        f: {
                          if (r = i[e >> 2], l = (r | 0) == 2139156720, !(l | (r | 0) == 2140081935 | (r | 0) == 2141891242) & t != t) break f;
                          e = A + G | 0, u = c[e >> 2], n = i[e >> 2];

                          u: {
                            k: {
                              if ((n | 0) != 2139156720) {
                                if (k = f(NaN), e = 3, (n | 0) == 2141891242) break u;
                                if ((n | 0) != 2140081935) break k;
                                k = f(0), e = 1;
                                break u;
                              }

                              k = f(0), e = 2;
                              break u;
                            }

                            if (e = 0, u != u) break u;
                            k = (U(2, (n & -1073741825) + 536870912 | 0), j()), e = n & 1073741824 ? 2 : 1;
                          }

                          n = e;

                          u: {
                            k: {
                              if (!l) {
                                if (u = f(NaN), e = 3, (r | 0) == 2141891242) break u;
                                if ((r | 0) != 2140081935) break k;
                                u = f(0), e = 1;
                                break u;
                              }

                              u = f(0), e = 2;
                              break u;
                            }

                            if (e = 0, t != t) break u;
                            u = (U(2, (r & -1073741825) + 536870912 | 0), j()), e = r & 1073741824 ? 2 : 1;
                          }

                          if ((n | 0) != (e | 0) | !(!e | u != u & k != k | f(m0(f(u - k))) < f(9999999747378752e-20))) break f;
                          if (e = 0, l) break t;
                          if ((r | 0) == 2140081935) break n;
                          if ((r | 0) == 2141891242) break i;
                          if (t != t) break r;
                          e = (r & -1073741825) + 536870912 | 0, r = r & 1073741824 ? 2 : 1;
                          break e;
                        }

                        if (e = 0, r = A + R | 0, t = c[r >> 2], r = i[r >> 2], (r | 0) == 2139156720) break t;
                        if ((r | 0) == 2140081935) break n;
                        if ((r | 0) == 2141891242) break i;
                        if (t != t) break r;
                        e = (r & -1073741825) + 536870912 | 0, r = r & 1073741824 ? 2 : 1;
                        break e;
                      }

                      r = 2;
                      break e;
                    }

                    e = 2143289344, r = 0;
                    break e;
                  }

                  e = 2143289344, r = 3;
                  break e;
                }

                r = 1;
              }

              if (n = (p << 3) + I | 0, i[n + 4 >> 2] = r, i[n >> 2] = e, e = 1, !!(h & 1)) break;
            }
          }

          function Q0(e, r, n) {
            var t = 0,
                u = 0,
                k = 0;
            if (n >>> 0 >= 512) return k4(e | 0, r | 0, n | 0), e;
            u = e + n | 0;

            e: {
              if (!((e ^ r) & 3)) {
                n: {
                  if (!(e & 3)) {
                    n = e;
                    break n;
                  }

                  if (!n) {
                    n = e;
                    break n;
                  }

                  for (n = e;;) {
                    if (V[n | 0] = O[r | 0], r = r + 1 | 0, n = n + 1 | 0, !(n & 3)) break n;
                    if (!(n >>> 0 < u >>> 0)) break;
                  }
                }

                t = u & -4;

                n: {
                  if (t >>> 0 < 64 || (k = t + -64 | 0, k >>> 0 < n >>> 0)) break n;

                  for (; i[n >> 2] = i[r >> 2], i[n + 4 >> 2] = i[r + 4 >> 2], i[n + 8 >> 2] = i[r + 8 >> 2], i[n + 12 >> 2] = i[r + 12 >> 2], i[n + 16 >> 2] = i[r + 16 >> 2], i[n + 20 >> 2] = i[r + 20 >> 2], i[n + 24 >> 2] = i[r + 24 >> 2], i[n + 28 >> 2] = i[r + 28 >> 2], i[n + 32 >> 2] = i[r + 32 >> 2], i[n + 36 >> 2] = i[r + 36 >> 2], i[n + 40 >> 2] = i[r + 40 >> 2], i[n + 44 >> 2] = i[r + 44 >> 2], i[n + 48 >> 2] = i[r + 48 >> 2], i[n + 52 >> 2] = i[r + 52 >> 2], i[n + 56 >> 2] = i[r + 56 >> 2], i[n + 60 >> 2] = i[r + 60 >> 2], r = r - -64 | 0, n = n - -64 | 0, k >>> 0 >= n >>> 0;) {
                  }
                }

                if (n >>> 0 >= t >>> 0) break e;

                for (; i[n >> 2] = i[r >> 2], r = r + 4 | 0, n = n + 4 | 0, t >>> 0 > n >>> 0;) {
                }

                break e;
              }

              if (u >>> 0 < 4) {
                n = e;
                break e;
              }

              if (t = u - 4 | 0, t >>> 0 < e >>> 0) {
                n = e;
                break e;
              }

              for (n = e; V[n | 0] = O[r | 0], V[n + 1 | 0] = O[r + 1 | 0], V[n + 2 | 0] = O[r + 2 | 0], V[n + 3 | 0] = O[r + 3 | 0], r = r + 4 | 0, n = n + 4 | 0, t >>> 0 >= n >>> 0;) {
              }
            }

            if (n >>> 0 < u >>> 0) for (; V[n | 0] = O[r | 0], r = r + 1 | 0, n = n + 1 | 0, (u | 0) != (n | 0);) {
            }
            return e;
          }

          function w1(e, r, n, t, u) {
            var k = f(0),
                o = 0,
                A = f(0),
                l = f(0),
                p = 0,
                R = 0,
                I = f(0),
                G = f(0),
                Z = 0;

            if (A = f(n - t), R = A != A, !R) {
              n = f(0), o = (r << 2) + e | 0, k = c[o + 208 >> 2];

              e: {
                n: {
                  o = i[o + 208 >> 2];

                  i: {
                    r: {
                      if ((o | 0) == 2139156720) break r;
                      if ((o | 0) == 2140081935) break n;
                      p = 4216;

                      t: {
                        if ((o | 0) != 2141891242) {
                          if (k == k) break t;
                          p = 4208;
                        }

                        switch (n = c[p >> 2], i[p + 4 >> 2] - 1 | 0) {
                          case 0:
                            break i;

                          case 1:
                            break r;

                          default:
                            break e;
                        }
                      }

                      if (n = (U(2, (o & -1073741825) + 536870912 | 0), j()), !(o & 1073741824)) break i;
                    }

                    n = f(f(n * u) * f(.009999999776482582));
                  }

                  if (n == n) break n;
                  break e;
                }

                l = f(n - t);
              }

              n = f(0), e = (r << 2) + e | 0, k = c[e + 216 >> 2];

              e: {
                n: {
                  r = i[e + 216 >> 2];

                  i: {
                    r: {
                      if ((r | 0) == 2139156720) break r;
                      if ((r | 0) == 2140081935) break n;
                      e = 4216;

                      t: {
                        if ((r | 0) != 2141891242) {
                          if (k == k) break t;
                          e = 4208;
                        }

                        switch (n = c[e >> 2], k = f(34028234663852886e22), i[e + 4 >> 2] - 1 | 0) {
                          case 0:
                            break i;

                          case 1:
                            break r;

                          default:
                            break e;
                        }
                      }

                      if (n = (U(2, (r & -1073741825) + 536870912 | 0), j()), !(r & 1073741824)) break i;
                    }

                    n = f(f(n * u) * f(.009999999776482582));
                  }

                  if (n == n) break n;
                  k = f(34028234663852886e22);
                  break e;
                }

                k = f(n - t);
              }

              if (n = (I = A, G = Rr(A, k), Z = k != k | R, Z ? I : G), e = n != n, !(e | l != l)) return $(n, l);
              A = e ? l : n;
            }

            return A;
          }

          function p1(e, r, n, t, u, k, o, A, l, p, R, I, G) {
            var Z = f(0),
                h = f(0),
                v = 0,
                N = 0,
                E = f(0),
                W = f(0),
                T = f(0),
                _ = 0,
                L = 0;
            if (l < f(0) | p < f(0)) e = 0;else {
              E = k, W = r, T = t, h = A;

              e: {
                if (!G || (Z = c[G + 16 >> 2], h = A, Z == f(0))) break e;
                _ = +Z, W = h2(+r, _, 0, 0), T = h2(+t, _, 0, 0), E = h2(+k, _, 0, 0), h = h2(+A, _, 0, 0);
              }

              Z = h, G = 0;

              e: {
                if ((e | 0) != (u | 0)) break e;

                if (L = E != E, G = W != W, L | G) {
                  G = G & L;
                  break e;
                }

                G = f(m0(f(E - W))) < f(9999999747378752e-20);
              }

              L = G;

              e: {
                if ((n | 0) != (o | 0)) break e;

                if (v = Z != Z, G = T != T, v | G) {
                  v = G & v;
                  break e;
                }

                v = f(m0(f(Z - T))) < f(9999999747378752e-20);
              }

              N = 1, G = 1;

              e: {
                if (L) break e;
                r = f(r - R);

                n: {
                  if ((e | 0) == 1) break n;

                  if (e = (e | 0) != 2, !(e | u)) {
                    if (!(r >= l)) break n;
                    break e;
                  }

                  if (G = 0, !(r < k) | (e | (u | 0) != 2 | (r != r | k != k | l != l)) || (G = 1, r >= l)) break e;
                }

                if (u = r != r, e = l != l, u | e) {
                  G = e & u;
                  break e;
                }

                G = f(m0(f(r - l))) < f(9999999747378752e-20);
              }

              e: {
                if (v) break e;
                r = f(t - I);

                n: {
                  if ((n | 0) == 1) break n;

                  if (e = (n | 0) != 2, !(e | o)) {
                    if (!(r >= p)) break n;
                    break e;
                  }

                  if (N = 0, !(r < A) | (e | (o | 0) != 2 | (r != r | A != A | p != p)) || (N = 1, r >= p)) break e;
                }

                if (n = r != r, e = p != p, n | e) {
                  N = e & n;
                  break e;
                }

                N = f(m0(f(r - p))) < f(9999999747378752e-20);
              }

              e = G & N;
            }
            return e;
          }

          function pr(e) {
            var r = 0,
                n = 0,
                t = 0,
                u = 0,
                k = 0,
                o = 0,
                A = 0,
                l = 0;
            if (D0(+e), k = e0(1) | 0, t = e0(0) | 0, u = k >>> 20 & 2047, (u | 0) == 2047) return e = e * 1, e / e;
            if (r = t << 1, o = k << 1 | t >>> 31, !r & (o | 0) == 2145386496 | o >>> 0 < 2145386496) return !r & (o | 0) == 2145386496 ? e * 0 : e;

            e: {
              if (!u) {
                if (u = 0, n = t << 12, r = k << 12 | t >>> 20, (r | 0) > 0 | (r | 0) >= 0) for (; u = u - 1 | 0, r = r << 1 | n >>> 31, n = n << 1, !!((r | 0) > 0 | (r | 0) >= 0);) {
                }
                r = 1 - u | 0, n = r & 31, (r & 63) >>> 0 >= 32 ? (r = t << n, t = 0) : (r = (1 << n) - 1 & t >>> 32 - n | k << n, t = t << n);
                break e;
              }

              r = k & 1048575 | 1048576;
            }

            if (n = t, (u | 0) > 1023) {
              for (;;) {
                e: {
                  if (t = r + -1048576 | 0, (t | 0) < 0 || (r = t, r | n)) break e;
                  return e * 0;
                }

                if (r = r << 1 | n >>> 31, n = n << 1, u = u - 1 | 0, !((u | 0) > 1023)) break;
              }

              u = 1023;
            }

            e: {
              if (t = r + -1048576 | 0, (t | 0) < 0 || (r = t, r | n)) break e;
              return e * 0;
            }

            if ((r | 0) == 1048575 | r >>> 0 < 1048575) for (; u = u - 1 | 0, t = r >>> 0 < 524288, o = r << 1 | n >>> 31, n = n << 1, r = o, !!t;) {
            }
            return l = k & -2147483648, o = r + -1048576 | u << 20, A = n, k = r, A = n, t = 1 - u | 0, n = t & 31, (t & 63) >>> 0 >= 32 ? (r = 0, t = k >>> n | 0) : (r = k >>> n | 0, t = ((1 << n) - 1 & k) << 32 - n | A >>> n), n = (u | 0) > 0, U(0, (n ? A : t) | 0), U(1, (n ? o : r) | l), +H0();
          }

          function Nr(e) {
            var r = 0,
                n = 0,
                t = 0,
                u = 0,
                k = 0;
            t = i[1380], r = e + 7 & -8, n = t + r | 0;

            e: {
              n: {
                if (n >>> 0 <= t >>> 0 && r || n >>> 0 > ui() << 16 >>> 0 && !(u4(n | 0) | 0)) break n;
                i[1380] = n;
                break e;
              }

              i[1745] = 48, t = -1;
            }

            if ((t | 0) != -1) {
              r = e + t | 0, n = r - 16 | 0, i[n + 12 >> 2] = 16, i[n >> 2] = 16, e = i[1712], e ? k = i[e + 8 >> 2] : k = 0;

              e: {
                n: {
                  if ((k | 0) == (t | 0)) {
                    if (u = t - (i[t - 4 >> 2] & -2) | 0, k = i[u - 4 >> 2], i[e + 8 >> 2] = r, e = u - (k & -2) | 0, r = -16, !(V[(e + i[e >> 2] | 0) - 4 | 0] & 1)) break n;
                    r = i[e + 4 >> 2], i[r + 8 >> 2] = i[e + 8 >> 2], i[i[e + 8 >> 2] + 4 >> 2] = r, n = n - e | 0, i[e >> 2] = n;
                    break e;
                  }

                  i[t + 12 >> 2] = 16, i[t >> 2] = 16, i[t + 8 >> 2] = r, i[t + 4 >> 2] = e, i[1712] = t, r = 16;
                }

                e = r + t | 0, n = n - e | 0, i[e >> 2] = n;
              }

              i[((n & -4) + e | 0) - 4 >> 2] = n | 1, r = i[e >> 2] - 8 | 0;

              e: {
                if (r >>> 0 <= 127) {
                  n = (r >>> 3 | 0) - 1 | 0;
                  break e;
                }

                if (u = i2(r), n = ((r >>> 29 - u ^ 4) - (u << 2) | 0) + 110 | 0, r >>> 0 <= 4095) break e;
                n = ((r >>> 30 - u ^ 2) - (u << 1) | 0) + 71 | 0, n = n >>> 0 >= 63 ? 63 : n;
              }

              r = n << 4, i[e + 4 >> 2] = r + 5824, r = r + 5832 | 0, i[e + 8 >> 2] = i[r >> 2], i[r >> 2] = e, i[i[e + 8 >> 2] + 4 >> 2] = e, r = i[1714], u = i[1715], e = n & 31, (n & 63) >>> 0 >= 32 ? (n = 1 << e, k = 0) : (k = 1 << e, n = k - 1 & 1 >>> 32 - e), i[1714] = k | r, i[1715] = n | u;
            }

            return (t | 0) != -1;
          }

          function N1(e, r, n) {
            var t = 0,
                u = 0,
                k = 0,
                o = 0,
                A = 0,
                l = 0,
                p = 0,
                R = 0,
                I = 0;

            e: {
              n: {
                i: {
                  r: {
                    t: {
                      f: {
                        u: {
                          k: {
                            o: {
                              A: {
                                if (r) {
                                  if (!n) break A;
                                  break o;
                                }

                                z0 = 0, e = (e >>> 0) / (n >>> 0) | 0;
                                break e;
                              }

                              if (!e) break k;
                              break u;
                            }

                            if (!(n - 1 & n)) break f;
                            k = (i2(n) + 33 | 0) - i2(r) | 0, o = 0 - k | 0;
                            break r;
                          }

                          z0 = 0, e = (r >>> 0) / 0 | 0;
                          break e;
                        }

                        if (t = 32 - i2(r) | 0, t >>> 0 < 31) break t;
                        break i;
                      }

                      if ((n | 0) == 1) break n;
                      k = n ? 31 - i2(n - 1 ^ n) | 0 : 32, n = k & 31, (k & 63) >>> 0 >= 32 ? e = r >>> n | 0 : (t = r >>> n | 0, e = ((1 << n) - 1 & r) << 32 - n | e >>> n), z0 = t;
                      break e;
                    }

                    k = t + 1 | 0, o = 63 - t | 0;
                  }

                  if (t = k & 63, u = t & 31, t >>> 0 >= 32 ? (t = 0, A = r >>> u | 0) : (t = r >>> u | 0, A = ((1 << u) - 1 & r) << 32 - u | e >>> u), o = o & 63, u = o & 31, o >>> 0 >= 32 ? (r = e << u, e = 0) : (r = (1 << u) - 1 & e >>> 32 - u | r << u, e = e << u), k) for (o = n - 1 | 0, I = (o | 0) == -1 ? -1 : 0; l = t << 1 | A >>> 31, t = A << 1 | r >>> 31, u = I - (l + (t >>> 0 > o >>> 0) | 0) >> 31, p = n & u, A = t - p | 0, t = l - (t >>> 0 < p >>> 0) | 0, r = r << 1 | e >>> 31, e = R | e << 1, R = u & 1, k = k - 1 | 0, !!k;) {
                  }
                  z0 = r << 1 | e >>> 31, e = R | e << 1;
                  break e;
                }

                e = 0, r = 0;
              }

              z0 = r;
            }

            return e;
          }

          function N4(e) {
            e = e | 0;
            var r = 0,
                n = 0,
                t = 0,
                u = 0;
            t = F - 624 | 0, F = t, r = i[e + 4 >> 2], i[e + 4 >> 2] = 0, r && Y[i[i[r >> 2] + 4 >> 2]](r), r = i[e + 8 >> 2], i[e + 8 >> 2] = 0, r && Y[i[i[r >> 2] + 4 >> 2]](r);

            e: {
              if (e = i[e >> 2], i[e + 560 >> 2] == i[e + 556 >> 2]) {
                if (i[e + 552 >> 2]) break e;
                V1(e + 556 | 0), u = V[e + 4 | 0], r = wr(t + 32 | 0, i[e + 568 >> 2]), n = i[r + 4 >> 2], i[e >> 2] = i[r >> 2], i[e + 4 >> 2] = n, n = i[r + 20 >> 2], i[e + 16 >> 2] = i[r + 16 >> 2], i[e + 20 >> 2] = n, n = i[r + 12 >> 2], i[e + 8 >> 2] = i[r + 8 >> 2], i[e + 12 >> 2] = n, Q0(e + 24 | 0, r + 24 | 0, 204), Q0(e + 228 | 0, r + 228 | 0, 328), n = i[e + 556 >> 2], n && (i[e + 560 >> 2] = n, L0(n)), i[e + 556 >> 2] = i[r + 556 >> 2], i[e + 560 >> 2] = i[r + 560 >> 2], i[e + 564 >> 2] = i[r + 564 >> 2], i[e + 584 >> 2] = i[r + 584 >> 2], n = i[r + 580 >> 2], i[e + 576 >> 2] = i[r + 576 >> 2], i[e + 580 >> 2] = n, n = i[r + 572 >> 2], i[e + 568 >> 2] = i[r + 568 >> 2], i[e + 572 >> 2] = n, (u | 0) < 0 && (V[e + 4 | 0] = O[e + 4 | 0] | 128, i[e + 24 >> 2] = i[e + 24 >> 2] & -909 | 520), F = t + 624 | 0;
                return;
              }

              i[t + 16 >> 2] = 3192, n2(e, t + 16 | 0), r2(), A0();
            }

            i[t >> 2] = 2046, n2(e, t), r2(), A0();
          }

          function Me(e, r, n) {
            var t = f(0),
                u = f(0);

            e: {
              n: {
                i: {
                  if ((r & -2) == 2) {
                    if (r = i[e + 188 >> 2], t = c[e + 188 >> 2], (r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | t == t || (r = i[e + 196 >> 2], t = c[e + 196 >> 2], (r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | t == t)) break i;
                    break n;
                  }

                  if (r = i[e + 192 >> 2], t = c[e + 192 >> 2], (r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | t == t || (t = c[e + 196 >> 2], r = i[e + 196 >> 2], (r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242)) break i;
                  if (t != t) break n;
                }

                t = f(0);

                i: {
                  r: {
                    if ((r | 0) == 2139156720) break r;
                    if ((r | 0) == 2140081935) break e;
                    e = 4216;

                    t: {
                      if ((r | 0) != 2141891242) {
                        if (t = (U(2, r), j()), t == t) break t;
                        e = 4208;
                      }

                      switch (t = c[e >> 2], u = f(NaN), i[e + 4 >> 2] - 1 | 0) {
                        case 0:
                          break e;

                        case 1:
                          break r;

                        default:
                          break i;
                      }
                    }

                    if (t = (U(2, (r & -1073741825) + 536870912 | 0), j()), !(r & 1073741824)) break e;
                  }

                  u = f(f(t * n) * f(.009999999776482582));
                }

                return u;
              }

              t = f(0);
            }

            return t;
          }

          function m1(e, r) {
            var n = 0,
                t = 0,
                u = 0,
                k = 0,
                o = 0,
                A = 0;

            for (n = F - 320 | 0, F = n, t = j0(n, 0, 288), n = t, i[n + 16 >> 2] = 2143289344, i[n + 20 >> 2] = 2143289344, j0(n + 24 | 0, 0, 49), i[n + 80 >> 2] = 2143289344, k = n + 288 | 0, u = n + 96 | 0; n = u, i[n + 16 >> 2] = -1082130432, i[n + 20 >> 2] = -1082130432, i[n + 8 >> 2] = 0, i[n + 12 >> 2] = 0, i[n >> 2] = -1082130432, i[n + 4 >> 2] = -1082130432, u = n + 24 | 0, (k | 0) != (u | 0);) {
            }

            if (i[t + 312 >> 2] = -1082130432, i[t + 316 >> 2] = -1082130432, i[t + 304 >> 2] = 0, i[t + 308 >> 2] = 0, i[t + 296 >> 2] = -1082130432, i[t + 300 >> 2] = -1082130432, i[t + 288 >> 2] = 2143289344, i[t + 292 >> 2] = 2143289344, Q0(e + 228 | 0, t, 320), i[e + 244 >> 2] = 0, i[e + 248 >> 2] = 0, V[e + 4 | 0] = O[e + 4 | 0] | 1, u = i[e + 556 >> 2], o = i[e + 560 >> 2], (u | 0) != (o | 0)) for (; n = i[u >> 2], i[n + 552 >> 2] != (e | 0) && (k = i[e + 568 >> 2], n = Z1(i[k >> 2], O[k + 8 | 0], n, e, A, r), i[u >> 2] = n, i[n + 552 >> 2] = e, n = i[u >> 2]), m1(n, r), A = A + 1 | 0, u = u + 4 | 0, (o | 0) != (u | 0);) {
            }
            F = t + 320 | 0;
          }

          function mr(e, r, n) {
            var t = 0,
                u = 0,
                k = 0,
                o = 0;

            if (t = e + 4 | 0, u = (t + r | 0) - 1 & 0 - r, r = i[e >> 2], u + n >>> 0 <= (r + e | 0) - 4 >>> 0) {
              k = i[e + 4 >> 2], i[k + 8 >> 2] = i[e + 8 >> 2], i[i[e + 8 >> 2] + 4 >> 2] = k, (t | 0) != (u | 0) && (u = u - t | 0, k = e - (i[e - 4 >> 2] & -2) | 0, t = u + i[k >> 2] | 0, i[k >> 2] = t, i[(k + (t & -4) | 0) - 4 >> 2] = t, e = e + u | 0, r = r - u | 0, i[e >> 2] = r);

              e: {
                if (n + 24 >>> 0 <= r >>> 0) {
                  t = (e + n | 0) + 8 | 0, r = (r - n | 0) - 8 | 0, i[t >> 2] = r, i[(t + (r & -4) | 0) - 4 >> 2] = r | 1, u = i[t >> 2] - 8 | 0;

                  n: {
                    if (u >>> 0 <= 127) {
                      r = (u >>> 3 | 0) - 1 | 0;
                      break n;
                    }

                    if (k = i2(u), r = ((u >>> 29 - k ^ 4) - (k << 2) | 0) + 110 | 0, u >>> 0 <= 4095) break n;
                    r = ((u >>> 30 - k ^ 2) - (k << 1) | 0) + 71 | 0, r = r >>> 0 >= 63 ? 63 : r;
                  }

                  u = r << 4, i[t + 4 >> 2] = u + 5824, u = u + 5832 | 0, i[t + 8 >> 2] = i[u >> 2], i[u >> 2] = t, i[i[t + 8 >> 2] + 4 >> 2] = t, u = i[1714], k = i[1715], t = r & 31, (r & 63) >>> 0 >= 32 ? (r = 1 << t, t = 0) : (o = 1 << t, r = o - 1 & 1 >>> 32 - t, t = o), i[1714] = t | u, i[1715] = r | k, r = n + 8 | 0, i[e >> 2] = r, i[((r & -4) + e | 0) - 4 >> 2] = r;
                  break e;
                }

                i[(e + r | 0) - 4 >> 2] = r;
              }

              e = e + 4 | 0;
            } else e = 0;

            return e;
          }

          function m4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0,
                t = 0,
                u = 0,
                k = 0;
            u = F - 320 | 0, F = u, e = i[e >> 2];

            e: {
              if (i[e + 560 >> 2] == i[e + 556 >> 2] || (t = i[r >> 2], r = i[t + 552 >> 2], !O1(e, t))) break e;

              if ((e | 0) == (r | 0)) {
                for (n = j0(u, 0, 288), r = n, i[r + 16 >> 2] = 2143289344, i[r + 20 >> 2] = 2143289344, j0(r + 24 | 0, 0, 49), i[r + 80 >> 2] = 2143289344, k = r + 288 | 0, r = r + 96 | 0; i[r + 16 >> 2] = -1082130432, i[r + 20 >> 2] = -1082130432, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[r >> 2] = -1082130432, i[r + 4 >> 2] = -1082130432, r = r + 24 | 0, (k | 0) != (r | 0);) {
                }

                i[n + 312 >> 2] = -1082130432, i[n + 316 >> 2] = -1082130432, i[n + 304 >> 2] = 0, i[n + 308 >> 2] = 0, i[n + 296 >> 2] = -1082130432, i[n + 300 >> 2] = -1082130432, i[n + 288 >> 2] = 2143289344, i[n + 292 >> 2] = 2143289344, Q0(t + 228 | 0, n, 320), i[t + 552 >> 2] = 0;
              }

              for (;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }

            F = u + 320 | 0;
          }

          function d2(e, r, n) {
            var t = 0,
                u = 0;

            e: {
              if ((e | 0) == (r | 0)) break e;
              if (u = e + n | 0, r - u >>> 0 <= 0 - (n << 1) >>> 0) return Q0(e, r, n);
              t = (e ^ r) & 3;

              n: {
                i: {
                  if (e >>> 0 < r >>> 0) {
                    if (t) {
                      t = e;
                      break n;
                    }

                    if (!(e & 3)) {
                      t = e;
                      break i;
                    }

                    for (t = e;;) {
                      if (!n) break e;
                      if (V[t | 0] = O[r | 0], r = r + 1 | 0, n = n - 1 | 0, t = t + 1 | 0, !(t & 3)) break;
                    }

                    break i;
                  }

                  r: {
                    if (t) break r;
                    if (u & 3) for (;;) {
                      if (!n) break e;
                      if (n = n - 1 | 0, t = n + e | 0, V[t | 0] = O[r + n | 0], !(t & 3)) break;
                    }
                    if (n >>> 0 <= 3) break r;

                    for (; n = n - 4 | 0, i[n + e >> 2] = i[r + n >> 2], n >>> 0 > 3;) {
                    }
                  }

                  if (!n) break e;

                  for (; n = n - 1 | 0, V[n + e | 0] = O[r + n | 0], !!n;) {
                  }

                  break e;
                }

                if (n >>> 0 <= 3) break n;

                for (; i[t >> 2] = i[r >> 2], r = r + 4 | 0, t = t + 4 | 0, n = n - 4 | 0, n >>> 0 > 3;) {
                }
              }

              if (!n) break e;

              for (; V[t | 0] = O[r | 0], t = t + 1 | 0, r = r + 1 | 0, n = n - 1 | 0, !!n;) {
              }
            }

            return e;
          }

          function y1(e, r, n, t) {
            e: switch (r - 9 | 0) {
              case 0:
                r = i[n >> 2], i[n >> 2] = r + 4, i[e >> 2] = i[r >> 2];
                return;

              case 6:
                r = i[n >> 2], i[n >> 2] = r + 4, r = W0[r >> 1], i[e >> 2] = r, i[e + 4 >> 2] = r >> 31;
                return;

              case 7:
                r = i[n >> 2], i[n >> 2] = r + 4, i[e >> 2] = ee[r >> 1], i[e + 4 >> 2] = 0;
                return;

              case 8:
                r = i[n >> 2], i[n >> 2] = r + 4, r = V[r | 0], i[e >> 2] = r, i[e + 4 >> 2] = r >> 31;
                return;

              case 9:
                r = i[n >> 2], i[n >> 2] = r + 4, i[e >> 2] = O[r | 0], i[e + 4 >> 2] = 0;
                return;

              case 16:
                r = i[n >> 2] + 7 & -8, i[n >> 2] = r + 8, v0[e >> 3] = v0[r >> 3];
                return;

              case 17:
                Y[t | 0](e, n);

              default:
                return;

              case 1:
              case 4:
              case 14:
                r = i[n >> 2], i[n >> 2] = r + 4, r = i[r >> 2], i[e >> 2] = r, i[e + 4 >> 2] = r >> 31;
                return;

              case 2:
              case 5:
              case 11:
              case 15:
                r = i[n >> 2], i[n >> 2] = r + 4, i[e >> 2] = i[r >> 2], i[e + 4 >> 2] = 0;
                return;

              case 3:
              case 10:
              case 12:
              case 13:
                break e;
            }

            r = i[n >> 2] + 7 & -8, i[n >> 2] = r + 8, n = i[r + 4 >> 2], i[e >> 2] = i[r >> 2], i[e + 4 >> 2] = n;
          }

          function E1(e, r, n, t) {
            var u = 0,
                k = 0,
                o = 0,
                A = 0,
                l = 0,
                p = 0,
                R = 0,
                I = 0,
                G = 0,
                Z = 0,
                h = 0,
                v = f(0),
                N = f(0),
                E = f(0),
                W = 0,
                T = f(0);

            e: {
              if (r == 0 || (v = c[e + 248 >> 2], N = c[e + 244 >> 2], E = c[e + 232 >> 2], I = +c[e + 228 >> 2], o = O[e + 4 | 0] & 8, u = o >>> 3 | 0, W = e, T = h2(I, r, 0, u), c[W + 228 >> 2] = T, G = +E, W = e, T = h2(G, r, 0, u), c[W + 232 >> 2] = T, Z = +N, l = pr(Z * r), u = l != l, h = +v, p = pr(h * r), k = p != p, n = I + n, A = m0(l) < 1e-4, A = u | A ? u | !A : !(m0(l + -1) < 1e-4), u = (o | 0) != 0, W = e, T = f(h2(n + Z, r, A & u, u & !A) - h2(n, r, 0, u)), c[W + 244 >> 2] = T, t = G + t, o = m0(p) < 1e-4, k = k | o ? k | !o : !(m0(p + -1) < 1e-4), W = e, T = f(h2(t + h, r, u & k, u & !k) - h2(t, r, 0, u)), c[W + 248 >> 2] = T, u = i[e + 560 >> 2], k = i[e + 556 >> 2], (u | 0) == (k | 0))) break e;

              for (u = u - k >> 2, k = u >>> 0 <= 1 ? 1 : u; u = i[e + 556 >> 2], i[e + 560 >> 2] - u >> 2 >>> 0 > R >>> 0 ? u = i[u + (R << 2) >> 2] : u = 0, E1(u, r, n, t), R = R + 1 | 0, (k | 0) != (R | 0);) {
              }
            }
          }

          function G1() {
            a4(6940, 2958), l4(6941, 2462, 1, 1, 0), Z2(6942, 2139, 1, -128, 127), Z2(6943, 2132, 1, -128, 127), Z2(6944, 2130, 1, 0, 255), Z2(6945, 1286, 2, -32768, 32767), Z2(6946, 1277, 2, 0, 65535), Z2(6947, 1315, 4, -2147483648, 2147483647), Z2(6948, 1306, 4, 0, -1), Z2(6949, 2641, 4, -2147483648, 2147483647), Z2(6950, 2632, 4, 0, -1), $1(6951, 1776, -2147483648, 2147483647), $1(6952, 1775, 0, -1), o1(6953, 1769, 4), o1(6954, 2906, 8), A1(6955, 2659), A1(6956, 3775), ar(6957, 4, 2646), ar(6958, 2, 2671), ar(6959, 4, 2686), s4(6960, 2467), P0(6961, 0, 3706), P0(6962, 0, 3808), P0(6963, 1, 3736), P0(6964, 2, 3338), P0(6965, 3, 3369), P0(6966, 4, 3409), P0(6967, 5, 3438), P0(6968, 4, 3845), P0(6969, 5, 3875), P0(6962, 0, 3540), P0(6963, 1, 3507), P0(6964, 2, 3606), P0(6965, 3, 3572), P0(6966, 4, 3673), P0(6967, 5, 3639), P0(6970, 6, 3476), P0(6971, 7, 3914);
          }

          function j0(e, r, n) {
            var t = 0,
                u = 0,
                k = 0,
                o = 0;

            e: {
              if (!n || (V[e | 0] = r, t = e + n | 0, V[t - 1 | 0] = r, n >>> 0 < 3) || (V[e + 2 | 0] = r, V[e + 1 | 0] = r, V[t - 3 | 0] = r, V[t - 2 | 0] = r, n >>> 0 < 7) || (V[e + 3 | 0] = r, V[t - 4 | 0] = r, n >>> 0 < 9) || (t = 0 - e & 3, u = t + e | 0, r = w0(r & 255, 16843009), i[u >> 2] = r, t = n - t & -4, n = t + u | 0, i[n - 4 >> 2] = r, t >>> 0 < 9) || (i[u + 8 >> 2] = r, i[u + 4 >> 2] = r, i[n - 8 >> 2] = r, i[n - 12 >> 2] = r, t >>> 0 < 25) || (i[u + 24 >> 2] = r, i[u + 20 >> 2] = r, i[u + 16 >> 2] = r, i[u + 12 >> 2] = r, i[n - 16 >> 2] = r, i[n - 20 >> 2] = r, i[n - 24 >> 2] = r, i[n - 28 >> 2] = r, o = u & 4 | 24, n = t - o | 0, n >>> 0 < 32)) break e;

              for (t = Gr(r, 0, 1, 1), k = z0, r = u + o | 0; i[r + 24 >> 2] = t, i[r + 28 >> 2] = k, i[r + 16 >> 2] = t, i[r + 20 >> 2] = k, i[r + 8 >> 2] = t, i[r + 12 >> 2] = k, i[r >> 2] = t, i[r + 4 >> 2] = k, r = r + 32 | 0, n = n - 32 | 0, n >>> 0 > 31;) {
              }
            }

            return e;
          }

          function L0(e) {
            e = e | 0;
            var r = 0,
                n = 0,
                t = 0,
                u = 0,
                k = 0;

            if (e) {
              r = e - 4 | 0, u = i[r >> 2], n = u, t = r, k = i[e - 8 >> 2], e = k & -2, (e | 0) != (k | 0) && (t = r - e | 0, n = i[t + 4 >> 2], i[n + 8 >> 2] = i[t + 8 >> 2], i[i[t + 8 >> 2] + 4 >> 2] = n, n = e + u | 0), e = r + u | 0, r = i[e >> 2], (r | 0) != i[(e + r | 0) - 4 >> 2] && (u = i[e + 4 >> 2], i[u + 8 >> 2] = i[e + 8 >> 2], i[i[e + 8 >> 2] + 4 >> 2] = u, n = r + n | 0), i[t >> 2] = n, i[((n & -4) + t | 0) - 4 >> 2] = n | 1, r = i[t >> 2] - 8 | 0;

              e: {
                if (r >>> 0 <= 127) {
                  e = (r >>> 3 | 0) - 1 | 0;
                  break e;
                }

                if (n = i2(r), e = ((r >>> 29 - n ^ 4) - (n << 2) | 0) + 110 | 0, r >>> 0 <= 4095) break e;
                e = ((r >>> 30 - n ^ 2) - (n << 1) | 0) + 71 | 0, e = e >>> 0 >= 63 ? 63 : e;
              }

              r = e << 4, i[t + 4 >> 2] = r + 5824, r = r + 5832 | 0, i[t + 8 >> 2] = i[r >> 2], i[r >> 2] = t, i[i[t + 8 >> 2] + 4 >> 2] = t, r = i[1714], n = i[1715], t = e & 31, (e & 63) >>> 0 >= 32 ? (e = 1 << t, u = 0) : (u = 1 << t, e = u - 1 & 1 >>> 32 - t), i[1714] = u | r, i[1715] = e | n;
            }
          }

          function y4(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0;
            var t = 0,
                u = 0,
                k = 0,
                o = 0,
                A = 0,
                l = 0,
                p = 0;
            t = F - 32 | 0, F = t, u = i[e + 28 >> 2], i[t + 16 >> 2] = u, k = i[e + 20 >> 2], i[t + 28 >> 2] = n, i[t + 24 >> 2] = r, r = k - u | 0, i[t + 20 >> 2] = r, k = r + n | 0, l = 2, r = t + 16 | 0;

            e: {
              for (;;) {
                n: {
                  i: {
                    r: {
                      if (!q1(o4(i[e + 60 >> 2], r | 0, l | 0, t + 12 | 0) | 0)) {
                        if (o = i[t + 12 >> 2], (o | 0) == (k | 0)) break r;
                        if ((o | 0) >= 0) break i;
                        break n;
                      }

                      if ((k | 0) != -1) break n;
                    }

                    r = i[e + 44 >> 2], i[e + 28 >> 2] = r, i[e + 20 >> 2] = r, i[e + 16 >> 2] = r + i[e + 48 >> 2], e = n;
                    break e;
                  }

                  A = i[r + 4 >> 2], p = A >>> 0 < o >>> 0, u = (p << 3) + r | 0, A = o - (p ? A : 0) | 0, i[u >> 2] = A + i[u >> 2], r = (p ? 12 : 4) + r | 0, i[r >> 2] = i[r >> 2] - A, k = k - o | 0, l = l - p | 0, r = u;
                  continue;
                }

                break;
              }

              if (i[e + 28 >> 2] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e >> 2] = i[e >> 2] | 32, e = 0, (l | 0) == 2) break e;
              e = n - i[r + 4 >> 2] | 0;
            }

            return F = t + 32 | 0, e | 0;
          }

          function E4(e) {
            e = e | 0;
            var r = 0,
                n = 0,
                t = 0,
                u = 0,
                k = 0;
            n = F - 96 | 0, F = n, i[n >> 2] = e, t = F - 16 | 0, F = t, i[t + 12 >> 2] = n, e = F - 144 | 0, F = e, e = Q0(e, 5376, 144), k = n + 16 | 0, r = k, i[e + 44 >> 2] = r, i[e + 20 >> 2] = r, u = -2 - r | 0, u = u >>> 0 >= 2147483647 ? 2147483647 : u, i[e + 48 >> 2] = u, r = r + u | 0, i[e + 28 >> 2] = r, i[e + 16 >> 2] = r, R1(e, 2201, n, 0, 0), u && (r = i[e + 20 >> 2], V[r - ((r | 0) == i[e + 16 >> 2]) | 0] = 0), F = e + 144 | 0, F = t + 16 | 0, e = k;

            e: {
              if (e & 3) for (;;) {
                if (!O[e | 0]) break e;
                if (e = e + 1 | 0, !(e & 3)) break;
              }

              for (; r = e, e = e + 4 | 0, t = i[r >> 2], !((t ^ -1) & t - 16843009 & -2139062144);) {
              }

              for (; e = r, r = e + 1 | 0, !!O[e | 0];) {
              }
            }

            return e = (e - k | 0) + 1 | 0, r = vr(e), r ? e = Q0(r, k, e) : e = 0, F = n + 96 | 0, e | 0;
          }

          function R1(e, r, n, t, u) {
            var k = 0,
                o = 0,
                A = 0,
                l = 0;
            k = F - 208 | 0, F = k, i[k + 204 >> 2] = n, n = k + 160 | 0, j0(n, 0, 40), i[k + 200 >> 2] = i[k + 204 >> 2];

            e: {
              if ((h1(0, r, k + 200 | 0, k + 80 | 0, n, t, u) | 0) < 0) {
                u = -1;
                break e;
              }

              l = i[e + 76 >> 2] >= 0, o = i[e >> 2], i[e + 72 >> 2] <= 0 && (i[e >> 2] = o & -33);

              n: {
                i: {
                  r: {
                    if (!i[e + 48 >> 2]) {
                      i[e + 48 >> 2] = 80, i[e + 28 >> 2] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, A = i[e + 44 >> 2], i[e + 44 >> 2] = k;
                      break r;
                    }

                    if (i[e + 16 >> 2]) break i;
                  }

                  if (n = -1, U1(e)) break n;
                }

                n = h1(e, r, k + 200 | 0, k + 80 | 0, k + 160 | 0, t, u);
              }

              if (A && (Y[i[e + 36 >> 2]](e, 0, 0) | 0, i[e + 48 >> 2] = 0, i[e + 44 >> 2] = A, i[e + 28 >> 2] = 0, r = i[e + 20 >> 2], i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, n = r ? n : -1), r = e, e = i[e >> 2], i[r >> 2] = e | o & 32, u = e & 32 ? -1 : n, !l) break e;
            }

            return F = k + 208 | 0, u;
          }

          function Ue(e) {
            var r = 0,
                n = f(0),
                t = 0,
                u = 0,
                k = 0,
                o = 0,
                A = 0,
                l = f(0),
                p = 0;
            k = F - 16 | 0, F = k, r = i[e + 12 >> 2];

            e: {
              if (r) {
                l = c[e + 520 >> 2], n = c[e + 516 >> 2];

                n: {
                  if (O[e + 4 | 0] & 32) {
                    n = f(Y[r | 0](e, n, l, 0));
                    break n;
                  }

                  n = f(Y[r | 0](e, n, l));
                }

                if (n == n) break e;
                i[k >> 2] = 3280, n2(e, k), r2(), A0();
              }

              n: {
                i: {
                  if (o = i[e + 556 >> 2], r = i[e + 560 >> 2], (o | 0) != (r | 0)) {
                    for (r = r - o >> 2, p = r >>> 0 <= 1 ? 1 : r;;) {
                      if (u = i[(A << 2) + o >> 2], !i[u + 548 >> 2]) {
                        if (r = i[u + 24 >> 2], (r & 196608) != 131072) {
                          if (r = r >>> 13 & 7, r || (r = i[e + 24 >> 2] >>> 10 & 7), O[u + 4 | 0] & 2 | (O[e + 24 | 0] & 8 ? (r | 0) == 5 : 0)) break i;
                          t = t || u;
                        }

                        if (A = A + 1 | 0, (p | 0) != (A | 0)) continue;
                      }

                      break;
                    }

                    if (t) break n;
                  }

                  n = c[e + 520 >> 2];
                  break e;
                }

                t = u;
              }

              n = f(Ue(t) + c[t + 232 >> 2]);
            }

            return F = k + 16 | 0, n;
          }

          function ne(e, r, n, t, u, k) {
            var o = 0,
                A = f(0),
                l = 0,
                p = f(0);
            o = (i[(r << 2) + 4192 >> 2] << 2) + e | 0, A = c[o + 216 >> 2];

            e: {
              n: {
                o = i[o + 216 >> 2];

                i: {
                  if ((o | 0) == 2139156720) break i;
                  if ((o | 0) == 2140081935) break n;
                  l = 4216;

                  r: {
                    if ((o | 0) != 2141891242) {
                      if (A == A) break r;
                      l = 4208;
                    }

                    switch (p = c[l >> 2], A = f(NaN), i[l + 4 >> 2] - 1 | 0) {
                      case 0:
                        break n;

                      case 1:
                        break i;

                      default:
                        break e;
                    }
                  }

                  if (p = (U(2, (o & -1073741825) + 536870912 | 0), j()), !(o & 1073741824)) break n;
                }

                A = f(f(p * n) * f(.009999999776482582));
                break e;
              }

              A = p;
            }

            t = f(A + f(b(e, r, t) + k0(e, r, t)));

            e: {
              n: {
                i: switch (i[u >> 2]) {
                  case 1:
                  case 2:
                    n = c[k >> 2], t = t != t || n < t ? n : t;
                    break n;

                  case 0:
                    break i;

                  default:
                    break e;
                }

                if (t != t) break e;
                i[u >> 2] = 2;
              }

              c[k >> 2] = t;
            }
          }

          function l0(e, r, n) {
            var t = f(0),
                u = f(0),
                k = 0,
                o = f(0);
            e = e + 116 | 0, k = i[(r << 2) + 4160 >> 2];

            e: {
              if ((r & -2) == 2) {
                r = a2(e, 4, k, 2140081935);
                break e;
              }

              r = c2(e, k, 2140081935);
            }

            e: {
              n: {
                i: {
                  r: {
                    if ((r | 0) == 2139156720) break r;
                    if ((r | 0) == 2140081935) break e;
                    e = 4216;

                    t: {
                      if ((r | 0) != 2141891242) {
                        if (t = (U(2, r), j()), t == t) break t;
                        e = 4208;
                      }

                      switch (t = c[e >> 2], u = f(NaN), i[e + 4 >> 2] - 1 | 0) {
                        case 0:
                          break i;

                        case 1:
                          break r;

                        default:
                          break n;
                      }
                    }

                    if (t = (U(2, (r & -1073741825) + 536870912 | 0), j()), !(r & 1073741824)) break i;
                  }

                  t = f(f(t * n) * f(.009999999776482582));
                }

                if (t >= f(0)) return t;
                if (u = t, t < f(0)) break e;
              }

              o = u == u ? u : f(0);
            }

            return o;
          }

          function a0(e, r, n) {
            var t = f(0),
                u = f(0),
                k = 0,
                o = f(0);
            e = e + 116 | 0, k = i[(r << 2) + 4176 >> 2];

            e: {
              if ((r & -2) == 2) {
                r = a2(e, 5, k, 2140081935);
                break e;
              }

              r = c2(e, k, 2140081935);
            }

            e: {
              n: {
                i: {
                  r: {
                    if ((r | 0) == 2139156720) break r;
                    if ((r | 0) == 2140081935) break e;
                    e = 4216;

                    t: {
                      if ((r | 0) != 2141891242) {
                        if (t = (U(2, r), j()), t == t) break t;
                        e = 4208;
                      }

                      switch (t = c[e >> 2], u = f(NaN), i[e + 4 >> 2] - 1 | 0) {
                        case 0:
                          break i;

                        case 1:
                          break r;

                        default:
                          break n;
                      }
                    }

                    if (t = (U(2, (r & -1073741825) + 536870912 | 0), j()), !(r & 1073741824)) break i;
                  }

                  t = f(f(t * n) * f(.009999999776482582));
                }

                if (t >= f(0)) return t;
                if (u = t, t < f(0)) break e;
              }

              o = u == u ? u : f(0);
            }

            return o;
          }

          function Z1(e, r, n, t, u, k) {
            var o = 0;

            e: {
              n: {
                if (e) {
                  i: {
                    if (r & 255) {
                      k = Y[e | 0](n, t, u, k) | 0;
                      break i;
                    }

                    k = Y[e | 0](n, t, u) | 0;
                  }

                  if (k) break n;
                }

                if (k = B(588), r = Q0(k, n, 552), i[r + 564 >> 2] = 0, i[r + 556 >> 2] = 0, i[r + 560 >> 2] = 0, u = i[n + 556 >> 2], t = i[n + 560 >> 2], (u | 0) != (t | 0)) {
                  if (o = t - u | 0, (o | 0) < 0) break e;

                  for (e = B(o), i[r + 556 >> 2] = e, i[r + 564 >> 2] = e + o; i[e >> 2] = i[u >> 2], e = e + 4 | 0, u = u + 4 | 0, (t | 0) != (u | 0);) {
                  }

                  i[r + 560 >> 2] = e;
                }

                e = i[n + 572 >> 2], i[r + 568 >> 2] = i[n + 568 >> 2], i[r + 572 >> 2] = e, i[r + 584 >> 2] = i[n + 584 >> 2], e = i[n + 580 >> 2], i[r + 576 >> 2] = i[n + 576 >> 2], i[r + 580 >> 2] = e, i[r + 552 >> 2] = 0;
              }

              return k;
            }

            ie(), A0();
          }

          function n2(e, r) {
            var n = 0,
                t = 0,
                u = 0;
            u = F - 16 | 0, F = u, i[u + 12 >> 2] = r;

            e: {
              n: {
                if (!e) {
                  r = i[u + 12 >> 2];
                  break n;
                }

                if (r = i[u + 12 >> 2], n = i[e + 568 >> 2], !n) break n;

                if (t = i[n + 4 >> 2], O[n + 9 | 0]) {
                  Y[t | 0](n, e, 5, 0, 4155, r) | 0;
                  break e;
                }

                Y[t | 0](n, e, 5, 4155, r) | 0;
                break e;
              }

              n: {
                if (!O[6872]) {
                  n = B(28), W0[n + 20 >> 1] = 0, i[n + 16 >> 2] = 1065353216, W0[n + 10 >> 1] = 0, W0[n + 12 >> 1] = 0, i[n >> 2] = 0, i[n + 24 >> 2] = 0, V[n + 9 | 0] = 0, t = 1, i[n + 4 >> 2] = 1, V[n + 22 | 0] = 0, i[1717] = n, V[6872] = 1, i[1716] = i[1716] + 1;
                  break n;
                }

                if (n = i[1717], t = i[n + 4 >> 2], !O[n + 9 | 0]) break n;
                Y[t | 0](n, e, 5, 0, 4155, r) | 0;
                break e;
              }

              Y[t | 0](n, e, 5, 4155, r) | 0;
            }

            F = u + 16 | 0;
          }

          function Ne(e, r, n) {
            var t = f(0),
                u = 0,
                k = f(0);
            e = e + 80 | 0, u = i[(r << 2) + 4176 >> 2];

            e: {
              n: {
                if ((r & -2) == 2) {
                  r = a2(e, 5, u, 2140081935);
                  break n;
                }

                r = c2(e, u, 2140081935);
              }

              n: {
                i: {
                  if ((r | 0) == 2139156720) break i;
                  if ((r | 0) == 2140081935) break e;
                  e = 4216;

                  r: {
                    if ((r | 0) != 2141891242) {
                      if (t = (U(2, r), j()), t == t) break r;
                      e = 4208;
                    }

                    switch (t = c[e >> 2], k = f(NaN), i[e + 4 >> 2] - 1 | 0) {
                      case 0:
                        break e;

                      case 1:
                        break i;

                      default:
                        break n;
                    }
                  }

                  if (t = (U(2, (r & -1073741825) + 536870912 | 0), j()), !(r & 1073741824)) break e;
                }

                k = f(f(t * n) * f(.009999999776482582));
              }

              return k;
            }

            return t;
          }

          function O2(e, r, n) {
            var t = f(0),
                u = 0,
                k = f(0);
            e = e + 80 | 0, u = i[(r << 2) + 4160 >> 2];

            e: {
              n: {
                if ((r & -2) == 2) {
                  r = a2(e, 4, u, 2140081935);
                  break n;
                }

                r = c2(e, u, 2140081935);
              }

              n: {
                i: {
                  if ((r | 0) == 2139156720) break i;
                  if ((r | 0) == 2140081935) break e;
                  e = 4216;

                  r: {
                    if ((r | 0) != 2141891242) {
                      if (t = (U(2, r), j()), t == t) break r;
                      e = 4208;
                    }

                    switch (t = c[e >> 2], k = f(NaN), i[e + 4 >> 2] - 1 | 0) {
                      case 0:
                        break e;

                      case 1:
                        break i;

                      default:
                        break n;
                    }
                  }

                  if (t = (U(2, (r & -1073741825) + 536870912 | 0), j()), !(r & 1073741824)) break e;
                }

                k = f(f(t * n) * f(.009999999776482582));
              }

              return k;
            }

            return t;
          }

          function G4(e, r) {
            e = e | 0, r = f(r);
            var n = 0,
                t = 0,
                u = 0;

            if (n = F - 16 | 0, F = n, e = i[e >> 2], !(r >= f(0))) {
              i[n >> 2] = 2245, t = F - 16 | 0, F = t, i[t + 12 >> 2] = n;

              e: {
                if (e) break e;

                if (O[6872]) {
                  e = i[1717];
                  break e;
                }

                e = B(28), W0[e + 20 >> 1] = 0, i[e + 16 >> 2] = 1065353216, W0[e + 10 >> 1] = 0, W0[e + 12 >> 1] = 0, i[e >> 2] = 0, i[e + 24 >> 2] = 0, V[e + 9 | 0] = 0, i[e + 4 >> 2] = 1, V[e + 22 | 0] = 0, i[1717] = e, V[6872] = 1, i[1716] = i[1716] + 1;
              }

              u = i[e + 4 >> 2];

              e: {
                if (O[e + 9 | 0]) {
                  Y[u | 0](e, 0, 5, 0, 4155, n) | 0;
                  break e;
                }

                Y[u | 0](e, 0, 5, 4155, n) | 0;
              }

              F = t + 16 | 0, r2(), A0();
            }

            c[e + 16 >> 2] = r == f(0) ? f(0) : r, F = n + 16 | 0;
          }

          function a2(e, r, n, t) {
            var u = f(0);
            r = (r << 2) + e | 0, u = c[r >> 2], r = i[r >> 2];

            e: {
              if ((r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | u == u || (r = (n << 2) + e | 0, u = c[r >> 2], r = i[r >> 2], (r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | u == u) || (r = i[e + 24 >> 2], u = c[e + 24 >> 2], (r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | u == u) || (u = c[e + 32 >> 2], e = i[e + 32 >> 2], !((e | 0) == 2139156720 | (e | 0) == 2140081935 | (e | 0) == 2141891242) && (r = t, u != u))) break e;
              r = e;
            }

            return r;
          }

          function W1(e, r, n, t, u) {
            var k = 0,
                o = 0,
                A = f(0),
                l = 0;
            k = 2, o = i[e + 24 >> 2] >>> 2 & 3;

            e: {
              n: {
                i: {
                  if (!(!i[e + 552 >> 2] | (r | 0) != 2)) {
                    r = 0, k = 3;

                    r: switch (o - 2 | 0) {
                      case 0:
                        break e;

                      case 1:
                        break r;

                      default:
                        break i;
                    }

                    k = 2;
                    break e;
                  }

                  if (r = 0, o >>> 0 > 1) break n;
                }

                r = k;
              }

              k = o;
            }

            n = x1(e, k, n), t = x1(e, r, t), A = b(e, k, u), o = e + 228 | 0, l = k << 2, c[o + (i[l + 4160 >> 2] << 2) >> 2] = n + A, A = k0(e, k, u), c[o + (i[l + 4176 >> 2] << 2) >> 2] = n + A, n = b(e, r, u), k = r << 2, c[o + (i[k + 4160 >> 2] << 2) >> 2] = t + n, n = k0(e, r, u), c[o + (i[k + 4176 >> 2] << 2) >> 2] = t + n;
          }

          function g1(e) {
            e = e | 0;
            var r = 0,
                n = 0,
                t = 0,
                u = 0;

            if (e) {
              if (r = i[e >> 2], n = i[r + 552 >> 2], n && (O1(n, r), i[r + 552 >> 2] = 0), t = i[r + 560 >> 2], n = i[r + 556 >> 2], (t | 0) != (n | 0)) for (t = t - n >> 2, u = t >>> 0 <= 1 ? 1 : t, t = 0; i[i[n + (t << 2) >> 2] + 552 >> 2] = 0, t = t + 1 | 0, (u | 0) != (t | 0);) {
              }
              i[r + 560 >> 2] = n, V1(r + 556 | 0), n = i[r + 556 >> 2], n && (i[r + 560 >> 2] = n, L0(n)), L0(r), r = i[e + 8 >> 2], i[e + 8 >> 2] = 0, r && Y[i[i[r >> 2] + 4 >> 2]](r), r = i[e + 4 >> 2], i[e + 4 >> 2] = 0, r && Y[i[i[r >> 2] + 4 >> 2]](r), L0(e);
            }
          }

          function R4(e, r, n, t, u, k) {
            e = e | 0, r = r | 0, n = f(n), t = t | 0, u = f(u), k = k | 0;
            var o = 0,
                A = 0,
                l = 0;
            o = F - 48 | 0, F = o, l = i[r + 8 >> 2];

            e: {
              if (V[6908] & 1) {
                r = i[1726];
                break e;
              }

              r = k1(5, 4352) | 0, V[6908] = 1, i[1726] = r;
            }

            i[o + 40 >> 2] = k, c[o + 32 >> 2] = u, i[o + 24 >> 2] = t, c[o + 16 >> 2] = n, A = +i4(r | 0, l | 0, 2813, o + 12 | 0, o + 16 | 0);

            e: {
              if (A < 4294967296 & A >= 0) {
                r = ~~A >>> 0;
                break e;
              }

              r = 0;
            }

            t = i[o + 12 >> 2], k = i[r + 4 >> 2], i[e >> 2] = i[r >> 2], i[e + 4 >> 2] = k, k = i[r + 12 >> 2], i[e + 8 >> 2] = i[r + 8 >> 2], i[e + 12 >> 2] = k, r4(t | 0), F = o + 48 | 0;
          }

          function Z4(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0;
            var t = 0,
                u = 0,
                k = 0,
                o = 0;

            if (t = F - 32 | 0, F = t, u = i[r >> 2], u >>> 0 < 2147483632) {
              e: {
                n: {
                  if (u >>> 0 >= 11) {
                    k = (u | 15) + 1 | 0, o = B(k), i[t + 16 >> 2] = k | -2147483648, i[t + 8 >> 2] = o, i[t + 12 >> 2] = u, k = u + o | 0;
                    break n;
                  }

                  if (V[t + 19 | 0] = u, o = t + 8 | 0, k = o + u | 0, !u) break e;
                }

                Q0(o, r + 4 | 0, u);
              }

              return V[k | 0] = 0, i[t >> 2] = n, Y[e | 0](t + 24 | 0, t + 8 | 0, t), e4(i[t + 24 >> 2]), e = i[t + 24 >> 2], pe(e | 0), pe(i[t >> 2]), V[t + 19 | 0] < 0 && L0(i[t + 8 >> 2]), F = t + 32 | 0, e | 0;
            }

            ie(), A0();
          }

          function V1(e) {
            var r = 0,
                n = 0,
                t = 0,
                u = 0,
                k = 0;
            u = F - 32 | 0, F = u, r = i[e >> 2], n = i[e + 4 >> 2] - r >> 2;

            e: {
              if (n >>> 0 >= i[e + 8 >> 2] - r >> 2 >>> 0 || (n = me(u + 8 | 0, n, n, e + 8 | 0), r = i[e >> 2], t = i[e + 4 >> 2] - r | 0, t = d2(i[n + 4 >> 2] - t | 0, r, t), r = i[e >> 2], i[e >> 2] = t, i[n + 4 >> 2] = r, t = i[e + 4 >> 2], i[e + 4 >> 2] = i[n + 8 >> 2], i[n + 8 >> 2] = t, k = i[e + 8 >> 2], i[e + 8 >> 2] = i[n + 12 >> 2], i[n >> 2] = r, i[n + 12 >> 2] = k, (r | 0) != (t | 0) && (i[n + 8 >> 2] = t + ((r - t | 0) + 3 & -4)), !r)) break e;
              L0(r);
            }

            F = u + 32 | 0;
          }

          function d0(e, r, n) {
            var t = 0,
                u = 0,
                k = 0;

            if (!(O[e | 0] & 32)) {
              e: {
                t = r, r = e, e = i[r + 16 >> 2];

                n: {
                  if (!e) {
                    if (U1(r)) break n;
                    e = i[r + 16 >> 2];
                  }

                  if (k = i[r + 20 >> 2], e - k >>> 0 < n >>> 0) {
                    Y[i[r + 36 >> 2]](r, t, n) | 0;
                    break e;
                  }

                  i: {
                    if (i[r + 80 >> 2] < 0) break i;

                    for (e = n;;) {
                      if (u = e, !e) break i;
                      if (e = u - 1 | 0, O[t + e | 0] == 10) break;
                    }

                    if (Y[i[r + 36 >> 2]](r, t, u) >>> 0 < u >>> 0) break n;
                    t = t + u | 0, n = n - u | 0, k = i[r + 20 >> 2];
                  }

                  Q0(k, t, n), i[r + 20 >> 2] = i[r + 20 >> 2] + n;
                }
              }
            }
          }

          function yr(e, r, n) {
            var t = 0,
                u = 0,
                k = 0;
            t = F - 16 | 0, F = t, u = e + 24 | 0, Y[r | 0](t + 8 | 0, u), k = i[t + 12 >> 2];

            e: {
              if ((i[i[t + 8 >> 2] >> 2] & 7 << k) >> k == (n | 0)) break e;

              for (Y[r | 0](t + 8 | 0, u), r = i[t + 8 >> 2], u = r, k = i[r >> 2], r = i[t + 12 >> 2], i[u >> 2] = k & (7 << r ^ -1) | (n & 7) << r;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }

            F = t + 16 | 0;
          }

          function k0(e, r, n) {
            var t = f(0),
                u = 0;
            e = e + 44 | 0, u = i[(r << 2) + 4176 >> 2];

            e: {
              if ((r & -2) == 2) {
                e = a2(e, 5, u, 2140081935);
                break e;
              }

              e = c2(e, u, 2140081935);
            }

            e: {
              if ((e | 0) != 2139156720) {
                if ((e | 0) == 2140081935 | (e | 0) == 2141891242) break e;
                if (t = (U(2, e), j()), t != t) return f(NaN);
                if (t = (U(2, (e & -1073741825) + 536870912 | 0), j()), !(e & 1073741824)) break e;
              }

              t = f(f(t * n) * f(.009999999776482582));
            }

            return t;
          }

          function b(e, r, n) {
            var t = f(0),
                u = 0;
            e = e + 44 | 0, u = i[(r << 2) + 4160 >> 2];

            e: {
              if ((r & -2) == 2) {
                e = a2(e, 4, u, 2140081935);
                break e;
              }

              e = c2(e, u, 2140081935);
            }

            e: {
              if ((e | 0) != 2139156720) {
                if ((e | 0) == 2140081935 | (e | 0) == 2141891242) break e;
                if (t = (U(2, e), j()), t != t) return f(NaN);
                if (t = (U(2, (e & -1073741825) + 536870912 | 0), j()), !(e & 1073741824)) break e;
              }

              t = f(f(t * n) * f(.009999999776482582));
            }

            return t;
          }

          function c2(e, r, n) {
            var t = f(0);
            r = (r << 2) + e | 0, t = c[r >> 2], r = i[r >> 2];

            e: {
              if ((r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | t == t || (r = i[e + 28 >> 2], t = c[e + 28 >> 2], (r | 0) == 2139156720 | (r | 0) == 2140081935 | (r | 0) == 2141891242 | t == t) || (t = c[e + 32 >> 2], e = i[e + 32 >> 2], !((e | 0) == 2139156720 | (e | 0) == 2140081935 | (e | 0) == 2141891242) && (r = n, t != t))) break e;
              r = e;
            }

            return r;
          }

          function W4(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0;
            var t = 0,
                u = 0,
                k = 0,
                o = 0,
                A = 0;
            return u = i[e + 84 >> 2], k = i[u >> 2], t = i[u + 4 >> 2], A = i[e + 28 >> 2], o = i[e + 20 >> 2] - A | 0, o = t >>> 0 < o >>> 0 ? t : o, o && (Q0(k, A, o), k = o + i[u >> 2] | 0, i[u >> 2] = k, t = i[u + 4 >> 2] - o | 0, i[u + 4 >> 2] = t), t = n >>> 0 > t >>> 0 ? t : n, t && (Q0(k, r, t), k = t + i[u >> 2] | 0, i[u >> 2] = k, i[u + 4 >> 2] = i[u + 4 >> 2] - t), V[k | 0] = 0, r = i[e + 44 >> 2], i[e + 28 >> 2] = r, i[e + 20 >> 2] = r, n | 0;
          }

          function o0(e, r) {
            var n = f(0),
                t = 0;
            e = e + 152 | 0, t = i[(r << 2) + 4176 >> 2];

            e: {
              if ((r & -2) == 2) {
                e = a2(e, 5, t, 2140081935);
                break e;
              }

              e = c2(e, t, 2140081935);
            }

            n = f(0);

            e: {
              if ((e | 0) == 2139156720 || (n = f(0), (e | 0) == 2140081935)) break e;

              n: {
                if ((e | 0) == 2141891242 || (n = (U(2, e), j()), n != n)) break n;
                n = (U(2, (e & -1073741825) + 536870912 | 0), j());
                break e;
              }

              n = f(NaN);
            }

            return $(n, f(0));
          }

          function i0(e, r) {
            var n = f(0),
                t = 0;
            e = e + 152 | 0, t = i[(r << 2) + 4160 >> 2];

            e: {
              if ((r & -2) == 2) {
                e = a2(e, 4, t, 2140081935);
                break e;
              }

              e = c2(e, t, 2140081935);
            }

            n = f(0);

            e: {
              if ((e | 0) == 2139156720 || (n = f(0), (e | 0) == 2140081935)) break e;

              n: {
                if ((e | 0) == 2141891242 || (n = (U(2, e), j()), n != n)) break n;
                n = (U(2, (e & -1073741825) + 536870912 | 0), j());
                break e;
              }

              n = f(NaN);
            }

            return $(n, f(0));
          }

          function g4(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0;
            var t = 0,
                u = 0,
                k = f(0);
            t = 2, r = i[r >> 2] + (n << 2) | 0, k = c[r + 116 >> 2];

            e: {
              n: {
                if (r = i[r + 116 >> 2], (r | 0) != 2139156720) {
                  if (u = NaN, (r | 0) == 2141891242) {
                    t = 3;
                    break e;
                  }

                  if ((r | 0) != 2140081935) break n;
                  u = 0, t = 1;
                  break e;
                }

                break e;
              }

              if (k != k) {
                t = 0;
                break e;
              }

              t = r & 1073741824 ? 2 : 1, u = (U(2, (r & -1073741825) + 536870912 | 0), +j());
            }

            v0[e + 8 >> 3] = u, i[e >> 2] = t;
          }

          function V4(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0;
            var t = 0,
                u = 0,
                k = f(0);
            t = 2, r = i[r >> 2] + (n << 2) | 0, k = c[r + 80 >> 2];

            e: {
              n: {
                if (r = i[r + 80 >> 2], (r | 0) != 2139156720) {
                  if (u = NaN, (r | 0) == 2141891242) {
                    t = 3;
                    break e;
                  }

                  if ((r | 0) != 2140081935) break n;
                  u = 0, t = 1;
                  break e;
                }

                break e;
              }

              if (k != k) {
                t = 0;
                break e;
              }

              t = r & 1073741824 ? 2 : 1, u = (U(2, (r & -1073741825) + 536870912 | 0), +j());
            }

            v0[e + 8 >> 3] = u, i[e >> 2] = t;
          }

          function T4(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0;
            var t = 0,
                u = 0,
                k = f(0);
            t = 2, r = i[r >> 2] + (n << 2) | 0, k = c[r + 44 >> 2];

            e: {
              n: {
                if (r = i[r + 44 >> 2], (r | 0) != 2139156720) {
                  if (u = NaN, (r | 0) == 2141891242) {
                    t = 3;
                    break e;
                  }

                  if ((r | 0) != 2140081935) break n;
                  u = 0, t = 1;
                  break e;
                }

                break e;
              }

              if (k != k) {
                t = 0;
                break e;
              }

              t = r & 1073741824 ? 2 : 1, u = (U(2, (r & -1073741825) + 536870912 | 0), +j());
            }

            v0[e + 8 >> 3] = u, i[e >> 2] = t;
          }

          function T1(e, r) {
            e: {
              if (r) {
                r = i[r >> 2], r = wr(B(588), r);
                break e;
              }

              n: {
                if (O[6872]) {
                  r = i[1717];
                  break n;
                }

                r = B(28), W0[r + 20 >> 1] = 0, i[r + 16 >> 2] = 1065353216, W0[r + 10 >> 1] = 0, W0[r + 12 >> 1] = 0, i[r >> 2] = 0, i[r + 24 >> 2] = 0, V[r + 9 | 0] = 0, i[r + 4 >> 2] = 1, V[r + 22 | 0] = 0, i[1717] = r, V[6872] = 1, i[1716] = i[1716] + 1;
              }

              r = wr(B(588), r);
            }

            return i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = r, i[r >> 2] = e, e;
          }

          function h2(e, r, n, t) {
            var u = 0,
                k = 0,
                o = 0;
            e = e * r, u = pr(e), u = u < 0 ? u + 1 : u, o = u != u;

            e: {
              if (!(o | !(m0(u) < 1e-4))) {
                e = e - u;
                break e;
              }

              n: {
                if (u != u) {
                  e = e - u;
                  break n;
                }

                if (e = e - u, !(m0(u + -1) < 1e-4)) break n;
                e = e + 1;
                break e;
              }

              if (n) {
                e = e + 1;
                break e;
              }

              if (t) break e;
              k = 0;

              n: {
                if (o || (k = 1, u > .5)) break n;
                k = m0(u + -.5) < 1e-4 ? 1 : 0;
              }

              e = e + k;
            }

            return e != e | r != r ? f(NaN) : f(e / r);
          }

          function I1(e) {
            var r = f(0),
                n = 0,
                t = f(0);
            n = 0;

            e: {
              if ((i[e + 24 >> 2] & 196608) == 131072) break e;

              n: {
                if (!i[e + 552 >> 2]) break n;
                r = c[e + 32 >> 2];

                i: {
                  if (r != r && (r = c[e + 28 >> 2], !(r > f(0)))) break i;
                  if (n = 1, r != f(0)) break e;
                }

                if (r = c[e + 36 >> 2], r == r) break n;

                if (V[e + 4 | 0] < 0) {
                  r = f(1);
                  break n;
                }

                if (r = f(0), t = c[e + 28 >> 2], !(t < f(0))) break n;
                r = f(-t);
              }

              n = r != f(0);
            }

            return n;
          }

          function B1(e, r) {
            var n = f(0);

            e: {
              if ((r | 0) != 2139156720) {
                if ((r | 0) != 2140081935) {
                  if ((r | 0) != 2141891242) break e;
                  i[e >> 2] = 2143289344, i[e + 4 >> 2] = 3;
                  return;
                }

                i[e >> 2] = 0, i[e + 4 >> 2] = 1;
                return;
              }

              i[e >> 2] = 0, i[e + 4 >> 2] = 2;
              return;
            }

            if (n = (U(2, r), j()), n != n) {
              i[e >> 2] = 2143289344, i[e + 4 >> 2] = 0;
              return;
            }

            i[e + 4 >> 2] = r & 1073741824 ? 2 : 1, i[e >> 2] = (r & -1073741825) + 536870912;
          }

          function I4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0,
                t = 0,
                u = f(0);
            r = i[r >> 2], u = c[r + 212 >> 2];

            e: {
              n: {
                if (r = i[r + 212 >> 2], (r | 0) != 2139156720) {
                  if (t = NaN, n = 3, (r | 0) == 2141891242) break e;
                  if ((r | 0) != 2140081935) break n;
                  t = 0, n = 1;
                  break e;
                }

                n = 2;
                break e;
              }

              if (n = 0, u != u) break e;
              t = (U(2, (r & -1073741825) + 536870912 | 0), +j()), n = r & 1073741824 ? 2 : 1;
            }

            r = n, v0[e + 8 >> 3] = t, i[e >> 2] = r;
          }

          function B4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0,
                t = 0,
                u = f(0);
            r = i[r >> 2], u = c[r + 216 >> 2];

            e: {
              n: {
                if (r = i[r + 216 >> 2], (r | 0) != 2139156720) {
                  if (t = NaN, n = 3, (r | 0) == 2141891242) break e;
                  if ((r | 0) != 2140081935) break n;
                  t = 0, n = 1;
                  break e;
                }

                n = 2;
                break e;
              }

              if (n = 0, u != u) break e;
              t = (U(2, (r & -1073741825) + 536870912 | 0), +j()), n = r & 1073741824 ? 2 : 1;
            }

            r = n, v0[e + 8 >> 3] = t, i[e >> 2] = r;
          }

          function d4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0,
                t = 0,
                u = f(0);
            r = i[r >> 2], u = c[r + 220 >> 2];

            e: {
              n: {
                if (r = i[r + 220 >> 2], (r | 0) != 2139156720) {
                  if (t = NaN, n = 3, (r | 0) == 2141891242) break e;
                  if ((r | 0) != 2140081935) break n;
                  t = 0, n = 1;
                  break e;
                }

                n = 2;
                break e;
              }

              if (n = 0, u != u) break e;
              t = (U(2, (r & -1073741825) + 536870912 | 0), +j()), n = r & 1073741824 ? 2 : 1;
            }

            r = n, v0[e + 8 >> 3] = t, i[e >> 2] = r;
          }

          function O4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0,
                t = 0,
                u = f(0);
            r = i[r >> 2], u = c[r + 200 >> 2];

            e: {
              n: {
                if (r = i[r + 200 >> 2], (r | 0) != 2139156720) {
                  if (t = NaN, n = 3, (r | 0) == 2141891242) break e;
                  if ((r | 0) != 2140081935) break n;
                  t = 0, n = 1;
                  break e;
                }

                n = 2;
                break e;
              }

              if (n = 0, u != u) break e;
              t = (U(2, (r & -1073741825) + 536870912 | 0), +j()), n = r & 1073741824 ? 2 : 1;
            }

            r = n, v0[e + 8 >> 3] = t, i[e >> 2] = r;
          }

          function _4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0,
                t = 0,
                u = f(0);
            r = i[r >> 2], u = c[r + 204 >> 2];

            e: {
              n: {
                if (r = i[r + 204 >> 2], (r | 0) != 2139156720) {
                  if (t = NaN, n = 3, (r | 0) == 2141891242) break e;
                  if ((r | 0) != 2140081935) break n;
                  t = 0, n = 1;
                  break e;
                }

                n = 2;
                break e;
              }

              if (n = 0, u != u) break e;
              t = (U(2, (r & -1073741825) + 536870912 | 0), +j()), n = r & 1073741824 ? 2 : 1;
            }

            r = n, v0[e + 8 >> 3] = t, i[e >> 2] = r;
          }

          function L4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0,
                t = 0,
                u = f(0);
            r = i[r >> 2], u = c[r + 208 >> 2];

            e: {
              n: {
                if (r = i[r + 208 >> 2], (r | 0) != 2139156720) {
                  if (t = NaN, n = 3, (r | 0) == 2141891242) break e;
                  if ((r | 0) != 2140081935) break n;
                  t = 0, n = 1;
                  break e;
                }

                n = 2;
                break e;
              }

              if (n = 0, u != u) break e;
              t = (U(2, (r & -1073741825) + 536870912 | 0), +j()), n = r & 1073741824 ? 2 : 1;
            }

            r = n, v0[e + 8 >> 3] = t, i[e >> 2] = r;
          }

          function d1(e) {
            var r = 0,
                n = 0,
                t = 0;
            n = i[e + 24 >> 2];

            e: {
              if (!(n & 8) || (r = 1, (n & 7168) == 5120) || (r = 0, t = i[e + 560 >> 2], n = i[e + 556 >> 2], (t | 0) == (n | 0))) break e;

              for (e = t - n >> 2, t = e >>> 0 <= 1 ? 1 : e, e = 0;;) {
                if (r = i[i[n + (e << 2) >> 2] + 24 >> 2], r = (r & 196608) != 131072 & (r & 57344) == 40960, r) break e;
                if (e = e + 1 | 0, (t | 0) == (e | 0)) break;
              }
            }

            return r;
          }

          function X4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0,
                t = f(0),
                u = f(0);
            t = f(NaN), r = i[r >> 2], u = c[r + 40 >> 2], r = i[r + 40 >> 2], n = 3;

            e: {
              if ((r | 0) == 2141891242) break e;

              if ((r | 0) == 2140081935) {
                t = f(0), n = 1;
                break e;
              }

              if ((r | 0) == 2139156720) {
                t = f(0), n = 2;
                break e;
              }

              if (n = 0, u != u) break e;
              t = (U(2, (r & -1073741825) + 536870912 | 0), j()), n = r & 1073741824 ? 2 : 1;
            }

            i[e >> 2] = n, v0[e + 8 >> 3] = t;
          }

          function v2(e) {
            var r = 0,
                n = f(0);
            r = 2143289344;

            e: {
              if (f(m0(e)) == f(1 / 0) | e != e || (r = 2139156720, e < f(10842021724855044e-35) & e > f(-10842021724855044e-35) | e == f(0))) break e;
              n = (U(2, (_0(e), e0(2) & -2147483648 | 1602224127)), j()), r = (_0(e > f(0xffffff0000000000) || e < f(-0xffffff0000000000) ? n : e), e0(2) - 536870912 | 1073741824);
            }

            return r;
          }

          function F4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;

            if (n = F - 16 | 0, F = n, e = i[e >> 2], (r | 0) < 6) {
              F = n + 16 | 0;

              e: {
                n: switch (r - 4 | 0) {
                  case 0:
                    if (r = e + 260 | 0, (O[e + 300 | 0] & 3) == 2) break e;
                    r = e + 252 | 0;
                    break e;

                  case 1:
                    if (r = e + 252 | 0, (O[e + 300 | 0] & 3) == 2) break e;
                    r = e + 260 | 0;
                    break e;

                  default:
                    break n;
                }

                r = (e + (r << 2) | 0) + 252 | 0;
              }

              return +c[r >> 2];
            }

            i[n >> 2] = 1871, n2(e, n), r2(), A0();
          }

          function C4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;

            if (n = F - 16 | 0, F = n, e = i[e >> 2], (r | 0) < 6) {
              F = n + 16 | 0;

              e: {
                n: switch (r - 4 | 0) {
                  case 0:
                    if (r = e + 276 | 0, (O[e + 300 | 0] & 3) == 2) break e;
                    r = e + 268 | 0;
                    break e;

                  case 1:
                    if (r = e + 268 | 0, (O[e + 300 | 0] & 3) == 2) break e;
                    r = e + 276 | 0;
                    break e;

                  default:
                    break n;
                }

                r = (e + (r << 2) | 0) + 268 | 0;
              }

              return +c[r >> 2];
            }

            i[n >> 2] = 1871, n2(e, n), r2(), A0();
          }

          function M4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;

            if (n = F - 16 | 0, F = n, e = i[e >> 2], (r | 0) < 6) {
              F = n + 16 | 0;

              e: {
                n: switch (r - 4 | 0) {
                  case 0:
                    if (r = e + 292 | 0, (O[e + 300 | 0] & 3) == 2) break e;
                    r = e + 284 | 0;
                    break e;

                  case 1:
                    if (r = e + 284 | 0, (O[e + 300 | 0] & 3) == 2) break e;
                    r = e + 292 | 0;
                    break e;

                  default:
                    break n;
                }

                r = (e + (r << 2) | 0) + 284 | 0;
              }

              return +c[r >> 2];
            }

            i[n >> 2] = 1871, n2(e, n), r2(), A0();
          }

          function t2(e) {
            var r = 0,
                n = f(0);
            r = 2143289344;

            e: {
              if (f(m0(e)) == f(1 / 0) | e != e || (r = 2140081935, e < f(10842021724855044e-35) & e > f(-10842021724855044e-35) | e == f(0))) break e;
              n = (U(2, (_0(e), e0(2) & -2147483648 | 1610612735)), j()), r = (_0(e > f(36893485948395848e3) || e < f(-36893485948395848e3) ? n : e), e0(2) - 536870912 | 0);
            }

            return r;
          }

          function U4(e, r) {
            e = e | 0, r = r | 0;
            var n = f(0),
                t = f(0);
            e = i[e >> 2] + (r << 2) | 0, t = c[e + 188 >> 2];

            e: {
              n: {
                if (e = i[e + 188 >> 2], (e | 0) == 2139156720 | (e | 0) == 2140081935) break n;
                if (n = f(NaN), (e | 0) == 2141891242 | t != t) break e;
                if ((e | 0) == 2139156720) break n;
                return f((U(2, (e & -1073741825) + 536870912 | 0), j()));
              }

              n = f(0);
            }

            return f(n);
          }

          function H4(e, r, n, t, u, k) {
            e = e | 0, r = r | 0, n = f(n), t = t | 0, u = f(u), k = k | 0;
            var o = 0,
                A = 0;
            return o = F - 16 | 0, F = o, A = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (A = i[A + i[r >> 2] >> 2]), Y[A | 0](o, r, n, t, u, k), e = B(16), r = i[o + 12 >> 2], i[e + 8 >> 2] = i[o + 8 >> 2], i[e + 12 >> 2] = r, r = i[o + 4 >> 2], i[e >> 2] = i[o >> 2], i[e + 4 >> 2] = r, F = o + 16 | 0, e | 0;
          }

          function P4(e, r, n) {
            e = e | 0, r = r | 0, n = +n;
            var t = 0,
                u = 0;

            e: {
              if (e = i[e >> 2], r = e + (r << 2) | 0, u = i[r + 152 >> 2], t = t2(f(n)), (u | 0) == (t | 0)) break e;

              for (i[r + 152 >> 2] = t;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function S4(e, r, n) {
            e = e | 0, r = r | 0, n = +n;
            var t = 0,
                u = 0;

            e: {
              if (e = i[e >> 2], r = e + (r << 2) | 0, u = i[r + 188 >> 2], t = t2(f(n)), (u | 0) == (t | 0)) break e;

              for (i[r + 188 >> 2] = t;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function D4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0,
                t = f(0);
            e = i[e >> 2] + (r << 2) | 0, t = c[e + 152 >> 2];

            e: {
              n: {
                if (e = i[e + 152 >> 2], (e | 0) == 2139156720 | (e | 0) == 2140081935) break n;
                if (n = NaN, (e | 0) == 2141891242 | t != t) break e;
                if ((e | 0) == 2139156720) break n;
                return U(2, (e & -1073741825) + 536870912 | 0), +j();
              }

              n = 0;
            }

            return +n;
          }

          function Y4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;

            e: {
              if (e = i[e >> 2], n = i[e + 24 >> 2], (n >>> 20 & 3) == (r | 0)) break e;

              for (i[e + 24 >> 2] = n & -3145729 | r << 20 & 3145728;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function z4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;

            e: {
              if (e = i[e >> 2], n = i[e + 24 >> 2], (n >>> 22 & 1) == (r | 0)) break e;

              for (i[e + 24 >> 2] = n & -4194305 | r << 22 & 4194304;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function te(e, r, n) {
            var t = 0,
                u = 0,
                k = 0;

            e: {
              if (!r) {
                t = e;
                break e;
              }

              for (; t = N1(e, r, 10), u = z0, e = Gr(t, u, 246, 0) + e | 0, n = n - 1 | 0, V[n | 0] = e | 48, k = r >>> 0 > 9, e = t, r = u, !!k;) {
              }
            }

            if (t) for (; n = n - 1 | 0, e = (t >>> 0) / 10 | 0, V[n | 0] = w0(e, 246) + t | 48, r = t >>> 0 > 9, t = e, !!r;) {
            }
            return n;
          }

          function Q4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;

            e: {
              if (e = i[e >> 2], n = i[e + 24 >> 2], (n >>> 16 & 3) == (r | 0)) break e;

              for (i[e + 24 >> 2] = n & -196609 | r << 16 & 196608;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function j4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;

            e: {
              if (e = i[e >> 2], n = i[e + 24 >> 2], (n >>> 18 & 3) == (r | 0)) break e;

              for (i[e + 24 >> 2] = n & -786433 | r << 18 & 786432;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function x4(e, r) {
            e = e | 0, r = +r;
            var n = 0,
                t = f(0),
                u = f(0);

            e: {
              if (t = f(r), e = i[e >> 2], u = c[e + 224 >> 2], t == u | t != t & u != u) break e;

              for (c[e + 224 >> 2] = t;;) {
                if (n = O[e + 4 | 0], n & 4) break e;
                if (V[e + 4 | 0] = n | 4, n = i[e + 20 >> 2], n && Y[n | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function J4(e, r) {
            e = e | 0, r = +r;
            var n = 0,
                t = f(0),
                u = f(0);

            e: {
              if (t = f(r), e = i[e >> 2], u = c[e + 28 >> 2], t == u | t != t & u != u) break e;

              for (c[e + 28 >> 2] = t;;) {
                if (n = O[e + 4 | 0], n & 4) break e;
                if (V[e + 4 | 0] = n | 4, n = i[e + 20 >> 2], n && Y[n | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function q4(e, r) {
            e = e | 0, r = +r;
            var n = 0,
                t = f(0),
                u = f(0);

            e: {
              if (t = f(r), e = i[e >> 2], u = c[e + 32 >> 2], t == u | t != t & u != u) break e;

              for (c[e + 32 >> 2] = t;;) {
                if (n = O[e + 4 | 0], n & 4) break e;
                if (V[e + 4 | 0] = n | 4, n = i[e + 20 >> 2], n && Y[n | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function K4(e, r) {
            e = e | 0, r = +r;
            var n = 0,
                t = f(0),
                u = f(0);

            e: {
              if (t = f(r), e = i[e >> 2], u = c[e + 36 >> 2], t == u | t != t & u != u) break e;

              for (c[e + 36 >> 2] = t;;) {
                if (n = O[e + 4 | 0], n & 4) break e;
                if (V[e + 4 | 0] = n | 4, n = i[e + 20 >> 2], n && Y[n | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function $4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;

            e: {
              if (e = i[e >> 2], n = i[e + 24 >> 2], (n >>> 4 & 7) == (r | 0)) break e;

              for (i[e + 24 >> 2] = n & -113 | r << 4 & 112;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function b4(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;

            e: {
              if (e = i[e >> 2], n = O[e + 4 | 0], ((n & 2) >>> 1 | 0) == (r | 0)) break e;

              for (V[e + 4 | 0] = n & 253 | (r ? 2 : 0);;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function en(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;

            e: {
              if (e = i[e >> 2], n = i[e + 24 >> 2], (n >>> 2 & 3) == (r | 0)) break e;

              for (i[e + 24 >> 2] = n & -13 | r << 2 & 12;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function rn(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0;
            var t = 0,
                u = 0;
            return t = F - 16 | 0, F = t, u = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (u = i[u + i[r >> 2] >> 2]), Y[u | 0](t, r, n), e = B(16), r = i[t + 12 >> 2], i[e + 8 >> 2] = i[t + 8 >> 2], i[e + 12 >> 2] = r, r = i[t + 4 >> 2], i[e >> 2] = i[t >> 2], i[e + 4 >> 2] = r, F = t + 16 | 0, e | 0;
          }

          function O1(e, r) {
            var n = 0,
                t = 0;

            e: {
              n: {
                if (n = i[e + 556 >> 2], t = i[e + 560 >> 2], (n | 0) == (t | 0)) break n;

                for (;;) {
                  if (i[n >> 2] == (r | 0)) break n;
                  if (n = n + 4 | 0, (t | 0) == (n | 0)) break;
                }

                break e;
              }

              if ((n | 0) == (t | 0)) break e;
              return r = n + 4 | 0, d2(n, r, t - r | 0), i[e + 560 >> 2] = t - 4, 1;
            }

            return 0;
          }

          function nn(e) {
            e = e | 0;
            var r = 0,
                n = 0;

            if (n = F - 16 | 0, F = n, e = i[e >> 2], i[e + 8 >> 2]) {
              for (; r = O[e + 4 | 0], !!(!(r & 4) && (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], e));) {
              }

              F = n + 16 | 0;
              return;
            }

            i[n >> 2] = 1024, n2(e, n), r2(), A0();
          }

          function _1(e, r) {
            var n = 0,
                t = 0,
                u = 0;

            if (D0(+e), t = e0(1) | 0, u = e0(0) | 0, n = t >>> 20 & 2047, (n | 0) != 2047) {
              if (!n) return e == 0 ? n = 0 : (e = _1(e * 18446744073709552e3, r), n = i[r >> 2] + -64 | 0), i[r >> 2] = n, e;
              i[r >> 2] = n - 1022, U(0, u | 0), U(1, t & -2146435073 | 1071644672), e = +H0();
            }

            return e;
          }

          function tn(e, r) {
            e = e | 0, r = r | 0;
            var n = 0,
                t = 0;
            return n = F - 16 | 0, F = n, t = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (t = i[t + i[r >> 2] >> 2]), Y[t | 0](n, r), e = B(16), r = i[n + 12 >> 2], i[e + 8 >> 2] = i[n + 8 >> 2], i[e + 12 >> 2] = r, r = i[n + 4 >> 2], i[e >> 2] = i[n >> 2], i[e + 4 >> 2] = r, F = n + 16 | 0, e | 0;
          }

          function He(e, r, n) {
            var t = 0;

            e: {
              if (t = e + 24 | 0, i[(t + (r << 2) | 0) + 184 >> 2] == (n | 0)) break e;

              for (i[((r << 2) + t | 0) + 184 >> 2] = n;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function Pe(e, r, n) {
            var t = 0;

            e: {
              if (t = e + 24 | 0, i[(t + (r << 2) | 0) + 192 >> 2] == (n | 0)) break e;

              for (i[((r << 2) + t | 0) + 192 >> 2] = n;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function fe(e, r, n) {
            var t = 0;

            e: {
              if (t = e + 24 | 0, i[(t + (r << 2) | 0) + 176 >> 2] == (n | 0)) break e;

              for (i[((r << 2) + t | 0) + 176 >> 2] = n;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function L1(e, r) {
            var n = 0,
                t = 0,
                u = 0;

            e: {
              if (n = e + 24 | 0, i[n + 16 >> 2] == (r | 0)) break e;

              for (t = Y[9](n) | 0, u = r, i[t + 16 >> 2] = u;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function X1(e, r, n) {
            var t = 0;

            e: {
              if (t = e + 24 | 0, i[(t + (r << 2) | 0) + 56 >> 2] == (n | 0)) break e;

              for (i[((r << 2) + t | 0) + 56 >> 2] = n;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function F1(e, r, n) {
            var t = 0;

            e: {
              if (t = e + 24 | 0, i[(t + (r << 2) | 0) + 92 >> 2] == (n | 0)) break e;

              for (i[((r << 2) + t | 0) + 92 >> 2] = n;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function Er(e, r, n) {
            var t = 0;

            e: {
              if (t = e + 24 | 0, i[(t + (r << 2) | 0) + 20 >> 2] == (n | 0)) break e;

              for (i[((r << 2) + t | 0) + 20 >> 2] = n;;) {
                if (r = O[e + 4 | 0], r & 4) break e;
                if (V[e + 4 | 0] = r | 4, r = i[e + 20 >> 2], r && Y[r | 0](e), i[e + 308 >> 2] = 2143289344, e = i[e + 552 >> 2], !e) break;
              }
            }
          }

          function fn() {
            for (var e = 0, r = 0, n = 0; r = e << 4, n = r + 5824 | 0, i[r + 5828 >> 2] = n, i[r + 5832 >> 2] = n, e = e + 1 | 0, (e | 0) != 64;) {
            }

            Nr(48), i[1720] = 16, i[1721] = 0, c1(), i[1721] = i[1732], i[1732] = 6880, i[1733] = 193, i[1734] = 0, G1(), i[1734] = i[1732], i[1732] = 6932;
          }

          function Se(e, r) {
            var n = 0,
                t = f(0);
            e = e + 80 | 0, n = i[(r << 2) + 4176 >> 2];

            e: {
              if ((r & -2) == 2) {
                e = a2(e, 5, n, 2143289344);
                break e;
              }

              e = c2(e, n, 2143289344);
            }

            return (e | 0) == 2139156720 | (e | 0) == 2140081935 | (e | 0) == 2141891242 ? e = 1 : (t = (U(2, e), j()), e = t == t), e;
          }

          function e2(e, r) {
            var n = 0,
                t = f(0);
            e = e + 80 | 0, n = i[(r << 2) + 4160 >> 2];

            e: {
              if ((r & -2) == 2) {
                e = a2(e, 4, n, 2143289344);
                break e;
              }

              e = c2(e, n, 2143289344);
            }

            return (e | 0) == 2139156720 | (e | 0) == 2140081935 | (e | 0) == 2141891242 ? e = 1 : (t = (U(2, e), j()), e = t == t), e;
          }

          function Gr(e, r, n, t) {
            var u = 0,
                k = 0,
                o = 0,
                A = 0,
                l = 0,
                p = 0;
            return u = n >>> 16 | 0, k = e >>> 16 | 0, p = w0(u, k), o = n & 65535, A = e & 65535, l = w0(o, A), k = (l >>> 16 | 0) + w0(k, o) | 0, u = (k & 65535) + w0(u, A) | 0, z0 = (w0(r, n) + p | 0) + w0(e, t) + (k >>> 16) + (u >>> 16) | 0, l & 65535 | u << 16;
          }

          function C1(e, r) {
            var n = 0,
                t = 0,
                u = 0;
            t = F - 16 | 0, F = t, n = O[e + 4 | 0], u = n & -17, V[e + 4 | 0] = u;

            e: {
              if (r) {
                if (i[e + 560 >> 2] != i[e + 556 >> 2]) break e;
                n = u | 8;
              } else n = n & 231;

              i[e + 8 >> 2] = r, V[e + 4 | 0] = n, F = t + 16 | 0;
              return;
            }

            i[t >> 2] = 3999, n2(e, t), r2(), A0();
          }

          function X0(e, r, n, t, u) {
            var k = 0;

            if (k = F - 256 | 0, F = k, !(u & 73728 | (n | 0) <= (t | 0))) {
              if (t = n - t | 0, n = t >>> 0 < 256, j0(k, r & 255, n ? t : 256), !n) for (; d0(e, k, 256), t = t - 256 | 0, t >>> 0 > 255;) {
              }
              d0(e, k, t);
            }

            F = k + 256 | 0;
          }

          function Q2(e, r, n) {
            var t = 0,
                u = f(0);

            e: {
              if ((n & -2) == 2 && (t = r - -64 | 0, u = c[t >> 2], t = i[t >> 2], (t | 0) == 2139156720 | (t | 0) == 2140081935 | (t | 0) == 2141891242 | u == u)) break e;
              t = i[((i[(n << 2) + 4176 >> 2] << 2) + r | 0) + 44 >> 2];
            }

            B1(e, t);
          }

          function un() {
            var e = 0,
                r = 0;
            return r = B(4), e = B(28), W0[e + 20 >> 1] = 0, i[e + 16 >> 2] = 1065353216, W0[e + 10 >> 1] = 0, W0[e + 12 >> 1] = 0, i[e >> 2] = 0, i[e + 24 >> 2] = 0, V[e + 9 | 0] = 0, i[e + 4 >> 2] = 1, V[e + 22 | 0] = 0, i[1716] = i[1716] + 1, i[r >> 2] = e, r | 0;
          }

          function j2(e, r, n) {
            var t = 0,
                u = f(0);

            e: {
              if ((n & -2) == 2 && (t = i[r + 60 >> 2], u = c[r + 60 >> 2], (t | 0) == 2139156720 | (t | 0) == 2140081935 | (t | 0) == 2141891242 | u == u)) break e;
              t = i[((i[(n << 2) + 4160 >> 2] << 2) + r | 0) + 44 >> 2];
            }

            B1(e, t);
          }

          function M1(e) {
            var r = 0,
                n = 0,
                t = 0;

            for (t = i[e >> 2];;) {
              if (n = V[t | 0], Ye(n)) {
                t = t + 1 | 0, i[e >> 2] = t, r >>> 0 <= 214748364 ? (n = n - 48 | 0, r = w0(r, 10), r = (n | 0) > (r ^ 2147483647) ? -1 : n + r | 0) : r = -1;
                continue;
              }

              break;
            }

            return r;
          }

          function me(e, r, n, t) {
            var u = 0;
            i[e + 12 >> 2] = 0, i[e + 16 >> 2] = t;

            e: {
              if (r) {
                if (r >>> 0 >= 1073741824) break e;
                u = B(r << 2);
              }

              return i[e >> 2] = u, n = (n << 2) + u | 0, i[e + 8 >> 2] = n, i[e + 12 >> 2] = (r << 2) + u, i[e + 4 >> 2] = n, e;
            }

            Tr(), A0();
          }

          function U1(e) {
            var r = 0;
            return r = i[e + 72 >> 2], i[e + 72 >> 2] = r - 1 | r, r = i[e >> 2], r & 8 ? (i[e >> 2] = r | 32, -1) : (i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, r = i[e + 44 >> 2], i[e + 28 >> 2] = r, i[e + 20 >> 2] = r, i[e + 16 >> 2] = r + i[e + 48 >> 2], 0);
          }

          function kn(e, r, n, t, u, k) {
            e = e | 0, r = r | 0, n = f(n), t = t | 0, u = f(u), k = k | 0;
            var o = 0;
            o = F - 16 | 0, F = o, r = i[i[r >> 2] + 4 >> 2], Y[i[i[r >> 2] + 8 >> 2]](o, r, n, t, u, k), c[e >> 2] = v0[o >> 3], c[e + 4 >> 2] = v0[o + 8 >> 3], F = o + 16 | 0;
          }

          function on(e, r) {
            e = e | 0, r = r | 0, r = i[r >> 2], v0[e >> 3] = c[r + 228 >> 2], v0[e + 8 >> 3] = c[r + 236 >> 2], v0[e + 16 >> 3] = c[r + 232 >> 2], v0[e + 24 >> 3] = c[r + 240 >> 2], v0[e + 32 >> 3] = c[r + 244 >> 2], v0[e + 40 >> 3] = c[r + 248 >> 2];
          }

          function An(e, r) {
            e = e | 0, r = r | 0;
            var n = 0,
                t = 0;
            return n = F - 48 | 0, F = n, t = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (t = i[t + i[r >> 2] >> 2]), Y[t | 0](n, r), e = Q0(B(48), n, 48), F = n + 48 | 0, e | 0;
          }

          function sn(e, r, n, t) {
            e = e | 0, r = r | 0, n = n | 0, t = t | 0;
            var u = 0;
            return u = F - 16 | 0, F = u, e = q1(t4(i[e + 60 >> 2], r | 0, n | 0, t & 255, u + 8 | 0) | 0), F = u + 16 | 0, z0 = e ? -1 : i[u + 12 >> 2], (e ? -1 : i[u + 8 >> 2]) | 0;
          }

          function ln(e, r) {
            e = e | 0, r = r | 0;
            var n = 0,
                t = 0;
            n = i[e >> 2], e = i[n + 556 >> 2];

            e: {
              if (i[n + 560 >> 2] - e >> 2 >>> 0 <= r >>> 0 || (e = i[e + (r << 2) >> 2], !e)) break e;
              t = i[e >> 2];
            }

            return t | 0;
          }

          function an(e, r, n, t, u) {
            e = e | 0, r = r | 0, n = +n, t = +t, u = u | 0;
            var k = 0;
            k = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (k = i[k + i[r >> 2] >> 2]), Y[k | 0](r, n, t, u);
          }

          function cn(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0;
            var t = 0;
            return t = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (t = i[t + i[r >> 2] >> 2]), f(f(Y[t | 0](r, n)));
          }

          function H1(e, r, n, t) {
            e = e | 0, r = r | 0, n = n | 0, t = t | 0;
            var u = 0;
            u = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (u = i[u + i[r >> 2] >> 2]), Y[u | 0](r, n, t);
          }

          function P1(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0;
            var t = 0;
            return t = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (t = i[t + i[r >> 2] >> 2]), Y[t | 0](r, n) | 0;
          }

          function hn(e, r, n, t) {
            e = e | 0, r = r | 0, n = n | 0, t = +t;
            var u = 0;
            u = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (u = i[u + i[r >> 2] >> 2]), Y[u | 0](r, n, t);
          }

          function vn(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0;
            var t = 0;
            return t = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (t = i[t + i[r >> 2] >> 2]), +Y[t | 0](r, n);
          }

          function B(e) {
            var r = 0;
            e = e || 1;

            e: {
              for (;;) {
                if (r = vr(e), r) break e;

                if (r = i[2006], r) {
                  Y[r | 0]();
                  continue;
                }

                break;
              }

              ie(), A0();
            }

            return r;
          }

          function wn(e, r, n) {
            e = e | 0, r = r | 0, n = f(n);
            var t = 0;
            t = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (t = i[t + i[r >> 2] >> 2]), Y[t | 0](r, n);
          }

          function x2(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0;
            var t = 0;
            t = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (t = i[t + i[r >> 2] >> 2]), Y[t | 0](r, n);
          }

          function ue(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;
            return n = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (n = i[n + i[r >> 2] >> 2]), Y[n | 0](r) | 0;
          }

          function $(e, r) {
            return _0(e), (e0(2) & 2147483647) >>> 0 <= 2139095040 ? (_0(r), (e0(2) & 2147483647) >>> 0 > 2139095040 ? e : f(bi(e, r))) : r;
          }

          function Rr(e, r) {
            return _0(e), (e0(2) & 2147483647) >>> 0 <= 2139095040 ? (_0(r), (e0(2) & 2147483647) >>> 0 > 2139095040 ? e : f($i(e, r))) : r;
          }

          function S1(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;
            return n = F - 16 | 0, F = n, i[n + 8 >> 2] = r, e = Y[e | 0](n + 8 | 0) | 0, pe(i[n + 8 >> 2]), F = n + 16 | 0, e | 0;
          }

          function pn(e, r, n) {
            e = e | 0, r = r | 0, n = +n;
            var t = 0;
            t = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (t = i[t + i[r >> 2] >> 2]), Y[t | 0](r, n);
          }

          function Nn(e, r, n, t, u) {
            return n = n | 0, t = t | 0, u = u | 0, n && (n | 0) != 5 ? ri(5672, t, u) | 0 : ri(5528, t, u) | 0;
          }

          function mn(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;
            return n = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (n = i[n + i[r >> 2] >> 2]), +Y[n | 0](r);
          }

          function D1(e, r) {
            if (!e) return 0;

            e: {
              if (!((r & -128) == 57216 | r >>> 0 <= 127)) {
                i[1745] = 25, e = -1;
                break e;
              }

              V[e | 0] = r, e = 1;
            }

            return e;
          }

          function Y1(e, r) {
            var n = 0,
                t = 0;
            n = B(4), i[n >> 2] = r, t = B(4), i[t >> 2] = r, Ce(6891, e | 0, 6954, 4566, 191, n | 0, 6954, 4570, 192, t | 0);
          }

          function ke(e, r) {
            var n = 0,
                t = 0;
            n = B(4), i[n >> 2] = r, t = B(4), i[t >> 2] = r, Ce(6921, e | 0, 6954, 4566, 189, n | 0, 6954, 4570, 190, t | 0);
          }

          function Zr(e, r) {
            var n = 0;

            e: {
              if (V[6900] & 1) {
                n = i[1724];
                break e;
              }

              n = k1(1, 4336) | 0, V[6900] = 1, i[1724] = n;
            }

            n4(n | 0, e | 0, r | 0, 0);
          }

          function yn(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;
            n = i[e + 8 >> 2], i[e + 8 >> 2] = r, n && Y[i[i[n >> 2] + 4 >> 2]](n), i[i[e >> 2] + 20 >> 2] = 15;
          }

          function En(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0;
            var t = 0,
                u = 0;
            t = e, u = l1((V[r + 11 | 0] < 0 ? i[r >> 2] : r) | 0, 6892, i[n >> 2]) | 0, i[t >> 2] = u;
          }

          function Gn(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0;
            var t = 0,
                u = 0;
            t = e, u = l1((V[r + 11 | 0] < 0 ? i[r >> 2] : r) | 0, 6915, i[n >> 2]) | 0, i[t >> 2] = u;
          }

          function z1(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;
            n = i[e >> 2], e = i[e + 4 >> 2], r = (e >> 1) + r | 0, e & 1 && (n = i[n + i[r >> 2] >> 2]), Y[n | 0](r);
          }

          function Rn(e, r) {
            e = e | 0, r = r | 0;
            var n = 0;
            n = i[e + 4 >> 2], i[e + 4 >> 2] = r, n && Y[i[i[n >> 2] + 4 >> 2]](n), C1(i[e >> 2], 14);
          }

          function Zn(e) {
            e = e | 0;
            var r = f(0);
            return e = i[e >> 2], r = c[e + 36 >> 2], r != r && (r = O[i[e + 568 >> 2] + 10 | 0] ? f(1) : f(0)), +r;
          }

          function Wn(e) {
            e = e | 0;
            var r = 0;
            r = i[e + 8 >> 2], i[e + 8 >> 2] = 0, r && Y[i[i[r >> 2] + 4 >> 2]](r), i[i[e >> 2] + 20 >> 2] = 0;
          }

          function gn(e) {
            e = e | 0;
            var r = 0;
            return r = B(12), V[r + 4 | 0] = 0, i[r + 8 >> 2] = i[e >> 2], i[e >> 2] = 0, i[r >> 2] = 4304, r | 0;
          }

          function Vn(e) {
            e = e | 0;
            var r = 0;
            return r = B(12), V[r + 4 | 0] = 0, i[r + 8 >> 2] = i[e >> 2], i[e >> 2] = 0, i[r >> 2] = 4424, r | 0;
          }

          function Tn() {
            var e = 0;
            if (e = i[1732], e) for (; Y[i[e >> 2]](), e = i[e + 4 >> 2], !!e;) {
            }
          }

          function In(e) {
            e = e | 0;
            var r = 0;
            r = i[e + 4 >> 2], i[e + 4 >> 2] = 0, r && Y[i[i[r >> 2] + 4 >> 2]](r), C1(i[e >> 2], 0);
          }

          function Q1(e) {
            return e = e | 0, i[e >> 2] = 4444, O[e + 4 | 0] && Zr(i[e + 8 >> 2], 1758), pe(i[e + 8 >> 2]), e | 0;
          }

          function j1(e) {
            return e = e | 0, i[e >> 2] = 4324, O[e + 4 | 0] && Zr(i[e + 8 >> 2], 1758), pe(i[e + 8 >> 2]), e | 0;
          }

          function Bn() {
            var e = 0;
            return e = B(16), i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, e | 0;
          }

          function x1(e, r, n) {
            return e2(e, r) ? O2(e, r, n) : (n = Ne(e, r, n), n == n && (n = f(-n)), n);
          }

          function J1(e) {
            e = e | 0;
            var r = 0;
            e && (r = i[e >> 2], r && L0(r), i[1716] = i[1716] - 1, L0(e));
          }

          function dn(e, r, n, t, u) {
            return e = e | 0, r = r | 0, n = n | 0, t = t | 0, u = u | 0, Y[e | 0](r, n, t, u) | 0;
          }

          function On() {
            var e = 0;
            return e = B(16), i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, i[e >> 2] = 0, e | 0;
          }

          function _n(e) {
            e = e | 0;
            var r = f(0);
            return r = c[i[e >> 2] + 224 >> 2], +(r != r ? f(NaN) : r);
          }

          function Ln(e) {
            return e = e | 0, e = i[i[e >> 2] + 552 >> 2], e ? i[e >> 2] : 0;
          }

          function Xn(e) {
            e = e | 0;
            var r = f(0);
            return r = c[i[e >> 2] + 32 >> 2], +(r == r ? r : f(0));
          }

          function Fn(e) {
            return e = e | 0, e = i[e >> 2], i[e + 560 >> 2] - i[e + 556 >> 2] >> 2;
          }

          function Cn(e) {
            e = e | 0, e = i[i[e >> 2] + 8 >> 2], Y[i[i[e >> 2] + 8 >> 2]](e);
          }

          function Mn(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0, V[(i[e >> 2] + r | 0) + 20 | 0] = n;
          }

          function Un(e, r, n) {
            e = e | 0, r = r | 0, n = +n, Er(i[e >> 2], r, t2(f(n)));
          }

          function Hn(e, r, n) {
            e = e | 0, r = r | 0, n = +n, Er(i[e >> 2], r, v2(f(n)));
          }

          function Pn(e, r, n, t) {
            return z0 = 0, 0;
          }

          function Sn(e, r, n) {
            e = e | 0, r = r | 0, n = +n, F1(i[e >> 2], r, t2(f(n)));
          }

          function Dn(e, r, n) {
            e = e | 0, r = r | 0, n = +n, F1(i[e >> 2], r, v2(f(n)));
          }

          function Yn(e, r, n) {
            e = e | 0, r = r | 0, n = +n, X1(i[e >> 2], r, t2(f(n)));
          }

          function zn(e, r, n) {
            e = e | 0, r = r | 0, n = +n, X1(i[e >> 2], r, v2(f(n)));
          }

          function Qn(e, r) {
            return e = e | 0, r = r | 0, O[(i[e >> 2] + r | 0) + 20 | 0];
          }

          function jn(e, r, n) {
            e = e | 0, r = r | 0, n = n | 0, i[i[e >> 2] + r >> 2] = n;
          }

          function xn(e, r) {
            e = e | 0, r = r | 0, Er(i[e >> 2], r, 2141891242);
          }

          function Wr(e, r, n) {
            e = e | 0, r = r | 0, n = +n, v0[i[e >> 2] + r >> 3] = n;
          }

          function Jn(e) {
            return e = e | 0, (O[i[e >> 2] + 4 | 0] & 2) >>> 1 | 0;
          }

          function qn(e) {
            return e = e | 0, (O[i[e >> 2] + 4 | 0] & 4) >>> 2 | 0;
          }

          function Kn(e, r) {
            e = e | 0, r = r | 0, i[e + 4 >> 2] = 10, i[e >> 2] = r;
          }

          function $n(e, r) {
            e = e | 0, r = r | 0, i[e + 4 >> 2] = 13, i[e >> 2] = r;
          }

          function bn(e) {
            return e = e | 0, i[i[e >> 2] + 24 >> 2] >>> 10 & 7;
          }

          function et(e) {
            return e = e | 0, i[i[e >> 2] + 24 >> 2] >>> 13 & 7;
          }

          function rt(e) {
            return e = e | 0, i[i[e >> 2] + 24 >> 2] >>> 18 & 3;
          }

          function gr(e, r) {
            return e = e | 0, r = r | 0, +v0[i[e >> 2] + r >> 3];
          }

          function it(e) {
            return e = e | 0, i[i[e >> 2] + 24 >> 2] >>> 20 & 3;
          }

          function nt(e) {
            return e = e | 0, i[i[e >> 2] + 24 >> 2] >>> 22 & 1;
          }

          function tt(e, r) {
            return e = e | 0, r = r | 0, i[i[e >> 2] + r >> 2];
          }

          function ft(e, r) {
            e = e | 0, r = +r, fe(i[e >> 2], 0, t2(f(r)));
          }

          function ut(e, r) {
            e = e | 0, r = +r, fe(i[e >> 2], 0, v2(f(r)));
          }

          function kt(e, r) {
            e = e | 0, r = +r, fe(i[e >> 2], 1, t2(f(r)));
          }

          function ot(e, r) {
            e = e | 0, r = +r, fe(i[e >> 2], 1, v2(f(r)));
          }

          function At(e, r) {
            e = e | 0, r = r | 0, i[e + 4 >> 2] = 7, i[e >> 2] = r;
          }

          function st(e, r) {
            e = e | 0, r = +r, He(i[e >> 2], 0, t2(f(r)));
          }

          function lt(e, r) {
            e = e | 0, r = +r, He(i[e >> 2], 0, v2(f(r)));
          }

          function at(e, r) {
            e = e | 0, r = +r, He(i[e >> 2], 1, t2(f(r)));
          }

          function ct(e, r) {
            e = e | 0, r = +r, Pe(i[e >> 2], 0, t2(f(r)));
          }

          function ht(e, r) {
            e = e | 0, r = +r, Pe(i[e >> 2], 0, v2(f(r)));
          }

          function vt(e, r) {
            e = e | 0, r = +r, Pe(i[e >> 2], 1, t2(f(r)));
          }

          function wt(e, r) {
            e = e | 0, r = +r, Pe(i[e >> 2], 1, v2(f(r)));
          }

          function pt(e) {
            return e = e | 0, i[i[e >> 2] + 24 >> 2] >>> 7 & 7;
          }

          function Nt(e) {
            return e = e | 0, i[i[e >> 2] + 24 >> 2] >>> 2 & 3;
          }

          function mt(e) {
            return e = e | 0, i[i[e >> 2] + 24 >> 2] >>> 4 & 7;
          }

          function De(e) {
            e = e | 0, e && Y[i[i[e >> 2] + 4 >> 2]](e);
          }

          function yt(e, r) {
            e = e | 0, r = +r, He(i[e >> 2], 1, v2(f(r)));
          }

          function q1(e) {
            return e ? (i[1745] = e, -1) : 0;
          }

          function Et(e, r) {
            e = e | 0, r = +r, L1(i[e >> 2], t2(f(r)));
          }

          function Gt(e, r) {
            e = e | 0, r = +r, L1(i[e >> 2], v2(f(r)));
          }

          function K1(e, r, n) {
            return f(b(e, r, n) + k0(e, r, n));
          }

          function Rt(e, r) {
            return e = e | 0, r = r | 0, Y[e | 0](r) | 0;
          }

          function $1(e, r, n, t) {
            f4(e | 0, r | 0, 8, 0, n | 0, -1, t | 0);
          }

          function Zt(e, r) {
            e = e | 0, r = r | 0, V[i[e >> 2] + 11 | 0] = r;
          }

          function Wt(e, r) {
            e = e | 0, r = r | 0, V[i[e >> 2] + 10 | 0] = r;
          }

          function gt(e) {
            return e = e | 0, ee[i[e >> 2] + 26 >> 1] & 3;
          }

          function Vt(e) {
            e = e | 0, fe(i[e >> 2], 0, 2141891242);
          }

          function Tt(e) {
            e = e | 0, fe(i[e >> 2], 1, 2141891242);
          }

          function It(e) {
            return e = e | 0, +c[i[e >> 2] + 228 >> 2];
          }

          function Bt(e) {
            return e = e | 0, +c[i[e >> 2] + 236 >> 2];
          }

          function dt(e) {
            return e = e | 0, +c[i[e >> 2] + 232 >> 2];
          }

          function Ot(e) {
            return e = e | 0, +c[i[e >> 2] + 240 >> 2];
          }

          function _t(e) {
            return e = e | 0, +c[i[e >> 2] + 248 >> 2];
          }

          function Lt(e) {
            return e = e | 0, +c[i[e >> 2] + 244 >> 2];
          }

          function Xt(e) {
            return e = e | 0, A4(i[e + 60 >> 2]) | 0;
          }

          function Ft(e, r) {
            e = e | 0, r = r | 0, yr(i[e >> 2], 5, r);
          }

          function Ct(e, r) {
            e = e | 0, r = r | 0, yr(i[e >> 2], 6, r);
          }

          function Mt(e, r) {
            e = e | 0, r = r | 0, yr(i[e >> 2], 7, r);
          }

          function Ut(e) {
            return e = e | 0, O[i[e >> 2] + 11 | 0];
          }

          function Ht(e) {
            return e = e | 0, O[i[e >> 2] + 10 | 0];
          }

          function b1(e, r) {
            e = e | 0, r = r | 0, Y[i[e >> 2]](r);
          }

          function Pt(e) {
            return e = e | 0, T1(B(12), e) | 0;
          }

          function ei(e, r) {
            e = e | 0, r = r | 0, Y[e | 0](r);
          }

          function St(e) {
            e = e | 0, Zr(i[e + 8 >> 2], 3184);
          }

          function ri(e, r, n) {
            return R1(e, r, n, 2, 3);
          }

          function ii(e) {
            return e = e | 0, Y[e | 0]() | 0;
          }

          function Dt() {
            return j0(B(48), 0, 48) | 0;
          }

          function r2() {
            Y[i[1454]](), Tr(), A0();
          }

          function Yt() {
            return T1(B(12), 0) | 0;
          }

          function Ye(e) {
            return e - 48 >>> 0 < 10;
          }

          function Vr(e) {
            e = e | 0, e && L0(e);
          }

          function zt(e) {
            return 6888;
          }

          function Qt(e) {
            return 6892;
          }

          function jt(e) {
            return 6912;
          }

          function xt(e) {
            return 6915;
          }

          function Jt(e) {
            return 6918;
          }

          function qt(e) {
            return 6923;
          }

          function l2(e) {
            return e = e | 0, e | 0;
          }

          function ni(e) {
            e = e | 0, V[e + 4 | 0] = 1;
          }

          function Kt(e) {
            e = e | 0, L0(Q1(e));
          }

          function $t(e) {
            e = e | 0, L0(j1(e));
          }

          function bt(e) {
            return 0;
          }

          function ti(e) {
            A0();
          }

          function fi() {
            Tr(), A0();
          }

          function Tr() {
            ie(), A0();
          }

          y = O, D();
          var Y = m([null, Nn, c4, w4, l2, At, Kn, $n, l2, l2, l2, l2, l2, l2, kn, Cn, c1, zt, De, H4, Qt, l2, l2, De, ni, b1, S1, gn, Z4, En, jt, De, z1, xt, l2, l2, De, ni, b1, S1, Vn, Gn, Jt, J1, ii, un, ei, J1, Mn, H1, G4, wn, Zt, x2, Wt, Qn, P1, Ut, ue, Ht, Dt, Vr, Bn, Vr, On, Vr, gr, Wr, tt, jn, qt, g1, ii, Yt, Rt, Pt, ei, g1, N4, z1, v4, x2, Q4, x2, Yn, hn, zn, Ft, Ct, Mt, en, j4, $4, Un, Hn, xn, Y4, z4, J4, pn, Et, Gt, q4, K4, ft, ut, Vt, kt, ot, Tt, st, lt, at, yt, ct, ht, vt, wt, x4, P4, Sn, Dn, S4, gt, ue, V4, rn, pt, bn, et, Nt, rt, mt, T4, X4, tn, Xn, mn, Zn, O4, _4, L4, I4, B4, d4, _n, D4, vn, it, nt, g4, U4, cn, p4, H1, m4, x2, Fn, ue, Ln, ue, ln, P1, Jn, ue, b4, x2, Rn, x2, In, yn, x2, Wn, nn, qn, ue, h4, an, It, Bt, dt, Ot, Lt, _t, on, An, F4, C4, M4, gr, Wr, gr, Wr, G1, j1, $t, R4, ti, fi, Q1, Kt, St, ti, Xt, y4, sn, bt, Pn, W4, fi]);

          function ui() {
            return Y0.byteLength / 65536 | 0;
          }

          function ef(e) {
            e = e | 0;
            var r = ui() | 0,
                n = r + e | 0;

            if (r < n && n < 65536) {
              var t = new ArrayBuffer(w0(n, 65536)),
                  u = new Int8Array(t);
              u.set(V), V = new Int8Array(t), W0 = new Int16Array(t), i = new Int32Array(t), O = new Uint8Array(t), ee = new Uint16Array(t), u1 = new Uint32Array(t), c = new Float32Array(t), v0 = new Float64Array(t), Y0 = t, b0.buffer = Y0, y = O;
            }

            return r;
          }

          return {
            E: fn,
            F: E4,
            G: Tn,
            H: vr,
            I: Y,
            J: L0,
            K: dn
          };
        }

        return Fe(w);
      }(s);
    }

    var Wi = Error,
        gi = {};
    o2 = [], typeof gi != "object" && le("no native wasm support detected");
    var P2,
        Xr = !1;

    function Fr(s, a, w) {
      w = a + w;

      for (var m = ""; !(a >= w);) {
        var y = s[a++];
        if (!y) break;

        if (y & 128) {
          var d = s[a++] & 63;
          if ((y & 224) == 192) m += String.fromCharCode((y & 31) << 6 | d);else {
            var X = s[a++] & 63;
            y = (y & 240) == 224 ? (y & 15) << 12 | d << 6 | X : (y & 7) << 18 | d << 12 | X << 6 | s[a++] & 63, 65536 > y ? m += String.fromCharCode(y) : (y -= 65536, m += String.fromCharCode(55296 | y >> 10, 56320 | y & 1023));
          }
        } else m += String.fromCharCode(y);
      }

      return m;
    }

    var je, $0, J2, xe, S2, J0, Cr, Mr;

    function Ur() {
      var s = P2.buffer;
      P.HEAP8 = je = new Int8Array(s), P.HEAP16 = J2 = new Int16Array(s), P.HEAP32 = S2 = new Int32Array(s), P.HEAPU8 = $0 = new Uint8Array(s), P.HEAPU16 = xe = new Uint16Array(s), P.HEAPU32 = J0 = new Uint32Array(s), P.HEAPF32 = Cr = new Float32Array(s), P.HEAPF64 = Mr = new Float64Array(s);
    }

    var Ze = P.INITIAL_MEMORY || 16777216;
    65536 <= Ze || le("INITIAL_MEMORY should be larger than STACK_SIZE, was " + Ze + "! (STACK_SIZE=65536)"), P.wasmMemory ? P2 = P.wasmMemory : P2 = new Gi(), Ur(), Ze = P2.buffer.byteLength;
    var Je,
        Hr = [],
        Pr = [],
        Sr = [];

    function Vi() {
      var s = P.preRun.shift();
      Hr.unshift(s);
    }

    var D2 = 0,
        se = null;

    function le(s) {
      throw P.onAbort && P.onAbort(s), s = "Aborted(" + s + ")", O0(s), Xr = !0, s = new Wi(s + ". Build with -sASSERTIONS for more info."), u0(s), s;
    }

    function Dr(s) {
      return s.startsWith("data:application/octet-stream;base64,");
    }

    var q2;

    if (q2 = "yoga-asm.wasm", !Dr(q2)) {
      var Yr = q2;
      q2 = P.locateFile ? P.locateFile(Yr, S0) : S0 + Yr;
    }

    function Ti(s) {
      var a = q2;

      try {
        try {
          if (a == q2 && o2) new Uint8Array(o2);else {
            if (Dr(a)) {
              try {
                var w = Ji(a.slice(37)),
                    m = new Uint8Array(w.length);

                for (a = 0; a < w.length; ++a) {
                  m[a] = w.charCodeAt(a);
                }

                var y = m;
              } catch (_unused) {
                throw Error("Converting base64 string to bytes failed.");
              }

              var d = y;
            } else d = void 0;

            if (!d) throw "sync fetching of the wasm failed: you can preload it to Module['wasmBinary'] manually, or emcc.py will do that for you when generating HTML (but not JS)";
          }
        } catch (D) {
          le(D);
        }

        var X = new Ri(),
            g = new Zi(s);
      } catch (D) {
        throw s = D.toString(), O0("failed to compile wasm module: " + s), (s.includes("imported Memory") || s.includes("memory import")) && O0("Memory size incompatibility issues may be due to changing INITIAL_MEMORY at runtime to something too large. Use ALLOW_MEMORY_GROWTH to allow any size memory (and also make sure not to set INITIAL_MEMORY at runtime to something smaller than it was at compile time)."), D;
      }

      return [g, X];
    }

    function Ke(s) {
      for (; 0 < s.length;) {
        s.shift()(P);
      }
    }

    function zr(s) {
      if (s === void 0) return "_unknown";
      s = s.replace(/[^a-zA-Z0-9_]/g, "$");
      var a = s.charCodeAt(0);
      return 48 <= a && 57 >= a ? "_" + s : s;
    }

    function $e(s, a) {
      return s = zr(s), function () {
        return a.apply(this, arguments);
      };
    }

    var A2 = [{}, {
      value: void 0
    }, {
      value: null
    }, {
      value: !0
    }, {
      value: !1
    }],
        be = [];

    function We(s) {
      var a = Error,
          w = $e(s, function (m) {
        this.name = s, this.message = m, m = Error(m).stack, m !== void 0 && (this.stack = this.toString() + "\n" + m.replace(/^Error(:[^\n]*)?\n/, ""));
      });
      return w.prototype = Object.create(a.prototype), w.prototype.constructor = w, w.prototype.toString = function () {
        return this.message === void 0 ? this.name : this.name + ": " + this.message;
      }, w;
    }

    var K2 = void 0;

    function r0(s) {
      throw new K2(s);
    }

    var ae = function ae(s) {
      return s || r0("Cannot use deleted val. handle = " + s), A2[s].value;
    },
        ge = function ge(s) {
      switch (s) {
        case void 0:
          return 1;

        case null:
          return 2;

        case !0:
          return 3;

        case !1:
          return 4;

        default:
          var a = be.length ? be.pop() : A2.length;
          return A2[a] = {
            fa: 1,
            value: s
          }, a;
      }
    },
        Qr = void 0,
        jr = void 0;

    function U0(s) {
      for (var a = ""; $0[s];) {
        a += jr[$0[s++]];
      }

      return a;
    }

    var ce = [];

    function er() {
      for (; ce.length;) {
        var s = ce.pop();
        s.L.Z = !1, s.delete();
      }
    }

    var he = void 0,
        y2 = {};

    function rr(s, a) {
      for (a === void 0 && r0("ptr should not be undefined"); s.P;) {
        a = s.aa(a), s = s.P;
      }

      return a;
    }

    var Y2 = {};

    function xr(s) {
      s = Ki(s);
      var a = U0(s);
      return B2(s), a;
    }

    function Jr(s, a) {
      var w = Y2[s];
      return w === void 0 && r0(a + " has unknown type " + xr(s)), w;
    }

    function Ve() {}

    var ir = !1;

    function qr(s) {
      --s.count.value, s.count.value === 0 && (s.S ? s.T.V(s.S) : s.O.M.V(s.N));
    }

    function Kr(s, a, w) {
      return a === w ? s : w.P === void 0 ? null : (s = Kr(s, a, w.P), s === null ? null : w.ma(s));
    }

    var $r = {};

    function Ii(s, a) {
      return a = rr(s, a), y2[a];
    }

    var br = void 0;

    function Te(s) {
      throw new br(s);
    }

    function Ie(s, a) {
      return a.O && a.N || Te("makeClassHandle requires ptr and ptrType"), !!a.T != !!a.S && Te("Both smartPtrType and smartPtr must be specified"), a.count = {
        value: 1
      }, $2(Object.create(s, {
        L: {
          value: a
        }
      }));
    }

    function $2(s) {
      return typeof FinalizationRegistry > "u" ? ($2 = function $2(a) {
        return a;
      }, s) : (ir = new FinalizationRegistry(function (a) {
        qr(a.L);
      }), $2 = function $2(a) {
        var w = a.L;
        return w.S && ir.register(a, {
          L: w
        }, a), a;
      }, Ve = function Ve(a) {
        ir.unregister(a);
      }, $2(s));
    }

    var Be = {};

    function nr(s) {
      for (; s.length;) {
        var a = s.pop();
        s.pop()(a);
      }
    }

    function ve(s) {
      return this.fromWireType(S2[s >> 2]);
    }

    var b2 = {},
        de = {};

    function T2(s, a, w) {
      function m(g) {
        g = w(g), g.length !== s.length && Te("Mismatched type converter count");

        for (var D = 0; D < s.length; ++D) {
          E2(s[D], g[D]);
        }
      }

      s.forEach(function (g) {
        de[g] = a;
      });
      var y = Array(a.length),
          d = [],
          X = 0;
      a.forEach(function (g, D) {
        Y2.hasOwnProperty(g) ? y[D] = Y2[g] : (d.push(g), b2.hasOwnProperty(g) || (b2[g] = []), b2[g].push(function () {
          y[D] = Y2[g], ++X, X === d.length && m(y);
        }));
      }), d.length === 0 && m(y);
    }

    function tr(s) {
      switch (s) {
        case 1:
          return 0;

        case 2:
          return 1;

        case 4:
          return 2;

        case 8:
          return 3;

        default:
          throw new TypeError("Unknown type size: " + s);
      }
    }

    function E2(s, a, w) {
      if (w === void 0) {
        w = {};
      }

      if (!("argPackAdvance" in a)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
      var m = a.name;

      if (s || r0('type "' + m + '" must have a positive integer typeid pointer'), Y2.hasOwnProperty(s)) {
        if (w.ta) return;
        r0("Cannot register type '" + m + "' twice");
      }

      Y2[s] = a, delete de[s], b2.hasOwnProperty(s) && (a = b2[s], delete b2[s], a.forEach(function (y) {
        return y();
      }));
    }

    function fr(s) {
      r0(s.L.O.M.name + " instance already deleted");
    }

    function I2() {}

    function ur(s, a, w) {
      if (s[a].R === void 0) {
        var m = s[a];
        s[a] = function () {
          return s[a].R.hasOwnProperty(arguments.length) || r0("Function '" + w + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + s[a].R + ")!"), s[a].R[arguments.length].apply(this, arguments);
        }, s[a].R = [], s[a].R[m.Y] = m;
      }
    }

    function Bi(s, a) {
      P.hasOwnProperty(s) ? (r0("Cannot register public name '" + s + "' twice"), ur(P, s, s), P.hasOwnProperty(void 0) && r0("Cannot register multiple overloads of a function with the same number of arguments (undefined)!"), P[s].R[void 0] = a) : P[s] = a;
    }

    function di(s, a, w, m, y, d, X, g) {
      this.name = s, this.constructor = a, this.W = w, this.V = m, this.P = y, this.oa = d, this.aa = X, this.ma = g, this.ia = [];
    }

    function kr(s, a, w) {
      for (; a !== w;) {
        a.aa || r0("Expected null or instance of " + w.name + ", got an instance of " + a.name), s = a.aa(s), a = a.P;
      }

      return s;
    }

    function Oi(s, a) {
      return a === null ? (this.da && r0("null is not a valid " + this.name), 0) : (a.L || r0('Cannot pass "' + lr(a) + '" as a ' + this.name), a.L.N || r0("Cannot pass deleted object as a pointer of type " + this.name), kr(a.L.N, a.L.O.M, this.M));
    }

    function _i(s, a) {
      if (a === null) {
        if (this.da && r0("null is not a valid " + this.name), this.ca) {
          var w = this.ea();
          return s !== null && s.push(this.V, w), w;
        }

        return 0;
      }

      if (a.L || r0('Cannot pass "' + lr(a) + '" as a ' + this.name), a.L.N || r0("Cannot pass deleted object as a pointer of type " + this.name), !this.ba && a.L.O.ba && r0("Cannot convert argument of type " + (a.L.T ? a.L.T.name : a.L.O.name) + " to parameter type " + this.name), w = kr(a.L.N, a.L.O.M, this.M), this.ca) switch (a.L.S === void 0 && r0("Passing raw pointer to smart pointer is illegal"), this.Aa) {
        case 0:
          a.L.T === this ? w = a.L.S : r0("Cannot convert argument of type " + (a.L.T ? a.L.T.name : a.L.O.name) + " to parameter type " + this.name);
          break;

        case 1:
          w = a.L.S;
          break;

        case 2:
          if (a.L.T === this) w = a.L.S;else {
            var m = a.clone();
            w = this.wa(w, ge(function () {
              m.delete();
            })), s !== null && s.push(this.V, w);
          }
          break;

        default:
          r0("Unsupporting sharing policy");
      }
      return w;
    }

    function Li(s, a) {
      return a === null ? (this.da && r0("null is not a valid " + this.name), 0) : (a.L || r0('Cannot pass "' + lr(a) + '" as a ' + this.name), a.L.N || r0("Cannot pass deleted object as a pointer of type " + this.name), a.L.O.ba && r0("Cannot convert argument of type " + a.L.O.name + " to parameter type " + this.name), kr(a.L.N, a.L.O.M, this.M));
    }

    function G2(s, a, w, m) {
      this.name = s, this.M = a, this.da = w, this.ba = m, this.ca = !1, this.V = this.wa = this.ea = this.ja = this.Aa = this.va = void 0, a.P !== void 0 ? this.toWireType = _i : (this.toWireType = m ? Oi : Li, this.U = null);
    }

    function Xi(s, a) {
      P.hasOwnProperty(s) || Te("Replacing nonexistant public symbol"), P[s] = a, P[s].Y = void 0;
    }

    function Fi(s, a) {
      var w = [];
      return function () {
        if (w.length = 0, Object.assign(w, arguments), s.includes("j")) {
          var m = P["dynCall_" + s];
          m = w && w.length ? m.apply(null, [a].concat(w)) : m.call(null, a);
        } else m = Je.get(a).apply(null, w);

        return m;
      };
    }

    function s2(s, a) {
      s = U0(s);
      var w = s.includes("j") ? Fi(s, a) : Je.get(a);
      return typeof w != "function" && r0("unknown function pointer with signature " + s + ": " + a), w;
    }

    var e1 = void 0;

    function Oe(s, a) {
      function w(d) {
        y[d] || Y2[d] || (de[d] ? de[d].forEach(w) : (m.push(d), y[d] = !0));
      }

      var m = [],
          y = {};
      throw a.forEach(w), new e1(s + ": " + m.map(xr).join([", "]));
    }

    function or(s, a, w, m, y) {
      var d = a.length;
      2 > d && r0("argTypes array size mismatch! Must at least get return value and 'this' types!");
      var X = a[1] !== null && w !== null,
          g = !1;

      for (w = 1; w < a.length; ++w) {
        if (a[w] !== null && a[w].U === void 0) {
          g = !0;
          break;
        }
      }

      var D = a[0].name !== "void",
          S = d - 2,
          Q = Array(S),
          J = [],
          f0 = [];
      return function () {
        if (arguments.length !== S && r0("function " + s + " called with " + arguments.length + " arguments, expected " + S + " args!"), f0.length = 0, J.length = X ? 2 : 1, J[0] = y, X) {
          var e0 = a[1].toWireType(f0, this);
          J[1] = e0;
        }

        for (var U = 0; U < S; ++U) {
          Q[U] = a[U + 2].toWireType(f0, arguments[U]), J.push(Q[U]);
        }

        if (U = m.apply(null, J), g) nr(f0);else for (var H0 = X ? 1 : 2; H0 < a.length; H0++) {
          var D0 = H0 === 1 ? e0 : Q[H0 - 2];
          a[H0].U !== null && a[H0].U(D0);
        }
        return e0 = D ? a[0].fromWireType(U) : void 0, e0;
      };
    }

    function Ar(s, a) {
      for (var w = [], m = 0; m < s; m++) {
        w.push(J0[a + 4 * m >> 2]);
      }

      return w;
    }

    function sr(s) {
      4 < s && --A2[s].fa === 0 && (A2[s] = void 0, be.push(s));
    }

    function lr(s) {
      if (s === null) return "null";
      var a = typeof s;
      return a === "object" || a === "array" || a === "function" ? s.toString() : "" + s;
    }

    function Ci(s, a) {
      switch (a) {
        case 2:
          return function (w) {
            return this.fromWireType(Cr[w >> 2]);
          };

        case 3:
          return function (w) {
            return this.fromWireType(Mr[w >> 3]);
          };

        default:
          throw new TypeError("Unknown float type: " + s);
      }
    }

    function Mi(s, a, w) {
      switch (a) {
        case 0:
          return w ? function (m) {
            return je[m];
          } : function (m) {
            return $0[m];
          };

        case 1:
          return w ? function (m) {
            return J2[m >> 1];
          } : function (m) {
            return xe[m >> 1];
          };

        case 2:
          return w ? function (m) {
            return S2[m >> 2];
          } : function (m) {
            return J0[m >> 2];
          };

        default:
          throw new TypeError("Unknown integer type: " + s);
      }
    }

    function Ui(s, a) {
      for (var w = "", m = 0; !(m >= a / 2); ++m) {
        var y = J2[s + 2 * m >> 1];
        if (y == 0) break;
        w += String.fromCharCode(y);
      }

      return w;
    }

    function Hi(s, a, w) {
      if (w === void 0 && (w = 2147483647), 2 > w) return 0;
      w -= 2;
      var m = a;
      w = w < 2 * s.length ? w / 2 : s.length;

      for (var y = 0; y < w; ++y) {
        J2[a >> 1] = s.charCodeAt(y), a += 2;
      }

      return J2[a >> 1] = 0, a - m;
    }

    function Pi(s) {
      return 2 * s.length;
    }

    function Si(s, a) {
      for (var w = 0, m = ""; !(w >= a / 4);) {
        var y = S2[s + 4 * w >> 2];
        if (y == 0) break;
        ++w, 65536 <= y ? (y -= 65536, m += String.fromCharCode(55296 | y >> 10, 56320 | y & 1023)) : m += String.fromCharCode(y);
      }

      return m;
    }

    function Di(s, a, w) {
      if (w === void 0 && (w = 2147483647), 4 > w) return 0;
      var m = a;
      w = m + w - 4;

      for (var y = 0; y < s.length; ++y) {
        var d = s.charCodeAt(y);

        if (55296 <= d && 57343 >= d) {
          var X = s.charCodeAt(++y);
          d = 65536 + ((d & 1023) << 10) | X & 1023;
        }

        if (S2[a >> 2] = d, a += 4, a + 4 > w) break;
      }

      return S2[a >> 2] = 0, a - m;
    }

    function Yi(s) {
      for (var a = 0, w = 0; w < s.length; ++w) {
        var m = s.charCodeAt(w);
        55296 <= m && 57343 >= m && ++w, a += 4;
      }

      return a;
    }

    var zi = {};

    function r1(s) {
      var a = zi[s];
      return a === void 0 ? U0(s) : a;
    }

    var _e = [];

    function Qi(s) {
      var a = _e.length;
      return _e.push(s), a;
    }

    function ji(s, a) {
      for (var w = Array(s), m = 0; m < s; ++m) {
        w[m] = Jr(J0[a + 4 * m >> 2], "parameter " + m);
      }

      return w;
    }

    var i1 = [],
        xi = [null, [], []];
    K2 = P.BindingError = We("BindingError"), P.count_emval_handles = function () {
      for (var s = 0, a = 5; a < A2.length; ++a) {
        A2[a] !== void 0 && ++s;
      }

      return s;
    }, P.get_first_emval = function () {
      for (var s = 5; s < A2.length; ++s) {
        if (A2[s] !== void 0) return A2[s];
      }

      return null;
    }, Qr = P.PureVirtualError = We("PureVirtualError");

    for (var n1 = Array(256), Le = 0; 256 > Le; ++Le) {
      n1[Le] = String.fromCharCode(Le);
    }

    jr = n1, P.getInheritedInstanceCount = function () {
      return Object.keys(y2).length;
    }, P.getLiveInheritedInstances = function () {
      var s = [],
          a;

      for (a in y2) {
        y2.hasOwnProperty(a) && s.push(y2[a]);
      }

      return s;
    }, P.flushPendingDeletes = er, P.setDelayFunction = function (s) {
      he = s, ce.length && he && he(er);
    }, br = P.InternalError = We("InternalError"), I2.prototype.isAliasOf = function (s) {
      if (!(this instanceof I2 && s instanceof I2)) return !1;
      var a = this.L.O.M,
          w = this.L.N,
          m = s.L.O.M;

      for (s = s.L.N; a.P;) {
        w = a.aa(w), a = a.P;
      }

      for (; m.P;) {
        s = m.aa(s), m = m.P;
      }

      return a === m && w === s;
    }, I2.prototype.clone = function () {
      if (this.L.N || fr(this), this.L.$) return this.L.count.value += 1, this;
      var s = $2,
          a = Object,
          w = a.create,
          m = Object.getPrototypeOf(this),
          y = this.L;
      return s = s(w.call(a, m, {
        L: {
          value: {
            count: y.count,
            Z: y.Z,
            $: y.$,
            N: y.N,
            O: y.O,
            S: y.S,
            T: y.T
          }
        }
      })), s.L.count.value += 1, s.L.Z = !1, s;
    }, I2.prototype.delete = function () {
      this.L.N || fr(this), this.L.Z && !this.L.$ && r0("Object already scheduled for deletion"), Ve(this), qr(this.L), this.L.$ || (this.L.S = void 0, this.L.N = void 0);
    }, I2.prototype.isDeleted = function () {
      return !this.L.N;
    }, I2.prototype.deleteLater = function () {
      return this.L.N || fr(this), this.L.Z && !this.L.$ && r0("Object already scheduled for deletion"), ce.push(this), ce.length === 1 && he && he(er), this.L.Z = !0, this;
    }, G2.prototype.pa = function (s) {
      return this.ja && (s = this.ja(s)), s;
    }, G2.prototype.ga = function (s) {
      this.V && this.V(s);
    }, G2.prototype.argPackAdvance = 8, G2.prototype.readValueFromPointer = ve, G2.prototype.deleteObject = function (s) {
      s !== null && s.delete();
    }, G2.prototype.fromWireType = function (s) {
      function a() {
        return this.ca ? Ie(this.M.W, {
          O: this.va,
          N: w,
          T: this,
          S: s
        }) : Ie(this.M.W, {
          O: this,
          N: s
        });
      }

      var w = this.pa(s);
      if (!w) return this.ga(s), null;
      var m = Ii(this.M, w);
      if (m !== void 0) return m.L.count.value === 0 ? (m.L.N = w, m.L.S = s, m.clone()) : (m = m.clone(), this.ga(s), m);
      if (m = this.M.oa(w), m = $r[m], !m) return a.call(this);
      m = this.ba ? m.ka : m.pointerType;
      var y = Kr(w, this.M, m.M);
      return y === null ? a.call(this) : this.ca ? Ie(m.M.W, {
        O: m,
        N: y,
        T: this,
        S: s
      }) : Ie(m.M.W, {
        O: m,
        N: y
      });
    }, e1 = P.UnboundTypeError = We("UnboundTypeError");

    var Ji = typeof atob == "function" ? atob : function (s) {
      var a = "",
          w = 0;
      s = s.replace(/[^A-Za-z0-9\+\/=]/g, "");

      do {
        var m = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(s.charAt(w++)),
            y = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(s.charAt(w++)),
            d = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(s.charAt(w++)),
            X = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(s.charAt(w++));
        m = m << 2 | y >> 4, y = (y & 15) << 4 | d >> 2;
        var g = (d & 3) << 6 | X;
        a += String.fromCharCode(m), d !== 64 && (a += String.fromCharCode(y)), X !== 64 && (a += String.fromCharCode(g));
      } while (w < s.length);

      return a;
    },
        qi = {
      q: function q(s, a, w) {
        s = U0(s), a = Jr(a, "wrapper"), w = ae(w);
        var m = [].slice,
            y = a.M,
            d = y.W,
            X = y.P.W,
            g = y.P.constructor;
        s = $e(s, function () {
          y.P.ia.forEach(function (S) {
            if (this[S] === X[S]) throw new Qr("Pure virtual function " + S + " must be implemented in JavaScript");
          }.bind(this)), Object.defineProperty(this, "__parent", {
            value: d
          }), this.__construct.apply(this, m.call(arguments));
        }), d.__construct = function () {
          this === d && r0("Pass correct 'this' to __construct");
          var S = g.implement.apply(void 0, [this].concat(m.call(arguments)));
          Ve(S);
          var Q = S.L;
          S.notifyOnDestruction(), Q.$ = !0, Object.defineProperties(this, {
            L: {
              value: Q
            }
          }), $2(this), S = Q.N, S = rr(y, S), y2.hasOwnProperty(S) ? r0("Tried to register registered instance: " + S) : y2[S] = this;
        }, d.__destruct = function () {
          this === d && r0("Pass correct 'this' to __destruct"), Ve(this);
          var S = this.L.N;
          S = rr(y, S), y2.hasOwnProperty(S) ? delete y2[S] : r0("Tried to unregister unregistered instance: " + S);
        }, s.prototype = Object.create(d);

        for (var D in w) {
          s.prototype[D] = w[D];
        }

        return ge(s);
      },
      k: function k(s) {
        var a = Be[s];
        delete Be[s];
        var w = a.ea,
            m = a.V,
            y = a.ha,
            d = y.map(function (X) {
          return X.sa;
        }).concat(y.map(function (X) {
          return X.ya;
        }));
        T2([s], d, function (X) {
          var g = {};
          return y.forEach(function (D, S) {
            var Q = X[S],
                J = D.qa,
                f0 = D.ra,
                e0 = X[S + y.length],
                U = D.xa,
                H0 = D.za;
            g[D.na] = {
              read: function read(D0) {
                return Q.fromWireType(J(f0, D0));
              },
              write: function write(D0, A0) {
                var _0 = [];
                U(H0, D0, e0.toWireType(_0, A0)), nr(_0);
              }
            };
          }), [{
            name: a.name,
            fromWireType: function fromWireType(D) {
              var S = {},
                  Q;

              for (Q in g) {
                S[Q] = g[Q].read(D);
              }

              return m(D), S;
            },
            toWireType: function toWireType(D, S) {
              for (var Q in g) {
                if (!(Q in S)) throw new TypeError('Missing field:  "' + Q + '"');
              }

              var J = w();

              for (Q in g) {
                g[Q].write(J, S[Q]);
              }

              return D !== null && D.push(m, J), J;
            },
            argPackAdvance: 8,
            readValueFromPointer: ve,
            U: m
          }];
        });
      },
      w: function w() {},
      C: function C(s, a, w, m, y) {
        var d = tr(w);
        a = U0(a), E2(s, {
          name: a,
          fromWireType: function fromWireType(X) {
            return !!X;
          },
          toWireType: function toWireType(X, g) {
            return g ? m : y;
          },
          argPackAdvance: 8,
          readValueFromPointer: function readValueFromPointer(X) {
            if (w === 1) var g = je;else if (w === 2) g = J2;else if (w === 4) g = S2;else throw new TypeError("Unknown boolean type size: " + a);
            return this.fromWireType(g[X >> d]);
          },
          U: null
        });
      },
      f: function f(s, a, w, m, y, d, X, g, D, S, Q, J, f0) {
        Q = U0(Q), d = s2(y, d), g && (g = s2(X, g)), S && (S = s2(D, S)), f0 = s2(J, f0);
        var e0 = zr(Q);
        Bi(e0, function () {
          Oe("Cannot construct " + Q + " due to unbound types", [m]);
        }), T2([s, a, w], m ? [m] : [], function (U) {
          if (U = U[0], m) var H0 = U.M,
              D0 = H0.W;else D0 = I2.prototype;
          U = $e(e0, function () {
            if (Object.getPrototypeOf(this) !== A0) throw new K2("Use 'new' to construct " + Q);
            if (_0.X === void 0) throw new K2(Q + " has no accessible constructor");
            var Fe = _0.X[arguments.length];
            if (Fe === void 0) throw new K2("Tried to invoke ctor of " + Q + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(_0.X).toString() + ") parameters instead!");
            return Fe.apply(this, arguments);
          });
          var A0 = Object.create(D0, {
            constructor: {
              value: U
            }
          });
          U.prototype = A0;

          var _0 = new di(Q, U, A0, f0, H0, d, g, S);

          H0 = new G2(Q, _0, !0, !1), D0 = new G2(Q + "*", _0, !1, !1);
          var j = new G2(Q + " const*", _0, !1, !0);
          return $r[s] = {
            pointerType: D0,
            ka: j
          }, Xi(e0, U), [H0, D0, j];
        });
      },
      d: function d(s, a, w, m, y, _d, X) {
        var g = Ar(w, m);
        a = U0(a), _d = s2(y, _d), T2([], [s], function (D) {
          function S() {
            Oe("Cannot call " + Q + " due to unbound types", g);
          }

          D = D[0];
          var Q = D.name + "." + a;
          a.startsWith("@@") && (a = Symbol[a.substring(2)]);
          var J = D.M.constructor;
          return J[a] === void 0 ? (S.Y = w - 1, J[a] = S) : (ur(J, a, Q), J[a].R[w - 1] = S), T2([], g, function (f0) {
            return f0 = or(Q, [f0[0], null].concat(f0.slice(1)), null, _d, X), J[a].R === void 0 ? (f0.Y = w - 1, J[a] = f0) : J[a].R[w - 1] = f0, [];
          }), [];
        });
      },
      p: function p(s, a, w, m, y, d) {
        0 < a || le();
        var X = Ar(a, w);
        y = s2(m, y), T2([], [s], function (g) {
          g = g[0];
          var D = "constructor " + g.name;
          if (g.M.X === void 0 && (g.M.X = []), g.M.X[a - 1] !== void 0) throw new K2("Cannot register multiple constructors with identical number of parameters (" + (a - 1) + ") for class '" + g.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
          return g.M.X[a - 1] = function () {
            Oe("Cannot construct " + g.name + " due to unbound types", X);
          }, T2([], X, function (S) {
            return S.splice(1, 0, null), g.M.X[a - 1] = or(D, S, null, y, d), [];
          }), [];
        });
      },
      b: function b(s, a, w, m, y, d, X, g) {
        var D = Ar(w, m);
        a = U0(a), d = s2(y, d), T2([], [s], function (S) {
          function Q() {
            Oe("Cannot call " + J + " due to unbound types", D);
          }

          S = S[0];
          var J = S.name + "." + a;
          a.startsWith("@@") && (a = Symbol[a.substring(2)]), g && S.M.ia.push(a);
          var f0 = S.M.W,
              e0 = f0[a];
          return e0 === void 0 || e0.R === void 0 && e0.className !== S.name && e0.Y === w - 2 ? (Q.Y = w - 2, Q.className = S.name, f0[a] = Q) : (ur(f0, a, J), f0[a].R[w - 2] = Q), T2([], D, function (U) {
            return U = or(J, U, S, d, X), f0[a].R === void 0 ? (U.Y = w - 2, f0[a] = U) : f0[a].R[w - 2] = U, [];
          }), [];
        });
      },
      B: function B(s, a) {
        a = U0(a), E2(s, {
          name: a,
          fromWireType: function fromWireType(w) {
            var m = ae(w);
            return sr(w), m;
          },
          toWireType: function toWireType(w, m) {
            return ge(m);
          },
          argPackAdvance: 8,
          readValueFromPointer: ve,
          U: null
        });
      },
      n: function n(s, a, w) {
        w = tr(w), a = U0(a), E2(s, {
          name: a,
          fromWireType: function fromWireType(m) {
            return m;
          },
          toWireType: function toWireType(m, y) {
            return y;
          },
          argPackAdvance: 8,
          readValueFromPointer: Ci(a, w),
          U: null
        });
      },
      e: function e(s, a, w, m, y) {
        a = U0(a), y === -1 && (y = 4294967295), y = tr(w);

        var d = function d(g) {
          return g;
        };

        if (m === 0) {
          var X = 32 - 8 * w;

          d = function d(g) {
            return g << X >>> X;
          };
        }

        w = a.includes("unsigned") ? function (g, D) {
          return D >>> 0;
        } : function (g, D) {
          return D;
        }, E2(s, {
          name: a,
          fromWireType: d,
          toWireType: w,
          argPackAdvance: 8,
          readValueFromPointer: Mi(a, y, m !== 0),
          U: null
        });
      },
      c: function c(s, a, w) {
        function m(d) {
          d >>= 2;
          var X = J0;
          return new y(X.buffer, X[d + 1], X[d]);
        }

        var y = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array][a];
        w = U0(w), E2(s, {
          name: w,
          fromWireType: m,
          argPackAdvance: 8,
          readValueFromPointer: m
        }, {
          ta: !0
        });
      },
      o: function o(s, a) {
        a = U0(a);
        var w = a === "std::string";
        E2(s, {
          name: a,
          fromWireType: function fromWireType(m) {
            var y = J0[m >> 2],
                d = m + 4;
            if (w) for (var X = d, g = 0; g <= y; ++g) {
              var D = d + g;

              if (g == y || $0[D] == 0) {
                if (X = X ? Fr($0, X, D - X) : "", S === void 0) var S = X;else S += String.fromCharCode(0), S += X;
                X = D + 1;
              }
            } else {
              for (S = Array(y), g = 0; g < y; ++g) {
                S[g] = String.fromCharCode($0[d + g]);
              }

              S = S.join("");
            }
            return B2(m), S;
          },
          toWireType: function toWireType(m, y) {
            y instanceof ArrayBuffer && (y = new Uint8Array(y));
            var d,
                X = typeof y == "string";

            if (X || y instanceof Uint8Array || y instanceof Uint8ClampedArray || y instanceof Int8Array || r0("Cannot pass non-string to std::string"), w && X) {
              var g = 0;

              for (d = 0; d < y.length; ++d) {
                var D = y.charCodeAt(d);
                127 >= D ? g++ : 2047 >= D ? g += 2 : 55296 <= D && 57343 >= D ? (g += 4, ++d) : g += 3;
              }

              d = g;
            } else d = y.length;

            if (g = t1(4 + d + 1), D = g + 4, J0[g >> 2] = d, w && X) {
              if (X = D, D = d + 1, d = $0, 0 < D) {
                D = X + D - 1;

                for (var S = 0; S < y.length; ++S) {
                  var Q = y.charCodeAt(S);

                  if (55296 <= Q && 57343 >= Q) {
                    var J = y.charCodeAt(++S);
                    Q = 65536 + ((Q & 1023) << 10) | J & 1023;
                  }

                  if (127 >= Q) {
                    if (X >= D) break;
                    d[X++] = Q;
                  } else {
                    if (2047 >= Q) {
                      if (X + 1 >= D) break;
                      d[X++] = 192 | Q >> 6;
                    } else {
                      if (65535 >= Q) {
                        if (X + 2 >= D) break;
                        d[X++] = 224 | Q >> 12;
                      } else {
                        if (X + 3 >= D) break;
                        d[X++] = 240 | Q >> 18, d[X++] = 128 | Q >> 12 & 63;
                      }

                      d[X++] = 128 | Q >> 6 & 63;
                    }

                    d[X++] = 128 | Q & 63;
                  }
                }

                d[X] = 0;
              }
            } else if (X) for (X = 0; X < d; ++X) {
              S = y.charCodeAt(X), 255 < S && (B2(D), r0("String has UTF-16 code units that do not fit in 8 bits")), $0[D + X] = S;
            } else for (X = 0; X < d; ++X) {
              $0[D + X] = y[X];
            }

            return m !== null && m.push(B2, g), g;
          },
          argPackAdvance: 8,
          readValueFromPointer: ve,
          U: function U(m) {
            B2(m);
          }
        });
      },
      j: function j(s, a, w) {
        if (w = U0(w), a === 2) var m = Ui,
            y = Hi,
            d = Pi,
            X = function X() {
          return xe;
        },
            g = 1;else a === 4 && (m = Si, y = Di, d = Yi, X = function X() {
          return J0;
        }, g = 2);
        E2(s, {
          name: w,
          fromWireType: function fromWireType(D) {
            for (var S = J0[D >> 2], Q = X(), J, f0 = D + 4, e0 = 0; e0 <= S; ++e0) {
              var U = D + 4 + e0 * a;
              (e0 == S || Q[U >> g] == 0) && (f0 = m(f0, U - f0), J === void 0 ? J = f0 : (J += String.fromCharCode(0), J += f0), f0 = U + a);
            }

            return B2(D), J;
          },
          toWireType: function toWireType(D, S) {
            typeof S != "string" && r0("Cannot pass non-string to C++ string type " + w);
            var Q = d(S),
                J = t1(4 + Q + a);
            return J0[J >> 2] = Q >> g, y(S, J + 4, Q + a), D !== null && D.push(B2, J), J;
          },
          argPackAdvance: 8,
          readValueFromPointer: ve,
          U: function U(D) {
            B2(D);
          }
        });
      },
      l: function l(s, a, w, m, y, d) {
        Be[s] = {
          name: U0(a),
          ea: s2(w, m),
          V: s2(y, d),
          ha: []
        };
      },
      i: function i(s, a, w, m, y, d, X, g, D, S) {
        Be[s].ha.push({
          na: U0(a),
          sa: w,
          qa: s2(m, y),
          ra: d,
          ya: X,
          xa: s2(g, D),
          za: S
        });
      },
      D: function D(s, a) {
        a = U0(a), E2(s, {
          ua: !0,
          name: a,
          argPackAdvance: 0,
          fromWireType: function fromWireType() {},
          toWireType: function toWireType() {}
        });
      },
      t: function t(s, a, w, m, y) {
        s = _e[s], a = ae(a), w = r1(w);
        var d = [];
        return J0[m >> 2] = ge(d), s(a, w, d, y);
      },
      u: function u(s, a, w, m) {
        s = _e[s], a = ae(a), w = r1(w), s(a, w, null, m);
      },
      h: sr,
      m: function m(s, a) {
        var w = ji(s, a),
            m = w[0];
        a = m.name + "_$" + w.slice(1).map(function (X) {
          return X.name;
        }).join("_") + "$";
        var y = i1[a];
        if (y !== void 0) return y;
        var d = Array(s - 1);
        return y = Qi(function (X, g, D, S) {
          for (var Q = 0, J = 0; J < s - 1; ++J) {
            d[J] = w[J + 1].readValueFromPointer(S + Q), Q += w[J + 1].argPackAdvance;
          }

          for (X = X[g].apply(X, d), J = 0; J < s - 1; ++J) {
            w[J + 1].la && w[J + 1].la(d[J]);
          }

          if (!m.ua) return m.toWireType(D, X);
        }), i1[a] = y;
      },
      r: function r(s) {
        4 < s && (A2[s].fa += 1);
      },
      s: function s(_s) {
        var a = ae(_s);
        nr(a), sr(_s);
      },
      g: function g() {
        le("");
      },
      y: function y(s, a, w) {
        $0.copyWithin(s, a, a + w);
      },
      x: function x(s) {
        var a = $0.length;
        if (s >>>= 0, 2147483648 < s) return !1;

        for (var w = 1; 4 >= w; w *= 2) {
          var m = a * (1 + .2 / w);
          m = Math.min(m, s + 100663296);
          var y = Math,
              d = y.min;
          m = Math.max(s, m), m += (65536 - m % 65536) % 65536;

          e: {
            var X = P2.buffer;

            try {
              P2.grow(d.call(y, 2147483648, m) - X.byteLength + 65535 >>> 16), Ur();
              var g = 1;
              break e;
            } catch (_unused2) {}

            g = void 0;
          }

          if (g) return !0;
        }

        return !1;
      },
      A: function A() {
        return 52;
      },
      v: function v() {
        return 70;
      },
      z: function z(s, a, w, m) {
        for (var y = 0, d = 0; d < w; d++) {
          var X = J0[a >> 2],
              g = J0[a + 4 >> 2];
          a += 8;

          for (var D = 0; D < g; D++) {
            var S = $0[X + D],
                Q = xi[s];
            S === 0 || S === 10 ? ((s === 1 ? k2 : O0)(Fr(Q, 0)), Q.length = 0) : Q.push(S);
          }

          y += g;
        }

        return J0[m >> 2] = y, 0;
      },
      a: P2
    },
        we = function () {
      function s(w) {
        P.asm = w.exports, Je = P.asm.I, Pr.unshift(P.asm.E), D2--, P.monitorRunDependencies && P.monitorRunDependencies(D2), D2 == 0 && (se && (w = se, se = null, w()));
      }

      var a = {
        a: qi
      };
      if (D2++, P.monitorRunDependencies && P.monitorRunDependencies(D2), P.instantiateWasm) try {
        return P.instantiateWasm(a, s);
      } catch (w) {
        O0("Module.instantiateWasm callback failed with error: " + w), u0(w);
      }
      return a = Ti(a), s(a[0]), P.asm;
    }(),
        Ki = P.___getTypeName = we.F;

    P.__embind_initialize_bindings = we.G;
    var t1 = we.H,
        B2 = we.J;
    P.dynCall_jiji = we.K;
    var Xe;

    se = function s() {
      Xe || f1(), Xe || (se = s);
    };

    function f1() {
      function s() {
        if (!Xe && (Xe = !0, P.calledRun = !0, !Xr)) {
          if (Ke(Pr), U2(P), P.onRuntimeInitialized && P.onRuntimeInitialized(), P.postRun) for (typeof P.postRun == "function" && (P.postRun = [P.postRun]); P.postRun.length;) {
            var a = P.postRun.shift();
            Sr.unshift(a);
          }
          Ke(Sr);
        }
      }

      if (!(0 < D2)) {
        if (P.preRun) for (typeof P.preRun == "function" && (P.preRun = [P.preRun]); P.preRun.length;) {
          Vi();
        }
        Ke(Hr), 0 < D2 || (P.setStatus ? (P.setStatus("Running..."), setTimeout(function () {
          setTimeout(function () {
            P.setStatus("");
          }, 1), s();
        }, 1)) : s());
      }
    }

    if (P.preInit) for (typeof P.preInit == "function" && (P.preInit = [P.preInit]); 0 < P.preInit.length;) {
      P.preInit.pop()();
    }
    return f1(), c0;
  };
}(),
    yi = Af;

function mf() {
  return (0, Ei.default)(yi());
}

// eslint-disable-next-line import/no-unresolved
var index = mf();

export { index as default };
